/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AddChatMemberInput = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type AddGroupMemberInput = {
  groupId: Scalars['String']['input'];
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type AddMemberResult = {
  __typename?: 'AddMemberResult';
  action: Scalars['String']['output'];
  invitationId?: Maybe<Scalars['String']['output']>;
  membershipId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddTagMemberInput = {
  userId: Scalars['String']['input'];
};

export type AddTeamMemberInput = {
  roles: Array<ConversationMemberRole>;
  userId: Scalars['String']['input'];
};

export type AdvancedSearchInput = {
  /** Advanced filters */
  filters?: InputMaybe<SearchFilterInput>;
  /** Search options */
  options?: InputMaybe<SearchOptionsInput>;
  /** Search query string */
  queryString: Scalars['String']['input'];
  /** Search scenario name */
  scenario?: InputMaybe<Scalars['String']['input']>;
};

export type Agent = {
  __typename?: 'Agent';
  /** Count of related entities */
  _count?: Maybe<AgentCount>;
  agentFolders?: Maybe<Array<AgentFolder>>;
  /** Agent type determines behavior pipeline */
  agentType: AgentType;
  /** Agent audience lane */
  audience: AgentAudience;
  /** Token count of cached documents (o200k_base) */
  cachedDocTokenCount?: Maybe<Scalars['Int']['output']>;
  /** Pre-formatted XML document text for Direct QA */
  cachedDocumentsText?: Maybe<Scalars['String']['output']>;
  chatRooms?: Maybe<Array<ChatRoom>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Data freshness status */
  dataStatus: AgentDataStatus;
  /** When data status was last evaluated */
  dataStatusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reason for current data status */
  dataStatusReason?: Maybe<Scalars['String']['output']>;
  /** Soft-delete timestamp. NULL = active agent. Set instead of hard-deleting to preserve ChatRoom FK integrity. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the document cache was last built */
  documentsCachedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Folder ID for form templates (Biểu mẫu) */
  formFolderPath?: Maybe<Scalars['String']['output']>;
  /** Whether this agent is hidden from client-facing agent selection */
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether this agent is active and can be used */
  isActive: Scalars['Boolean']['output'];
  /**
   * Deprecated: All agents are KG agents. This field always returns true.
   * @deprecated All agents now use Knowledge Graph RAG. Standard RAG has been removed.
   */
  isKgAgent: Scalars['Boolean']['output'];
  /** Whether this agent is a multiagent workflow */
  isMultiagent: Scalars['Boolean']['output'];
  knowledgeGraph?: Maybe<KnowledgeGraph>;
  knowledgeGraphId?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  languageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: AgentStatus;
  tools?: Maybe<Array<AgentTool>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Workflow for multiagent execution */
  workflow?: Maybe<Workflow>;
  /** Optional workflow ID for multiagent execution */
  workflowId?: Maybe<Scalars['String']['output']>;
};

/** Agent audience lane */
export enum AgentAudience {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type AgentCount = {
  __typename?: 'AgentCount';
  /** Number of agent folders linked to this agent */
  agentFolders: Scalars['Int']['output'];
  /** Number of chat rooms using this agent */
  chatRooms: Scalars['Int']['output'];
  /** Number of tools linked to this agent */
  tools: Scalars['Int']['output'];
};

/** Agent data freshness status */
export enum AgentDataStatus {
  /** KG rebuild or cache rebuild in progress */
  Building = 'BUILDING',
  /** Data matches last build */
  Current = 'CURRENT',
  /** Source changed since last build; agent still serves old data */
  Stale = 'STALE',
  /** Initial state, not yet evaluated */
  Unknown = 'UNKNOWN'
}

export type AgentFolder = {
  __typename?: 'AgentFolder';
  agent?: Maybe<Agent>;
  agentId: Scalars['String']['output'];
  folder?: Maybe<Folder>;
  folderId: Scalars['String']['output'];
};

export type AgentInfo = {
  __typename?: 'AgentInfo';
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AgentQueryDto = {
  agentType?: InputMaybe<AgentType>;
  audience?: InputMaybe<AgentAudience>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AgentStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AgentRecreationConfig = {
  __typename?: 'AgentRecreationConfig';
  folderIds: Array<Scalars['String']['output']>;
  languageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tools?: Maybe<Scalars['JSONObject']['output']>;
};

export type AgentRecreationResult = {
  __typename?: 'AgentRecreationResult';
  config: AgentRecreationConfig;
  userId: Scalars['String']['output'];
};

/** Agent status */
export enum AgentStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AgentSyncConfig = {
  __typename?: 'AgentSyncConfig';
  agent?: Maybe<Agent>;
  agentId: Scalars['String']['output'];
  autoUpdate: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  folderId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  syncUrls: Array<Scalars['String']['output']>;
  targetFolder?: Maybe<Folder>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AgentTool = {
  __typename?: 'AgentTool';
  agent?: Maybe<Agent>;
  agentId: Scalars['String']['output'];
  config?: Maybe<Scalars['JSONObject']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  tool?: Maybe<Tool>;
  toolId: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Agent type determines the behavior pipeline */
export enum AgentType {
  /** Direct Q&A agent using only LLM with system prompt (no KG) */
  DirectQa = 'DIRECT_QA',
  /** Finbot agent with market info tools calling fintech backend APIs */
  Finbot = 'FINBOT',
  /** Knowledge Graph RAG agent using vector search and graph traversal */
  KgRag = 'KG_RAG'
}

/** API Key for OpenAI-compatible API access */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** Optional: restrict to specific agent */
  agentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Optional daily request limit */
  dailyLimit?: Maybe<Scalars['Int']['output']>;
  /** Optional expiration date */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** First characters of the key for identification (e.g., sk-verba-...) */
  keyPrefix: Scalars['String']['output'];
  /** Last usage timestamp */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User-friendly name for the key */
  name: Scalars['String']['output'];
  /** Requests per minute limit */
  rateLimit: Scalars['Int']['output'];
  /** Multi-tenant realm (e.g., citeka, ueh) */
  realm: Scalars['String']['output'];
  /** Allowed operations (e.g., chat:completions) */
  scopes: Array<Scalars['String']['output']>;
  /** Current status */
  status: ApiKeyStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** Total requests made */
  usageCount: Scalars['Int']['output'];
  /** Owner user ID */
  userId: Scalars['String']['output'];
};

/** Filter for listing API keys */
export type ApiKeyFilterInput = {
  /** Filter by agent ID */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Include expired keys (default: false) */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include revoked keys (default: false) */
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Generic mutation response for API key operations */
export type ApiKeyMutationResponse = {
  __typename?: 'ApiKeyMutationResponse';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Status of an API key */
export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type Artifact = {
  __typename?: 'Artifact';
  chainId?: Maybe<Scalars['String']['output']>;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  formId?: Maybe<Scalars['String']['output']>;
  formName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  slotValues?: Maybe<Scalars['JSONObject']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignCustomerLabelInput = {
  labelId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignTagInput = {
  /** User ID who is adding the tag */
  addedBy: Scalars['String']['input'];
  /** Conversation ID */
  conversationId: Scalars['String']['input'];
  /** Tag ID */
  tagId: Scalars['String']['input'];
};

export type AssignedChannelData = {
  __typename?: 'AssignedChannelData';
  assignedAt?: Maybe<Scalars['String']['output']>;
  canModify: Scalars['Boolean']['output'];
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

export type AttendeeEmailAddress = {
  __typename?: 'AttendeeEmailAddress';
  /** SMTP address of the attendee */
  address: Scalars['String']['output'];
  /** Display name of the attendee */
  name?: Maybe<Scalars['String']['output']>;
};

export type AttendeeEmailAddressInput = {
  /** SMTP address of the attendee */
  address: Scalars['String']['input'];
  /** Display name of the attendee */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AttendeeInput = {
  /** Email address information of the attendee */
  emailAddress: AttendeeEmailAddressInput;
  /** Alternate date/time proposed by the attendee for a meeting request */
  proposedNewTime?: InputMaybe<ProposedNewTimeInput>;
  /** Type of attendee */
  type?: AttendeeType;
};

export type AttendeeStatus = {
  __typename?: 'AttendeeStatus';
  /** Response status of the attendee */
  response: ResponseStatus;
  /** Time when the response was sent */
  time?: Maybe<Scalars['DateTime']['output']>;
};

/** Type of event attendee */
export enum AttendeeType {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
  Resource = 'RESOURCE'
}

export type AuthResponse = {
  __typename?: 'AuthResponse';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  refresh_token: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token_type: Scalars['String']['output'];
};

export type AuthResponseWithUser = {
  __typename?: 'AuthResponseWithUser';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  refresh_token: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token_type: Scalars['String']['output'];
  user: UserInfo;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int']['output'];
};

/** Content type for event body */
export enum BodyContentType {
  Html = 'HTML',
  Text = 'TEXT'
}

export type BulkAddTagMembersInput = {
  userIds: Array<Scalars['String']['input']>;
};

export type BulkOperationError = {
  __typename?: 'BulkOperationError';
  customerId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type BulkOperationResult = {
  __typename?: 'BulkOperationResult';
  errors: Array<BulkOperationError>;
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type BulkRemoveTagMembersInput = {
  membershipIds: Array<Scalars['String']['input']>;
};

export type BulkTagOperationInput = {
  /** User ID performing the operation */
  addedBy: Scalars['String']['input'];
  /** List of conversation IDs */
  conversationIds: Array<Scalars['String']['input']>;
  /** List of tag IDs to assign */
  tagIds: Array<Scalars['String']['input']>;
};

export type BulkTagOperationResult = {
  __typename?: 'BulkTagOperationResult';
  /** Number of tag assignments created */
  assignmentCount: Scalars['Int']['output'];
  /** List of conversation IDs that failed processing */
  failedConversationIds: Array<Scalars['String']['output']>;
  /** Operation result message */
  message: Scalars['String']['output'];
  /** Number of conversations processed */
  processedCount: Scalars['Int']['output'];
  /** Operation success status */
  success: Scalars['Boolean']['output'];
};

export type CalendarPermission = {
  __typename?: 'CalendarPermission';
  /** List of allowed roles this user can be assigned to */
  allowedRoles: Array<CalendarRoleType>;
  /** ID of the calendar this permission applies to */
  calendarId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** User who discovered this permission */
  discoveredBy: Scalars['String']['output'];
  /** Email address of the user with permission */
  emailAddress: Scalars['String']['output'];
  /** Display name of the user with permission */
  emailName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the user is inside the organization */
  isInsideOrganization: Scalars['Boolean']['output'];
  /** Whether this permission can be removed */
  isRemovable: Scalars['Boolean']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  /** Current role assigned to the user for this calendar */
  role: CalendarRoleType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Calendar permission role types */
export enum CalendarRoleType {
  /** Custom role with specific permissions */
  Custom = 'CUSTOM',
  /** Can act as delegate without access to private events */
  DelegateWithoutPrivateEventAccess = 'DELEGATE_WITHOUT_PRIVATE_EVENT_ACCESS',
  /** Can act as delegate with access to private events */
  DelegateWithPrivateEventAccess = 'DELEGATE_WITH_PRIVATE_EVENT_ACCESS',
  /** Can read free/busy information */
  FreeBusyRead = 'FREE_BUSY_READ',
  /** Can read limited calendar information */
  LimitedRead = 'LIMITED_READ',
  /** No access to the calendar */
  None = 'NONE',
  /** Can read all calendar information */
  Read = 'READ',
  /** Can read and write calendar information */
  Write = 'WRITE'
}

/** Internal calendar type classification */
export enum CalendarType {
  /** Group shared calendar */
  Group = 'GROUP',
  /** Resource calendar (meeting room, equipment, etc.) */
  Resource = 'RESOURCE',
  /** User personal calendar */
  User = 'USER'
}

export type CategoryStats = {
  __typename?: 'CategoryStats';
  /** Category */
  category: TagCategory;
  /** Number of conversations using tags in this category */
  conversationCount: Scalars['Int']['output'];
  /** Number of tags in this category */
  tagCount: Scalars['Int']['output'];
};

export type Channel = {
  __typename?: 'Channel';
  /** Array of assigned agent IDs */
  assignedAgentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Agent assignments for this channel */
  channelAgents?: Maybe<Array<ChannelAgent>>;
  /** Package assignments for this channel */
  channelPackages?: Maybe<Array<ChannelPackage>>;
  /** Platform app connections for this channel */
  channelPlatformApps?: Maybe<Array<ChannelPlatformApp>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Soft delete timestamp */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Channel avatar/image URL */
  image?: Maybe<Scalars['String']['output']>;
  /** Soft delete flag */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether this channel has unlimited messaging for all users */
  isUnlimitedMessaging: Scalars['Boolean']['output'];
  /** Platform-specific metadata (Teams: teamId, channelId, etc.) */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Channel/page display name */
  name: Scalars['String']['output'];
  /** Array of offered package IDs */
  offeredPackageIds?: Maybe<Array<Scalars['String']['output']>>;
  /** External platform page/channel ID */
  pageId: Scalars['String']['output'];
  /** Platform this channel belongs to */
  platform?: Maybe<Platform>;
  /** Platform ID */
  platformId: Scalars['String']['output'];
  /** Channel status (active, inactive, suspended) */
  status: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who owns this channel */
  user?: Maybe<User>;
  /** User ID who owns this channel */
  userId: Scalars['String']['output'];
  /** Platform-specific webhook URL */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ChannelAgent = {
  __typename?: 'ChannelAgent';
  /** Agent assigned to the channel */
  agent?: Maybe<Agent>;
  /** Agent ID */
  agentId: Scalars['String']['output'];
  /** Channel this assignment belongs to */
  channel?: Maybe<Channel>;
  /** Channel ID */
  channelId: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether this assignment is active */
  isActive: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ChannelAgentData = {
  __typename?: 'ChannelAgentData';
  id: Scalars['ID']['output'];
  languageId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Workflow ID for loading prompts at runtime */
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type ChannelData = {
  __typename?: 'ChannelData';
  assignedInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAssignable: Scalars['Boolean']['output'];
  membershipType: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
};

export type ChannelDetailInfo = {
  __typename?: 'ChannelDetailInfo';
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  platformInfo: PlatformInfo;
};

export type ChannelFilter = {
  /** Filter by display name (contains search) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by favorite status */
  isFavoriteByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by membership type */
  membershipType?: InputMaybe<ChannelMembershipType>;
  /** Number of results to skip */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ChannelIdentity = {
  __typename?: 'ChannelIdentity';
  /** Channel display name */
  channelDisplayName?: Maybe<Scalars['String']['output']>;
  /** Microsoft Channel ID */
  channelId?: Maybe<Scalars['String']['output']>;
  /** Microsoft Team ID */
  teamId?: Maybe<Scalars['String']['output']>;
};

export type ChannelInfo = {
  __typename?: 'ChannelInfo';
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platform: PlatformCode;
};

/** The type of the channel */
export enum ChannelMembershipType {
  Private = 'PRIVATE',
  Shared = 'SHARED',
  Standard = 'STANDARD'
}

export type ChannelMessageFilter = {
  /** Filter messages after this date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter messages by sender display name */
  fromDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of results */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by message type */
  messageType?: InputMaybe<MessageType>;
  /** Number of results to skip for pagination */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Only show reply messages */
  repliesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show root messages (not replies) */
  rootMessagesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in message content */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages before this date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ChannelMessageOperationResult = {
  __typename?: 'ChannelMessageOperationResult';
  /** Additional operation data */
  data?: Maybe<Scalars['String']['output']>;
  /** Operation result message */
  message: Scalars['String']['output'];
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type ChannelPackage = {
  __typename?: 'ChannelPackage';
  /** Channel this assignment belongs to */
  channel?: Maybe<Channel>;
  /** Channel ID */
  channelId: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether this assignment is active */
  isActive: Scalars['Boolean']['output'];
  /** Package assigned to the channel */
  package?: Maybe<Package>;
  /** Package ID */
  packageId: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ChannelPlatformApp = {
  __typename?: 'ChannelPlatformApp';
  /** Platform-specific access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Channel this connection belongs to */
  channel?: Maybe<Channel>;
  /** Channel ID */
  channelId: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether this connection is active (only one active per channel) */
  isActive: Scalars['Boolean']['output'];
  /** Platform app connected to the channel */
  platformApp?: Maybe<PlatformApp>;
  /** Platform App ID */
  platformAppId: Scalars['String']['output'];
  /** Refresh token for platforms requiring refresh */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Token expiration timestamp */
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ChannelResponse = {
  __typename?: 'ChannelResponse';
  channel: Channel;
  message: Scalars['String']['output'];
};

export type ChannelSummary = {
  __typename?: 'ChannelSummary';
  /** Total number of guests in channel */
  guestsCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates if there are channel members from other tenants */
  hasMembersFromOtherTenants?: Maybe<Scalars['Boolean']['output']>;
  /** Total number of members in channel */
  membersCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of owners in channel */
  ownersCount?: Maybe<Scalars['Int']['output']>;
};

export type ChannelTokensData = {
  __typename?: 'ChannelTokensData';
  accessToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isUnlimitedMessaging: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  platformAppConfig?: Maybe<Scalars['String']['output']>;
  platformAppId?: Maybe<Scalars['String']['output']>;
  platformId: Scalars['ID']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type ChannelUserQuota = {
  __typename?: 'ChannelUserQuota';
  channelId: Scalars['ID']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  remainingMessages: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type ChannelsQueryDto = {
  /** Filter by creation date from (ISO string) */
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by creation date to (ISO string) */
  createdTo?: InputMaybe<Scalars['String']['input']>;
  /** Include channel agents */
  includeAgents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include deleted channels */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include channel packages */
  includePackages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include platform details */
  includePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include channel platform apps */
  includePlatformApps?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include user details */
  includeUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Items per page */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by platform code (facebook, zalo, teams, website) */
  platformCode?: InputMaybe<Scalars['String']['input']>;
  /** Filter by platform ID */
  platformId?: InputMaybe<Scalars['String']['input']>;
  /** Search in channel name or pageId */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort field */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort order */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last update date from (ISO string) */
  updatedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last update date to (ISO string) */
  updatedTo?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelsResponse = {
  __typename?: 'ChannelsResponse';
  data: Array<Channel>;
  meta: PaginationMeta;
};

export type ChannelsStatsResponse = {
  __typename?: 'ChannelsStatsResponse';
  /** Active channels count */
  active: Scalars['Int']['output'];
  /** Deleted channels count */
  deleted: Scalars['Int']['output'];
  /** Facebook channels count */
  facebook: Scalars['Int']['output'];
  /** Teams channels count */
  teams: Scalars['Int']['output'];
  /** Total channels count */
  total: Scalars['Int']['output'];
  /** Website channels count */
  website: Scalars['Int']['output'];
  /** Zalo channels count */
  zalo: Scalars['Int']['output'];
};

export type ChatLastMessage = {
  __typename?: 'ChatLastMessage';
  body?: Maybe<Scalars['String']['output']>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromDisplayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
};

export type ChatMember = {
  __typename?: 'ChatMember';
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  odataType?: Maybe<Scalars['String']['output']>;
  roles: Array<ConversationMemberRole>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  visibleHistoryStartDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ChatMemberInput = {
  /** Member roles (owner or member) */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User ID or email address */
  userId: Scalars['String']['input'];
};

export type ChatMessageSearchInput = {
  /** Search only in this specific chat */
  chatId?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages from this sender (email or name) */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages from this date (ISO string) */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages that have attachments */
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of results to return (max 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter messages that mention specific people */
  mentions?: InputMaybe<Scalars['String']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Search query string */
  query: Scalars['String']['input'];
  /** Sort order for results */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages sent to this person (email or name) */
  to?: InputMaybe<Scalars['String']['input']>;
  /** Filter messages up to this date (ISO string) */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type ChatMessageSearchResponse = {
  __typename?: 'ChatMessageSearchResponse';
  /** Next page offset for pagination */
  nextOffset?: Maybe<Scalars['Int']['output']>;
  /** Search query used */
  query: Scalars['String']['output'];
  /** Search results */
  results: Array<ChatMessageSearchResult>;
  /** Number of results returned */
  returnedCount: Scalars['Int']['output'];
  /** Whether search used Microsoft Graph API or database fallback */
  searchMethod: Scalars['String']['output'];
  /** Total number of results found */
  totalCount: Scalars['Int']['output'];
};

export type ChatMessageSearchResult = {
  __typename?: 'ChatMessageSearchResult';
  /** Chat display name where message was found */
  chatDisplayName?: Maybe<Scalars['String']['output']>;
  /** Highlighted search terms in the message */
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  /** The found message */
  message: MicrosoftChatMessage;
  /** Search relevance score */
  relevanceScore?: Maybe<Scalars['Int']['output']>;
  /** Context snippet around the found text */
  snippet?: Maybe<Scalars['String']['output']>;
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  /** Count of related entities */
  _count?: Maybe<ChatRoomCount>;
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['String']['output']>;
  /** Denormalized agent name — survives agent deletion so orphaned rooms can be matched to a replacement agent by name */
  agentName?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether chatbot auto-reply is enabled for this chat room */
  isAutoReplyEnabled: Scalars['Boolean']['output'];
  lastMessage?: Maybe<Message>;
  lastMessageId?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Message>>;
  name?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type ChatRoomCount = {
  __typename?: 'ChatRoomCount';
  /** Number of messages in this chat room */
  messages: Scalars['Int']['output'];
};

export type ChatRoomData = {
  __typename?: 'ChatRoomData';
  agentId?: Maybe<Scalars['ID']['output']>;
  channelId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isAutoReplyEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ClickHouseDatabasesResponse = {
  __typename?: 'ClickHouseDatabasesResponse';
  /** Number of databases */
  count: Scalars['Int']['output'];
  /** List of available database names */
  databases: Array<Scalars['String']['output']>;
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Response timestamp */
  timestamp: Scalars['String']['output'];
};

export type ClickHouseHealthResponse = {
  __typename?: 'ClickHouseHealthResponse';
  /** Whether ClickHouse is enabled */
  clickhouseEnabled: Scalars['Boolean']['output'];
  /** Component status information as JSON string */
  components: Scalars['String']['output'];
  /** Configuration information as JSON string */
  configuration: Scalars['String']['output'];
  /** Whether connection is healthy */
  connectionHealthy: Scalars['Boolean']['output'];
  /** Error message if unhealthy */
  error?: Maybe<Scalars['String']['output']>;
  /** Last health check timestamp */
  lastChecked: Scalars['String']['output'];
  /** Overall health status */
  status: Scalars['String']['output'];
};

export type ClickHouseIntentAnalysisResponse = {
  __typename?: 'ClickHouseIntentAnalysisResponse';
  /** Confidence score (0-1) */
  confidence: Scalars['Float']['output'];
  /** Analysis context as JSON string */
  context?: Maybe<Scalars['String']['output']>;
  /** Detected intent type */
  intent: Scalars['String']['output'];
  /** Whether message has analytical intent */
  isAnalytical: Scalars['Boolean']['output'];
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** AI-generated query suggestion */
  suggestedQuery?: Maybe<Scalars['String']['output']>;
  /** Analysis timestamp */
  timestamp: Scalars['String']['output'];
};

export type ClickHouseQueryMetadata = {
  __typename?: 'ClickHouseQueryMetadata';
  /** Whether result was cached */
  cached: Scalars['Boolean']['output'];
  /** Column information as JSON strings */
  columns: Array<Scalars['String']['output']>;
  /** Execution time in milliseconds */
  executionTimeMs: Scalars['Float']['output'];
  /** Executed query */
  query: Scalars['String']['output'];
  /** Unique query identifier */
  queryId: Scalars['String']['output'];
  /** Number of rows returned */
  rowsReturned: Scalars['Int']['output'];
  /** Execution timestamp */
  timestamp: Scalars['String']['output'];
};

export type ClickHouseQueryResponse = {
  __typename?: 'ClickHouseQueryResponse';
  /** Query result data as JSON string */
  data?: Maybe<Scalars['String']['output']>;
  /** Error message if query failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Query execution metadata */
  metadata?: Maybe<ClickHouseQueryMetadata>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Response timestamp */
  timestamp: Scalars['String']['output'];
};

export type ClickHouseQuerySuggestion = {
  __typename?: 'ClickHouseQuerySuggestion';
  /** Query complexity level */
  complexity: Scalars['String']['output'];
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Estimated execution time in milliseconds */
  estimatedExecutionTime?: Maybe<Scalars['Float']['output']>;
  /** Suggested query SQL */
  query: Scalars['String']['output'];
  /** Query tags */
  tags: Array<Scalars['String']['output']>;
  /** Intended use case */
  useCase: Scalars['String']['output'];
};

export type ClickHouseSchemaResponse = {
  __typename?: 'ClickHouseSchemaResponse';
  /** Whether result was cached */
  cached: Scalars['Boolean']['output'];
  /** Database name */
  database: Scalars['String']['output'];
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Schema information as JSON string */
  schemaInfo: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of tables analyzed */
  tablesAnalyzed: Scalars['Int']['output'];
  /** Response timestamp */
  timestamp: Scalars['String']['output'];
};

export type ClickHouseSuggestionsResponse = {
  __typename?: 'ClickHouseSuggestionsResponse';
  /** Target database */
  database: Scalars['String']['output'];
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** List of query suggestions */
  suggestions: Array<ClickHouseQuerySuggestion>;
  /** Response timestamp */
  timestamp: Scalars['String']['output'];
};

export type ConversationDetailResponse = {
  __typename?: 'ConversationDetailResponse';
  /** Assigned agent information */
  agent?: Maybe<AgentInfo>;
  /** Channel information */
  channel: ChannelDetailInfo;
  conversationGroup?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** Customer information */
  customer: MessageUser;
  customerAvatar: Scalars['String']['output'];
  /** Customer dynamic fields information */
  customerFields?: Maybe<CustomerFieldsInfo>;
  customerName: Scalars['String']['output'];
  hasUnread: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Messages in this conversation */
  messages: ConversationMessagesResponse;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusColor: Scalars['String']['output'];
  timeAgo: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ConversationFilters = {
  /** Filter by specific channel ID */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by date range */
  dateRange?: InputMaybe<DateRangeInput>;
  /** Filter conversations with/without unread messages */
  hasUnread?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by platform type (facebook, website, zalo) */
  platformType?: InputMaybe<PlatformCode>;
  /** Search in customer names and message content */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by conversation status (active, waiting_for_agent, closed) */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationHistoryItem = {
  __typename?: 'ConversationHistoryItem';
  createdAt: Scalars['DateTime']['output'];
  customerAvatar?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastMessage?: Maybe<LastMessageInfo>;
  messageCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  tags: Array<ConversationTagInfo>;
  timeAgo: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type ConversationHistoryResponse = {
  __typename?: 'ConversationHistoryResponse';
  activeConversation?: Maybe<ConversationHistoryItem>;
  averageDuration?: Maybe<Scalars['String']['output']>;
  closedConversations: Array<ConversationHistoryItem>;
  conversationGroup: Scalars['String']['output'];
  totalConversations: Scalars['Int']['output'];
  totalMessages: Scalars['Int']['output'];
};

export type ConversationItemInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type ConversationListItem = {
  __typename?: 'ConversationListItem';
  /** Channel information */
  channel: ChannelInfo;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Customer avatar URL */
  customerAvatar: Scalars['String']['output'];
  /** Customer display name */
  customerName: Scalars['String']['output'];
  /** Whether conversation has unread messages */
  hasUnread: Scalars['Boolean']['output'];
  /** Unique conversation ID */
  id: Scalars['String']['output'];
  /** Whether auto-reply is enabled for this conversation */
  isAutoReplyEnabled: Scalars['Boolean']['output'];
  /** Last message in conversation */
  lastMessage?: Maybe<LastMessageInfo>;
  /** Preview of last message text */
  lastMessagePreview: Scalars['String']['output'];
  /** Conversation status */
  status: Scalars['String']['output'];
  /** Status color for UI display */
  statusColor: Scalars['String']['output'];
  /** Tags assigned to this conversation */
  tags: Array<ConversationTagInfo>;
  /** Human-readable time since last update */
  timeAgo: Scalars['String']['output'];
  /** Number of unread messages */
  unreadCount: Scalars['Int']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Customer user ID */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ConversationListResponse = {
  __typename?: 'ConversationListResponse';
  conversations: Array<ConversationListItem>;
  pagination: PaginationResponse;
  totalCount: Scalars['Int']['output'];
};

/** The role of the team member */
export enum ConversationMemberRole {
  Guest = 'GUEST',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  /** Message attachments (images, files, etc.) */
  attachments?: Maybe<Array<MessageAttachment>>;
  /** When message was created */
  createdAt: Scalars['String']['output'];
  /** Message ID */
  id: Scalars['String']['output'];
  /** Whether message has been read */
  isRead: Scalars['Boolean']['output'];
  /** Message status (sent, delivered, read) */
  messageStatus: Scalars['String']['output'];
  /** When message was read */
  readAt?: Maybe<Scalars['String']['output']>;
  /** Who read the message */
  readBy?: Maybe<Scalars['String']['output']>;
  /** Message role (USER, ASSISTANT, SYSTEM) */
  role: Scalars['String']['output'];
  /** Message content (nullable for attachment-only messages) */
  text?: Maybe<Scalars['String']['output']>;
  /** Human-readable time since message creation */
  timeAgo: Scalars['String']['output'];
  /** When message was last updated */
  updatedAt: Scalars['String']['output'];
  /** Message sender information */
  user?: Maybe<MessageUser>;
};

export type ConversationMessagesResponse = {
  __typename?: 'ConversationMessagesResponse';
  /** Conversation ID */
  conversationId: Scalars['String']['output'];
  /** Last message timestamp for real-time updates */
  lastMessageTime: Scalars['String']['output'];
  messages: Array<ConversationMessage>;
  pagination: MessagePaginationResponse;
  totalCount: Scalars['Int']['output'];
};

export type ConversationNote = {
  __typename?: 'ConversationNote';
  /** Author details */
  author: NoteAuthor;
  /** User ID who created the note */
  authorId: Scalars['String']['output'];
  /** Note content */
  content: Scalars['String']['output'];
  /** Conversation ID this note belongs to */
  conversationId: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Is note pinned */
  isPinned: Scalars['Boolean']['output'];
  /** Type of note */
  noteType: NoteType;
  /** Note type display name */
  noteTypeDisplayName: Scalars['String']['output'];
  /** Priority level */
  priority: NotePriority;
  /** Priority display color */
  priorityColor: Scalars['String']['output'];
  /** Time ago formatted */
  timeAgo: Scalars['String']['output'];
  /** Last update date */
  updatedAt: Scalars['String']['output'];
};

export type ConversationNoteFilters = {
  /** Filter by author user ID */
  authorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by conversation ID */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by pinned status */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by note type */
  noteType?: InputMaybe<NoteType>;
  /** Filter by priority */
  priority?: InputMaybe<NotePriority>;
  /** Search in content */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationNoteListResponse = {
  __typename?: 'ConversationNoteListResponse';
  /** Count of high/urgent priority notes */
  highPriorityCount: Scalars['Int']['output'];
  notes: Array<ConversationNote>;
  /** Count of pinned notes */
  pinnedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Fields available for sorting conversation notes */
export enum ConversationNoteSortField {
  CreatedAt = 'CREATED_AT',
  NoteType = 'NOTE_TYPE',
  Priority = 'PRIORITY',
  UpdatedAt = 'UPDATED_AT'
}

export type ConversationNoteSorting = {
  direction?: Scalars['String']['input'];
  field?: ConversationNoteSortField;
};

export type ConversationNoteStats = {
  __typename?: 'ConversationNoteStats';
  /** Statistics by author */
  authorStats: Array<NoteAuthorStats>;
  /** Pinned notes count */
  pinnedNotes: Scalars['Int']['output'];
  /** Statistics by priority */
  priorityStats: Array<NotePriorityStats>;
  /** Total notes count */
  totalNotes: Scalars['Int']['output'];
  /** Statistics by note type */
  typeStats: Array<NoteTypeStats>;
};

/** Fields available for sorting conversations */
export enum ConversationSortField {
  CreatedAt = 'CREATED_AT',
  CustomerName = 'CUSTOMER_NAME',
  LastMessageAt = 'LAST_MESSAGE_AT',
  UnreadCount = 'UNREAD_COUNT'
}

export type ConversationSorting = {
  direction?: SortDirection;
  field?: ConversationSortField;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  id: Scalars['String']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  lastMessageText?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type ConversationTag = {
  __typename?: 'ConversationTag';
  /** Tag category */
  category?: Maybe<TagCategory>;
  /** Category display name */
  categoryName: Scalars['String']['output'];
  /** Tag display color (hex) */
  color: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['String']['output'];
  /** Tag description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display order */
  displayOrder: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** Is tag active */
  isActive: Scalars['Boolean']['output'];
  /** Tag name (unique) */
  name: Scalars['String']['output'];
  /** Last update date */
  updatedAt: Scalars['String']['output'];
  /** Number of conversations using this tag */
  usageCount: Scalars['Int']['output'];
};

export type ConversationTagAssignment = {
  __typename?: 'ConversationTagAssignment';
  /** When tag was added */
  addedAt: Scalars['String']['output'];
  /** User ID who added the tag */
  addedBy: Scalars['String']['output'];
  /** User who added the tag */
  addedByUser: TagAssignedByUser;
  /** Conversation ID */
  chatRoomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Tag details */
  tag: ConversationTag;
  /** Tag ID */
  tagId: Scalars['String']['output'];
};

export type ConversationTagFilters = {
  /** Filter by category */
  category?: InputMaybe<TagCategory>;
  /** Filter by active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in tag name and description */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationTagInfo = {
  __typename?: 'ConversationTagInfo';
  addedAt: Scalars['DateTime']['output'];
  addedBy?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  categoryName?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConversationTagListResponse = {
  __typename?: 'ConversationTagListResponse';
  tags: Array<ConversationTag>;
  totalCount: Scalars['Int']['output'];
};

export type ConversationTagStats = {
  __typename?: 'ConversationTagStats';
  /** Active tags count */
  activeTags: Scalars['Int']['output'];
  /** Usage statistics by category */
  categoryStats: Array<CategoryStats>;
  /** Inactive tags count */
  inactiveTags: Scalars['Int']['output'];
  /** Usage statistics by tag */
  tagUsage: Array<TagUsageStats>;
  /** Total number of tags */
  totalTags: Scalars['Int']['output'];
};

export type ConversationWithChannelInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ConversationWithChannelResult = {
  __typename?: 'ConversationWithChannelResult';
  channel: UserChannelInfo;
  conversationGroup: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isNewConversation: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CreateAgentDto = {
  agentType?: InputMaybe<AgentType>;
  audience?: InputMaybe<AgentAudience>;
  folderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Form templates folder path. Accepted for forward compatibility; the underlying column was removed in migration 20260309300000_remove_agent_form_folder_path and the value is currently not persisted. */
  formFolderPath?: InputMaybe<Scalars['String']['input']>;
  /** Explicit Knowledge Graph to bind this agent to. Mutually exclusive with linkActiveKg; when both are set, the explicit ID wins. */
  knowledgeGraphId?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['String']['input'];
  /** When true, auto-resolve the latest COMPLETED Knowledge Graph in the namespace inferred from the user. Ignored when knowledgeGraphId is provided. */
  linkActiveKg?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  toolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** React Flow workflow definition (nodes, edges, viewport, metadata). When provided, a Workflow row is created and linked to the agent. */
  workflowDefinition?: InputMaybe<Scalars['JSONObject']['input']>;
};

/** Input for creating a new API key */
export type CreateApiKeyInput = {
  /** Optional: restrict to specific agent UUID */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Daily request limit (optional) */
  dailyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Expiration date (ISO string, optional) */
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  /** User-friendly name for the key */
  name: Scalars['String']['input'];
  /** Rate limit (requests per minute, default: 60) */
  rateLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Scopes (default: ["chat:completions"]) */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response when creating an API key - contains the raw key (shown only once) */
export type CreateApiKeyResponse = {
  __typename?: 'CreateApiKeyResponse';
  /** The created API key metadata */
  apiKey: ApiKey;
  /** The raw API key value - only shown once, store it securely! */
  rawKey: Scalars['String']['output'];
};

export type CreateChannelDto = {
  /** Channel avatar/image URL */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Enable unlimited messaging for enterprise channels */
  isUnlimitedMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Channel/page display name */
  name: Scalars['String']['input'];
  /** External platform page/channel ID */
  pageId: Scalars['String']['input'];
  /** Platform ID */
  platformId: Scalars['String']['input'];
  /** Platform-specific webhook URL */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelInput = {
  /** Optional textual description for the channel */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Channel display name (max 50 characters) */
  displayName: Scalars['String']['input'];
  /** Whether channel should be marked as recommended (default: false) */
  isFavoriteByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of the channel (default: standard) */
  membershipType?: InputMaybe<ChannelMembershipType>;
};

export type CreateChannelReplyInput = {
  /** Reply attachments (JSON string) */
  attachments?: InputMaybe<Scalars['String']['input']>;
  /** Reply content and type */
  body: MessageBodyInput;
  /** Reply importance level */
  importance?: InputMaybe<MessageImportance>;
  /** Reply mentions (JSON string) */
  mentions?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationNoteInput = {
  /** Note content */
  content: Scalars['String']['input'];
  /** Conversation ID this note belongs to */
  conversationId: Scalars['String']['input'];
  /** Pin this note */
  isPinned?: Scalars['Boolean']['input'];
  /** Type of note */
  noteType?: NoteType;
  /** Priority level */
  priority?: NotePriority;
};

export type CreateConversationTagInput = {
  /** Tag category */
  category?: InputMaybe<TagCategory>;
  /** Tag display color (hex) */
  color?: Scalars['String']['input'];
  /** Tag description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display order */
  displayOrder?: Scalars['Int']['input'];
  /** Is tag active */
  isActive?: Scalars['Boolean']['input'];
  /** Tag name (unique) */
  name: Scalars['String']['input'];
};

export type CreateCustomerLabelInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  displayOrder: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEventInput = {
  attendees?: InputMaybe<Array<AttendeeInput>>;
  body?: InputMaybe<EventBodyInput>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Teams Channel ID for channel meeting */
  channelId?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<EventClassification>;
  end: Scalars['String']['input'];
  endTimeZone?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<EventImportance>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<EventLocationInput>;
  onlineMeetingProvider?: InputMaybe<OnlineMeetingProvider>;
  recurrence?: InputMaybe<EventRecurrenceInput>;
  /** Whether to send meeting notification to channel */
  sendChannelMessage?: InputMaybe<Scalars['Boolean']['input']>;
  sensitivity?: InputMaybe<EventSensitivity>;
  showAs?: InputMaybe<EventShowAs>;
  start: Scalars['String']['input'];
  startTimeZone?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  /** Teams Team ID for channel meeting */
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFacebookChannelDto = {
  /** Enable unlimited messaging for enterprise Facebook channel */
  isUnlimitedMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Facebook page access token (short-lived) */
  pageAccessToken: Scalars['String']['input'];
  /** Facebook page category */
  pageCategory?: InputMaybe<Scalars['String']['input']>;
  /** Facebook page ID */
  pageId: Scalars['String']['input'];
  /** Facebook page profile picture URL */
  pageImage?: InputMaybe<Scalars['String']['input']>;
  /** Facebook page display name */
  pageName: Scalars['String']['input'];
  /** Platform app ID to associate with channel */
  platformAppId: Scalars['String']['input'];
};

export type CreateGroupInput = {
  allowExternalSenders?: InputMaybe<Scalars['Boolean']['input']>;
  autoSubscribeNewMembers?: InputMaybe<Scalars['Boolean']['input']>;
  classification?: InputMaybe<GroupClassification>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  enableTeams?: InputMaybe<Scalars['Boolean']['input']>;
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  mailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mailNickname?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  owners?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredDataLocation?: InputMaybe<PreferredDataLocation>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  securityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<GroupVisibility>;
};

export type CreateMicrosoftChatInput = {
  /** Array of users to chat with (current user will be automatically added) */
  members: Array<ChatMemberInput>;
  /** Chat topic/title (optional, automatically used for group chats with 2+ members) */
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMicrosoftChatMessageInput = {
  /** Message attachments (JSON string) */
  attachments?: InputMaybe<Scalars['String']['input']>;
  /** Message content and type */
  body: MessageBodyInput;
  /** Message importance level */
  importance?: InputMaybe<MessageImportance>;
  /** Message mentions (JSON string) */
  mentions?: InputMaybe<Scalars['String']['input']>;
  /** Message subject */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMicrosoftUserInput = {
  useHardcodedTokens?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type CreatePackageDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  duration: Scalars['String']['input'];
  messageCount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packageType: Scalars['String']['input'];
  platformType?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  status: Scalars['String']['input'];
};

export type CreatePlatformAppDto = {
  config: Scalars['JSONObject']['input'];
  platformCode: Scalars['String']['input'];
};

export type CreatePlatformDto = {
  code: PlatformCode;
  name: Scalars['String']['input'];
};

export type CreateSocialUserInput = {
  channelId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  platformType: PlatformCode;
  platformUserId: Scalars['String']['input'];
  profilePic?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  memberUserIds: Array<Scalars['String']['input']>;
};

export type CreateTeamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  firstChannelName?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<TeamVisibility>;
};

/** Input for creating a new workflow */
export type CreateWorkflowDto = {
  /** Workflow definition containing nodes, edges, and viewport */
  definition: Scalars['JSONObject']['input'];
  /** Optional description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether workflow is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is the default workflow */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Workflow name (must be unique for the user) */
  name: Scalars['String']['input'];
  /** Semantic version */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentUserTeamContext = {
  __typename?: 'CurrentUserTeamContext';
  canPerformOwnerActions: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  /** Number of guests in this team */
  guestCount?: Maybe<Scalars['Int']['output']>;
  isOwner: Scalars['Boolean']['output'];
  joinedDateTime: Scalars['DateTime']['output'];
  /** Total number of members in this team */
  memberCount?: Maybe<Scalars['Int']['output']>;
  /** Microsoft membership ID for this user in the team */
  membershipId?: Maybe<Scalars['ID']['output']>;
  /** Number of owners in this team */
  ownerCount?: Maybe<Scalars['Int']['output']>;
  permissions: TeamMemberPermissions;
  /** Number of regular members (excluding owners) */
  regularMemberCount?: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['ID']['output'];
  userRole: ConversationMemberRole;
};

export type CustomerActivity = {
  __typename?: 'CustomerActivity';
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  performedBy?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CustomerCategoryStats = {
  __typename?: 'CustomerCategoryStats';
  category: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
};

export type CustomerDashboardResponse = {
  __typename?: 'CustomerDashboardResponse';
  customers: Array<CustomerInfo>;
  pagination: PaginationResponse;
  totalCount: Scalars['Int']['output'];
};

export type CustomerDynamicFieldValue = {
  __typename?: 'CustomerDynamicFieldValue';
  fieldKey: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerFieldsInfo = {
  __typename?: 'CustomerFieldsInfo';
  completedFields: Scalars['Int']['output'];
  fields: Array<DynamicFieldInfo>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedField?: Maybe<Scalars['String']['output']>;
  /** Current customer lifecycle stage */
  stage?: Maybe<CustomerStage>;
  totalFields: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type CustomerFilters = {
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastContactedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  lastContactedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer stages */
  stages?: InputMaybe<Array<CustomerStage>>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerScore: Scalars['Int']['output'];
  dynamicFields: Array<CustomerDynamicFieldValue>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Customer labels (multiple labels allowed) */
  labels: Array<CustomerLabelInfo>;
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recentActivity: Array<CustomerActivity>;
  /** Customer lifecycle stage */
  stage?: Maybe<CustomerStage>;
  totalConversations: Scalars['Int']['output'];
  totalMessages: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerLabelInfo = {
  __typename?: 'CustomerLabelInfo';
  assignedAt: Scalars['DateTime']['output'];
  assignedBy?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  customerCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CustomerLabelStats = {
  __typename?: 'CustomerLabelStats';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  labelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerLabelsResponse = {
  __typename?: 'CustomerLabelsResponse';
  labels: Array<CustomerLabelInfo>;
  totalCount: Scalars['Int']['output'];
};

export type CustomerScore = {
  __typename?: 'CustomerScore';
  breakdown: CustomerScoreBreakdown;
  lastCalculated: Scalars['DateTime']['output'];
  totalScore: Scalars['Int']['output'];
};

export type CustomerScoreBreakdown = {
  __typename?: 'CustomerScoreBreakdown';
  engagementLevel: Scalars['Int']['output'];
  profileCompleteness: Scalars['Int']['output'];
  responseQuality: Scalars['Int']['output'];
};

export type CustomerScoreDistribution = {
  __typename?: 'CustomerScoreDistribution';
  count: Scalars['Int']['output'];
  scoreRange: Scalars['String']['output'];
};

export type CustomerSidebarStats = {
  __typename?: 'CustomerSidebarStats';
  categories: Array<CustomerCategoryStats>;
  labels: Array<CustomerLabelStats>;
  lastUpdated: Scalars['DateTime']['output'];
  myLeads: Scalars['Int']['output'];
  stages: Array<CustomerStageStats>;
  totalCustomers: Scalars['Int']['output'];
};

export type CustomerSorting = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

/** Customer lifecycle stage */
export enum CustomerStage {
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  AtRisk = 'AT_RISK',
  LoyalCustomer = 'LOYAL_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  Prospect = 'PROSPECT'
}

export type CustomerStageStats = {
  __typename?: 'CustomerStageStats';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  stage?: Maybe<CustomerStage>;
};

export type DateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

/** Days of the week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DecrementQuotaInput = {
  channelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Dead Letter Queue record for failed task messages */
export type DlqRecord = {
  __typename?: 'DlqRecord';
  /** When record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Number of times this message failed */
  failureCount: Scalars['Int']['output'];
  /** Reason for failure */
  failureReason: Scalars['String']['output'];
  /** When first failure occurred */
  firstFailureAt: Scalars['DateTime']['output'];
  /** DLQ record ID */
  id: Scalars['String']['output'];
  /** When last failure occurred */
  lastFailureAt: Scalars['DateTime']['output'];
  /** Original message content */
  originalMessage: Scalars['JSONObject']['output'];
  /** Original queue name */
  originalQueue: Scalars['String']['output'];
  /** Notes about resolution */
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  /** Whether this DLQ record has been resolved */
  resolved: Scalars['Boolean']['output'];
  /** When the record was resolved */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who resolved the record */
  resolvedBy?: Maybe<Scalars['String']['output']>;
  /** Associated task state */
  taskState?: Maybe<TaskState>;
  /** Associated task state ID */
  taskStateId?: Maybe<Scalars['String']['output']>;
};

export type Document = {
  __typename?: 'Document';
  /** Count of related entities */
  _count?: Maybe<DocumentCount>;
  /** Array of asset metadata [{md5, page, name, path}] */
  assets?: Maybe<Scalars['JSON']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Soft-delete timestamp */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extension: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  folder?: Maybe<Folder>;
  folderId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Knowledge graphs that include this document */
  knowledgeGraphDocuments?: Maybe<Array<KnowledgeGraphDocument>>;
  /** YAML frontmatter extracted from source markdown (SKHCN gov/legal fields: doc_number, doc_type, issuing_agency, signatory, issued_date, effective_date, site) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** MD5 of raw markdown bytes (before URL replacement) */
  originalMarkdownMd5?: Maybe<Scalars['String']['output']>;
  /** When the document was parsed */
  parsedAt?: Maybe<Scalars['DateTime']['output']>;
  /** MD5 of markdown after S3 URL replacement */
  processedMarkdownMd5?: Maybe<Scalars['String']['output']>;
  /** Array of sheet regions for xlsx [{region_id, title, sheet_name, location, type, shape, columns, files}] */
  regions?: Maybe<Scalars['JSON']['output']>;
  /** S3 path to markdown content */
  s3MarkdownPath?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  /** MD5 of original source file (docx/pdf), nullable */
  sourceDocumentMd5?: Maybe<Scalars['String']['output']>;
  /** S3 key for original source document in kg-source-docs bucket */
  sourceFileS3Key?: Maybe<Scalars['String']['output']>;
  /** Original filename before parsing (e.g., "Report.docx") */
  sourceFilename?: Maybe<Scalars['String']['output']>;
  /** When content was published/updated in source system */
  sourcePublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Original file type (docx, pdf, xlsx, pptx, etc.) */
  sourceType?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type DocumentCount = {
  __typename?: 'DocumentCount';
  /** Number of knowledge graphs this document is linked to */
  knowledgeGraphDocuments: Scalars['Int']['output'];
};

/** Document status */
export enum DocumentStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  /** Image S3 references [{md5, page, name, path}] */
  assets?: Maybe<Scalars['JSON']['output']>;
  changeType: Scalars['String']['output'];
  changedBy: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  md5Hash: Scalars['String']['output'];
  /** Sheet S3 references [{region_id, title, ...}] */
  regions?: Maybe<Scalars['JSON']['output']>;
  /** S3 key in kg-parsed-data at this version */
  s3MarkdownPath?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DynamicFieldInfo = {
  __typename?: 'DynamicFieldInfo';
  category?: Maybe<Scalars['String']['output']>;
  categoryLabel?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  fieldKey: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  selectOptions?: Maybe<Array<FieldOptionInfo>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  allowNewTimeProposals: Scalars['Boolean']['output'];
  attendeeCount: Scalars['Int']['output'];
  attendees: Array<EventAttendee>;
  body?: Maybe<Scalars['String']['output']>;
  bodyPreview?: Maybe<Scalars['String']['output']>;
  calendar?: Maybe<EventCalendar>;
  calendarId: Scalars['String']['output'];
  /** Whether the current user can delete this event */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the current user can edit this event */
  canEdit: Scalars['Boolean']['output'];
  /** Whether the current user can respond to this event invitation */
  canRespond: Scalars['Boolean']['output'];
  categories: Array<Scalars['String']['output']>;
  changeKey?: Maybe<Scalars['String']['output']>;
  /** Teams Channel ID if this is a channel meeting */
  channelId?: Maybe<Scalars['String']['output']>;
  /** Channel message ID if notification was sent to channel */
  channelMessageId?: Maybe<Scalars['String']['output']>;
  /** Channel message web URL for direct access */
  channelMessageWebUrl?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<EventClassification>;
  createdAt: Scalars['DateTime']['output'];
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Current user response status */
  currentUserResponse?: Maybe<Scalars['String']['output']>;
  discoveredBy: Scalars['String']['output'];
  /** Event duration in minutes */
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  end: Scalars['DateTime']['output'];
  endTimeZone?: Maybe<Scalars['String']['output']>;
  extendedProperties?: Maybe<Scalars['String']['output']>;
  hasAttachments: Scalars['Boolean']['output'];
  /** Whether this event has time conflicts with other events */
  hasConflicts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  importance: EventImportance;
  isAllDay: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  /** Whether event is happening now */
  isHappeningNow?: Maybe<Scalars['Boolean']['output']>;
  isOnlineMeeting: Scalars['Boolean']['output'];
  /** Whether current user is the organizer */
  isOrganizer?: Maybe<Scalars['Boolean']['output']>;
  isRecurring: Scalars['Boolean']['output'];
  joinWebUrl?: Maybe<Scalars['String']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastSyncAt: Scalars['DateTime']['output'];
  location?: Maybe<Scalars['String']['output']>;
  locationDetails?: Maybe<EventLocation>;
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  /** Time until event starts (in minutes) */
  minutesToStart?: Maybe<Scalars['Int']['output']>;
  /** Next occurrence date for recurring events */
  nextOccurrence?: Maybe<Scalars['DateTime']['output']>;
  onlineMeetingInfo?: Maybe<OnlineMeetingInfo>;
  onlineMeetingProvider?: Maybe<OnlineMeetingProvider>;
  onlineMeetingUrl?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<EventOrganizer>;
  organizerEmail?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<EventRecurrence>;
  recurrencePattern?: Maybe<Scalars['String']['output']>;
  /** Number of remaining occurrences for recurring events */
  remainingOccurrences?: Maybe<Scalars['Int']['output']>;
  responseRequested: Scalars['Boolean']['output'];
  sensitivity: EventSensitivity;
  seriesMasterId?: Maybe<Scalars['String']['output']>;
  showAs: EventShowAs;
  start: Scalars['DateTime']['output'];
  startTimeZone?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  /** Teams Team ID if this is a channel meeting */
  teamId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  updatedAt: Scalars['DateTime']['output'];
  webLink?: Maybe<Scalars['String']['output']>;
};

export type EventAttendee = {
  __typename?: 'EventAttendee';
  /** Avatar URL if available from Microsoft Graph */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Display name or email if name not available */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email address information of the attendee */
  emailAddress: AttendeeEmailAddress;
  /** ID of the event this attendee belongs to */
  eventId: Scalars['ID']['output'];
  /** Whether this attendee has responded */
  hasResponded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Alternate date/time proposed by the attendee for a meeting request */
  proposedNewTime?: Maybe<ProposedNewTime>;
  /** Response status of the attendee */
  status: AttendeeStatus;
  /** Type of attendee: required, optional, or resource */
  type: AttendeeType;
  updatedAt: Scalars['DateTime']['output'];
  /** Whether this attendee will attend (accepted) */
  willAttend?: Maybe<Scalars['Boolean']['output']>;
};

export type EventBodyInput = {
  content: Scalars['String']['input'];
  contentType?: BodyContentType;
};

export type EventCalendar = {
  __typename?: 'EventCalendar';
  /** Allowed online meeting providers for this calendar */
  allowedOnlineMeetingProviders: Array<Scalars['String']['output']>;
  /** Permissions for users who have access to this calendar */
  calendarPermissions?: Maybe<Array<CalendarPermission>>;
  /** Internal calendar type classification */
  calendarType: CalendarType;
  /** Whether user can edit this calendar */
  canEdit: Scalars['Boolean']['output'];
  /** Whether user can share this calendar */
  canShare: Scalars['Boolean']['output'];
  /** Whether user can view private items in this calendar */
  canViewPrivateItems: Scalars['Boolean']['output'];
  /** Version identifier for optimistic locking */
  changeKey?: Maybe<Scalars['String']['output']>;
  /** Calendar color (enum value) */
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Default online meeting provider for new meetings */
  defaultOnlineMeetingProvider?: Maybe<Scalars['String']['output']>;
  discoveredBy: Scalars['String']['output'];
  /** Total number of events in this calendar */
  eventCount: Scalars['Int']['output'];
  /** Number of extended properties for this calendar */
  extendedPropertyCount?: Maybe<Scalars['Int']['output']>;
  /** Group ID if this is a group calendar */
  groupId?: Maybe<Scalars['String']['output']>;
  /** Calendar color as hex code */
  hexColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this is the default calendar for the user */
  isDefaultCalendar: Scalars['Boolean']['output'];
  /** Whether this calendar is enabled for sync */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user is the owner of this calendar */
  isOwner: Scalars['Boolean']['output'];
  /** Whether this calendar can be deleted */
  isRemovable: Scalars['Boolean']['output'];
  /** Whether this calendar is currently being synchronized */
  isSyncing: Scalars['Boolean']['output'];
  /** Whether this calendar supports tracking meeting responses */
  isTallyingResponses: Scalars['Boolean']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  /** Status of the last synchronization operation */
  lastSyncStatus?: Maybe<Scalars['String']['output']>;
  /** Multi-value extended properties for this calendar */
  multiValueExtendedProperties?: Maybe<Array<ExtendedProperty>>;
  name: Scalars['String']['output'];
  /** Original calendar ID from Microsoft Graph */
  originalId?: Maybe<Scalars['String']['output']>;
  /** Email address of the calendar owner */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the calendar owner */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Parent group name if this is a group calendar */
  parentGroupName?: Maybe<Scalars['String']['output']>;
  /** Total number of permissions for this calendar */
  permissionCount?: Maybe<Scalars['Int']['output']>;
  /** Detailed permissions as JSON */
  permissions?: Maybe<Scalars['String']['output']>;
  /** Single-value extended properties for this calendar */
  singleValueExtendedProperties?: Maybe<Array<ExtendedProperty>>;
  /** Source type: personal, group, or shared */
  sourceType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Classification level of the event */
export enum EventClassification {
  Confidential = 'CONFIDENTIAL',
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type EventFilterInput = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Exclude events where current user is the organizer */
  excludeOrganized?: InputMaybe<Scalars['Boolean']['input']>;
  importance?: InputMaybe<EventImportance>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** The importance level of the event */
export enum EventImportance {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

export type EventLocation = {
  __typename?: 'EventLocation';
  city?: Maybe<Scalars['String']['output']>;
  countryOrRegion?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type EventLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryOrRegion?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type EventOrganizer = {
  __typename?: 'EventOrganizer';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EventRecurrence = {
  __typename?: 'EventRecurrence';
  pattern: RecurrencePattern;
  range: RecurrenceRange;
};

export type EventRecurrenceInput = {
  pattern: RecurrencePatternInput;
  range: RecurrenceRangeInput;
};

/** The sensitivity level of the event */
export enum EventSensitivity {
  Confidential = 'CONFIDENTIAL',
  Normal = 'NORMAL',
  Personal = 'PERSONAL',
  Private = 'PRIVATE'
}

/** How the event should appear in calendar free/busy view */
export enum EventShowAs {
  Busy = 'BUSY',
  Free = 'FREE',
  Oof = 'OOF',
  Tentative = 'TENTATIVE',
  Unknown = 'UNKNOWN',
  WorkingElsewhere = 'WORKING_ELSEWHERE'
}

/** Type of event (single instance, recurring series, etc.) */
export enum EventType {
  Exception = 'EXCEPTION',
  Occurrence = 'OCCURRENCE',
  SeriesMaster = 'SERIES_MASTER',
  SingleInstance = 'SINGLE_INSTANCE'
}

export type ExportResult = {
  __typename?: 'ExportResult';
  documentsCreated: Scalars['Int']['output'];
  documentsDeleted: Scalars['Int']['output'];
  documentsUpdated: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type ExportToDocumentsResultObject = {
  __typename?: 'ExportToDocumentsResultObject';
  documentsCreated: Scalars['Int']['output'];
  documentsDeleted: Scalars['Int']['output'];
  documentsUpdated: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type ExtendedProperty = {
  __typename?: 'ExtendedProperty';
  /** ID of the calendar this property belongs to */
  calendarId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** MAPI property identifier */
  propertyId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Property value (for single-value properties) */
  value?: Maybe<Scalars['String']['output']>;
  /** Property values (for multi-value properties) */
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type FacebookChannelResult = {
  __typename?: 'FacebookChannelResult';
  channel?: Maybe<Channel>;
  error?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  relationshipInfo?: Maybe<RelationshipInfo>;
  success: Scalars['Boolean']['output'];
  wasRestored?: Maybe<Scalars['Boolean']['output']>;
};

export type FacebookConnectionHealthDto = {
  __typename?: 'FacebookConnectionHealthDto';
  channelId: Scalars['String']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isHealthy: Scalars['Boolean']['output'];
  lastPingAt: Scalars['DateTime']['output'];
  pageId: Scalars['String']['output'];
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  tokenStatus: Scalars['String']['output'];
};

export type FacebookConnectionSummaryDto = {
  __typename?: 'FacebookConnectionSummaryDto';
  connections: Array<FacebookConnectionHealthDto>;
  expiredTokens: Scalars['Int']['output'];
  expiringTokens: Scalars['Int']['output'];
  healthy: Scalars['Int']['output'];
  invalidTokens: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unhealthy: Scalars['Int']['output'];
};

export type FacebookTokenRefreshResultDto = {
  __typename?: 'FacebookTokenRefreshResultDto';
  failed: Scalars['Int']['output'];
  failedChannels: Array<Scalars['String']['output']>;
  refreshed: Scalars['Int']['output'];
  refreshedChannels: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type FieldCategory = {
  __typename?: 'FieldCategory';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  fields?: Maybe<Array<FieldDefinition>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FieldDefinition = {
  __typename?: 'FieldDefinition';
  category?: Maybe<FieldCategory>;
  categoryId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  fieldSource: FieldSource;
  fieldType: FieldType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selectOptions?: Maybe<Array<FieldOption>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  validationRules?: Maybe<Scalars['JSONObject']['output']>;
};

export type FieldOption = {
  __typename?: 'FieldOption';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  fieldDefinition?: Maybe<FieldDefinition>;
  fieldDefinitionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type FieldOptionInfo = {
  __typename?: 'FieldOptionInfo';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Field source - DEFAULT (system) or CUSTOM (user-created) */
export enum FieldSource {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

/** The type of field for data collection */
export enum FieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  File = 'FILE',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Radio = 'RADIO',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Url = 'URL'
}

export type FieldValidationResult = {
  __typename?: 'FieldValidationResult';
  errors: Array<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

/** OneDrive file sync status */
export enum FileStatus {
  Deleted = 'DELETED',
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Synced = 'SYNCED'
}

export type FileUploadInput = {
  /** Base64 encoded file content */
  content: Scalars['String']['input'];
  /** Original filename */
  filename: Scalars['String']['input'];
  /** MIME type of the file */
  mimeType: Scalars['String']['input'];
  /** File type (auto-detected if not provided) */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FindFormTemplatesInput = {
  /** When set, return only templates whose `folderId` matches. Required for the lazy-per-folder loader on admin + @-picker; without it the resolver paginates over the namespace flat. */
  folderId?: InputMaybe<Scalars['String']['input']>;
  /** When true, surface rows whose `meta.deleted=true` (admin restore flow). Defaults to false. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Substring (case-insensitive) filter on `formId` (filename routing key). */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Number of rows to skip; defaults to 0. */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Page size; defaults to 50, capped at 200. */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FindOrCreateChatRoomInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Folder = {
  __typename?: 'Folder';
  /** Count of related entities */
  _count?: Maybe<FolderCount>;
  agentFolders?: Maybe<Array<AgentFolder>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Soft-delete timestamp */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['ID']['output'];
  /** Folder content hash (hash of children MD5s for KG validation) */
  md5?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Folder>;
  parentId?: Maybe<Scalars['String']['output']>;
  subFolders?: Maybe<Array<Folder>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type FolderCount = {
  __typename?: 'FolderCount';
  /** Number of agent folders linked to this folder */
  agentFolders: Scalars['Int']['output'];
  /** Number of documents in this folder */
  documents: Scalars['Int']['output'];
  /** Number of subfolders in this folder */
  subFolders: Scalars['Int']['output'];
};

export type FormFolder = {
  __typename?: 'FormFolder';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Folder basename */
  name: Scalars['String']['output'];
  /** Product namespace (skhcn, ueh, citeka, …) */
  namespace: Scalars['String']['output'];
  /** null = namespace root */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FormParsedContent = {
  __typename?: 'FormParsedContent';
  /** Parsed assets [{md5, extension, original_name, s3_url, kind}] */
  assets: Scalars['JSON']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** FK to FormTemplate.id (1:1, ON DELETE CASCADE) */
  formTemplateId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** MD5 of raw markdown bytes (before URL replacement) */
  originalMarkdownMd5: Scalars['String']['output'];
  /** When the template was last parsed */
  parsedAt: Scalars['DateTime']['output'];
  /** MD5 of markdown after S3 URL replacement */
  processedMarkdownMd5: Scalars['String']['output'];
  /** Reserved for slot/region annotations (empty list today) */
  regions: Scalars['JSON']['output'];
  /** S3 key in kg-parsed-data bucket */
  s3MarkdownPath: Scalars['String']['output'];
  /** Parsed markdown text after S3 URL replacement */
  text: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  /** User UUID who authored this template (null = system-seeded) */
  authoredBy?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** FK to FormFolder (null = namespace root) */
  folderId?: Maybe<Scalars['String']['output']>;
  /** Bare `<name>.docx` filename — routing key the LLM passes to fill_form */
  formId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** MD5 of the DOCX bytes (content address in S3) */
  md5: Scalars['String']['output'];
  /** Parsed meta.json (slots, edits, analyzer_reasoning) */
  meta: Scalars['JSON']['output'];
  /** Authoring mode — "placeholder" or "xml_surgical" */
  mode: Scalars['String']['output'];
  /** Product namespace (citeka, ueh, skhcn, sdl, ifc, …) */
  namespace: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Bumped on each re-author of the same (folderId, formId) */
  version: Scalars['Int']['output'];
};

export type FormTemplateConnection = {
  __typename?: 'FormTemplateConnection';
  items: Array<FormTemplate>;
  /** Number of rows after filtering, before pagination (skip+take). */
  total: Scalars['Int']['output'];
};

export type FormTemplateFolderCount = {
  __typename?: 'FormTemplateFolderCount';
  /** Number of non-deleted FormTemplate rows under this folder. */
  count: Scalars['Int']['output'];
  /** FormFolder.id, or "" for the namespace root (folderId IS NULL). */
  folderId: Scalars['String']['output'];
};

export type FreeBusyQueryInput = {
  availabilityViewInterval?: InputMaybe<Scalars['Int']['input']>;
  endTime: Scalars['String']['input'];
  schedules: Array<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type FreeBusyResult = {
  __typename?: 'FreeBusyResult';
  availabilityView: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  freeBusyViewType?: Maybe<Scalars['String']['output']>;
  scheduleId: Scalars['String']['output'];
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type GenerateInput = {
  agent_id?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Array<ConversationItemInput>>;
  query: Scalars['String']['input'];
  strategy?: GenerationStrategy;
};

export type GenerateTeamsAppResponse = {
  __typename?: 'GenerateTeamsAppResponse';
  colorIconUrl?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  manifest?: Maybe<TeamsAppManifest>;
  message?: Maybe<Scalars['String']['output']>;
  outlineIconUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerationPayload = {
  __typename?: 'GenerationPayload';
  documents: Array<Scalars['JSONObject']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finish_reason: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Specifies the RAG generation strategy to be used for a query. All products use Knowledge Graph RAG exclusively. */
export enum GenerationStrategy {
  /** Use the Knowledge Graph-based RAG pipeline. */
  KnowledgeGraphRag = 'KNOWLEDGE_GRAPH_RAG'
}

export type GetAllPlatformAppsQueryInput = {
  /** Include channel platform app relationships with channel details */
  includeChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include platform details */
  includePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include user details */
  includeUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of items per page */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page number (1-based) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by platform code (facebook, zalo, teams, website) */
  platformCode?: InputMaybe<Scalars['String']['input']>;
  /** Filter by platform ID */
  platformId?: InputMaybe<Scalars['String']['input']>;
  /** Search in platform app name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort order */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type GetChannelByPageIdInput = {
  pageId: Scalars['String']['input'];
  platformCode: PlatformCode;
};

export type GetUserByPlatformIdInput = {
  platformType: PlatformCode;
  platformUserId: Scalars['String']['input'];
};

export type Group = {
  __typename?: 'Group';
  allowExternalSenders: Scalars['Boolean']['output'];
  autoSubscribeNewMembers: Scalars['Boolean']['output'];
  /** Calendar information for this group */
  calendarInfo: GroupCalendarInfo;
  classification?: Maybe<GroupClassification>;
  createdAt: Scalars['DateTime']['output'];
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Current user role in this group (computed field) */
  currentUserRole?: Maybe<Scalars['String']['output']>;
  deletedDateTime?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discoveredBy?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  groupTypes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAssignableToRole: Scalars['Boolean']['output'];
  /** Whether current user is a member of this group */
  isCurrentUserMember: Scalars['Boolean']['output'];
  /** Whether current user is an owner of this group */
  isCurrentUserOwner: Scalars['Boolean']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  mailEnabled: Scalars['Boolean']['output'];
  mailNickname: Scalars['String']['output'];
  /** Total number of members in this group */
  memberCount: Scalars['Int']['output'];
  members: Array<GroupMember>;
  onPremisesDomainName?: Maybe<Scalars['String']['output']>;
  onPremisesNetBiosName?: Maybe<Scalars['String']['output']>;
  onPremisesSecurityIdentifier?: Maybe<Scalars['String']['output']>;
  onPremisesSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Total number of owners in this group */
  ownerCount: Scalars['Int']['output'];
  owners: Array<GroupOwner>;
  /** User permissions for this group */
  permissions?: Maybe<GroupPermissions>;
  preferredDataLocation?: Maybe<PreferredDataLocation>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  proxyAddresses: Array<Scalars['String']['output']>;
  renewedDateTime?: Maybe<Scalars['DateTime']['output']>;
  securityEnabled: Scalars['Boolean']['output'];
  /** Group statistics and member info */
  stats?: Maybe<GroupStats>;
  /** Teams-specific information for this group */
  teamsInfo: GroupTeamsInfo;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: GroupVisibility;
};

export type GroupCalendarInfo = {
  __typename?: 'GroupCalendarInfo';
  calendarId?: Maybe<Scalars['String']['output']>;
  calendarName?: Maybe<Scalars['String']['output']>;
  canCreateEvents: Scalars['Boolean']['output'];
  canDeleteEvents: Scalars['Boolean']['output'];
  canEditEvents: Scalars['Boolean']['output'];
  eventCount: Scalars['Int']['output'];
  hasCalendar: Scalars['Boolean']['output'];
};

export type GroupCalendarInput = {
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

/** The classification of the group for data sensitivity */
export enum GroupClassification {
  Confidential = 'CONFIDENTIAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type GroupFilter = {
  classification?: InputMaybe<GroupClassification>;
  groupTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  securityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<GroupVisibility>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  addedAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  mail?: Maybe<Scalars['String']['output']>;
  memberType: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userPrincipalName: Scalars['String']['output'];
};

export type GroupOwner = {
  __typename?: 'GroupOwner';
  addedAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  mail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userPrincipalName: Scalars['String']['output'];
};

export type GroupPermissions = {
  __typename?: 'GroupPermissions';
  /** Can create events in group calendar */
  canCreateEvents: Scalars['Boolean']['output'];
  /** Can delete events from group calendar */
  canDeleteEvents: Scalars['Boolean']['output'];
  /** Can delete this group */
  canDeleteGroup: Scalars['Boolean']['output'];
  /** Can edit events in group calendar */
  canEditEvents: Scalars['Boolean']['output'];
  /** Can manage group settings */
  canManageGroup: Scalars['Boolean']['output'];
  /** Can add/remove group members */
  canManageMembers: Scalars['Boolean']['output'];
  /** Can manage group owners */
  canManageOwners: Scalars['Boolean']['output'];
  /** Can send messages as the group */
  canSendAsGroup: Scalars['Boolean']['output'];
  /** Can view group calendar */
  canViewCalendar: Scalars['Boolean']['output'];
};

export type GroupStats = {
  __typename?: 'GroupStats';
  /** Number of calendar events */
  eventCount: Scalars['Int']['output'];
  /** Number of guests in this group */
  guestCount: Scalars['Int']['output'];
  /** Total number of members in this group */
  memberCount: Scalars['Int']['output'];
  /** Number of owners in this group */
  ownerCount: Scalars['Int']['output'];
  /** Number of regular members (excluding owners) */
  regularMemberCount: Scalars['Int']['output'];
};

export type GroupSyncInput = {
  forceFull?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  syncCalendars?: InputMaybe<Scalars['Boolean']['input']>;
  syncEvents?: InputMaybe<Scalars['Boolean']['input']>;
  syncMembers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupSyncResult = {
  __typename?: 'GroupSyncResult';
  errorCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['DateTime']['output'];
  syncedCount: Scalars['Int']['output'];
};

export type GroupTeamsInfo = {
  __typename?: 'GroupTeamsInfo';
  isTeamsEnabled: Scalars['Boolean']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  teamsDisplayName?: Maybe<Scalars['String']['output']>;
  teamsInternalId?: Maybe<Scalars['String']['output']>;
  teamsWebUrl?: Maybe<Scalars['String']['output']>;
};

/** The visibility of the group */
export enum GroupVisibility {
  HiddenMembership = 'HIDDEN_MEMBERSHIP',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type HiddenOneDriveItem = {
  __typename?: 'HiddenOneDriveItem';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  hiddenAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type JobInfo = {
  __typename?: 'JobInfo';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type JobStatusPayload = {
  __typename?: 'JobStatusPayload';
  jobId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type KgDelta = {
  __typename?: 'KGDelta';
  addedNodes: Scalars['Int']['output'];
  addedRelationships: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  knowledgeGraphId: Scalars['String']['output'];
  s3DeltaManifest?: Maybe<Scalars['String']['output']>;
};

/** KG Pipeline Job - Tracks 4-module KG Pipeline execution */
export type KgPipelineJob = {
  __typename?: 'KGPipelineJob';
  /** When pipeline completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pipeline configuration options */
  config?: Maybe<Scalars['JSONObject']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Current module (1-4) */
  currentModule: Scalars['Int']['output'];
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Which module failed (1-4) */
  errorModule?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Input path (parsed data source) */
  inputPath: Scalars['String']['output'];
  /** Folder Scanner progress */
  module1Progress?: Maybe<Scalars['JSONObject']['output']>;
  /** Folder Reader progress */
  module2Progress?: Maybe<Scalars['JSONObject']['output']>;
  /** Document Analyzer progress */
  module3Progress?: Maybe<Scalars['JSONObject']['output']>;
  /** Relationship Extractor progress */
  module4Progress?: Maybe<Scalars['JSONObject']['output']>;
  /** Product namespace */
  namespace: Scalars['String']['output'];
  /** Output path in S3 (kg-exports bucket) */
  outputPath?: Maybe<Scalars['String']['output']>;
  /** S3 assets created by this pipeline */
  s3Assets: Array<S3Asset>;
  /** When pipeline execution started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pipeline status */
  status: KgPipelineStatus;
  /** Total documents processed */
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  /** Total KG nodes created */
  totalNodes?: Maybe<Scalars['Int']['output']>;
  /** Total KG relationships created */
  totalRelationships?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** User ID who started the pipeline */
  userId: Scalars['String']['output'];
};

/** Status of a KG Pipeline job */
export enum KgPipelineStatus {
  /** Pipeline cancelled by user */
  Cancelled = 'CANCELLED',
  /** All modules complete */
  Completed = 'COMPLETED',
  /** Pipeline failed */
  Failed = 'FAILED',
  /** Folder Scanner complete */
  Module_1Complete = 'MODULE_1_COMPLETE',
  /** Folder Scanner running */
  Module_1Running = 'MODULE_1_RUNNING',
  /** Folder Reader complete */
  Module_2Complete = 'MODULE_2_COMPLETE',
  /** Folder Reader running */
  Module_2Running = 'MODULE_2_RUNNING',
  /** Document Analyzer complete */
  Module_3Complete = 'MODULE_3_COMPLETE',
  /** Document Analyzer running */
  Module_3Running = 'MODULE_3_RUNNING',
  /** Relationship Extractor running */
  Module_4Running = 'MODULE_4_RUNNING',
  /** Pipeline created but not started */
  Pending = 'PENDING'
}

/** Knowledge Graph source type */
export enum KgSourceType {
  Documents = 'DOCUMENTS',
  Files = 'FILES'
}

/** Knowledge Graph status */
export enum KgStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

/** Knowledge Graph workflow type */
export enum KgType {
  Build = 'BUILD',
  Import = 'IMPORT'
}

export type KnowledgeGraph = {
  __typename?: 'KnowledgeGraph';
  /** Count of related entities */
  _count?: Maybe<KnowledgeGraphCount>;
  /** Identifies the date and time when the workflow was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Completed workflow steps */
  completedSteps: Scalars['Int']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Error details if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Estimated storage size in bytes */
  estimatedStorageSize?: Maybe<Scalars['Int']['output']>;
  /** File size and processing metadata */
  fileMetadata?: Maybe<KnowledgeGraphFileMetadata>;
  folderContentMd5?: Maybe<Scalars['String']['output']>;
  /** Folder snapshot at build time (array of folder info) */
  folderSnapshot?: Maybe<Scalars['JSON']['output']>;
  /** Health status and connectivity metrics */
  healthStatus?: Maybe<KnowledgeGraphHealthStatus>;
  id: Scalars['ID']['output'];
  /** Whether this KG data is live in Neo4j/Weaviate */
  isActive: Scalars['Boolean']['output'];
  /** True when source documents have changed since last build. Uses eagerly loaded data when available to avoid extra DB queries. */
  isStale?: Maybe<Scalars['Boolean']['output']>;
  /** Documents associated with this knowledge graph */
  knowledgeGraphDocuments?: Maybe<Array<KnowledgeGraphDocument>>;
  /** Product namespace */
  namespace: Scalars['String']['output'];
  /** MD5 hash for IMPORT workflows */
  pickleMd5?: Maybe<Scalars['String']['output']>;
  /** Processing time in minutes for completed KGs */
  processingTimeMinutes?: Maybe<Scalars['Int']['output']>;
  /** Flexible progress storage */
  progressData?: Maybe<Scalars['JSONObject']['output']>;
  /** Processing progress percentage (0-100) */
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  /** S3 path to KG pickle file */
  s3PicklePath?: Maybe<Scalars['String']['output']>;
  /** Source type (DOCUMENTS | FILES) */
  sourceType: KgSourceType;
  /** Current workflow status */
  status: KgStatus;
  /** Total nodes in the knowledge graph */
  totalNodes: Scalars['Int']['output'];
  /** Total relationships in the knowledge graph */
  totalRelationships: Scalars['Int']['output'];
  /** Total workflow steps */
  totalSteps: Scalars['Int']['output'];
  triggeredBy?: Maybe<Scalars['String']['output']>;
  /** Usage statistics and analytics */
  usageStats?: Maybe<KnowledgeGraphUsageStats>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Validation/build tree with MD5s */
  validationTree?: Maybe<Scalars['JSONObject']['output']>;
  /** Semantic version (e.g., "1.0.0") */
  version: Scalars['String']['output'];
  /** Workflow type (BUILD | IMPORT) */
  workflowType: KgType;
};

export type KnowledgeGraphCount = {
  __typename?: 'KnowledgeGraphCount';
  /** Number of agents using this knowledge graph */
  agents: Scalars['Int']['output'];
  /** Number of documents linked to this knowledge graph */
  knowledgeGraphDocuments: Scalars['Int']['output'];
};

export type KnowledgeGraphDeletionPreview = {
  __typename?: 'KnowledgeGraphDeletionPreview';
  /** Number of agents that will lose access */
  affectedAgents: Scalars['Int']['output'];
  /** List of dependent KGs that may be affected */
  dependentKGs: Array<Scalars['String']['output']>;
  /** Number of documents to be unlinked */
  documentsToUnlink: Scalars['Int']['output'];
  /** Estimated deletion time in minutes */
  estimatedDeletionTime: Scalars['Int']['output'];
  /** Number of nodes to be deleted */
  nodesToDelete: Scalars['Int']['output'];
  /** Number of relationships to be deleted */
  relationshipsToDelete: Scalars['Int']['output'];
};

export type KnowledgeGraphDocument = {
  __typename?: 'KnowledgeGraphDocument';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  documentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  knowledgeGraph?: Maybe<KnowledgeGraph>;
  knowledgeGraphId: Scalars['String']['output'];
  /** Number of nodes this document contributed */
  nodeCount: Scalars['Int']['output'];
  /** Number of relationships this document contributed */
  relationshipCount: Scalars['Int']['output'];
  /** Identifies the date and time when the object was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type KnowledgeGraphFileMetadata = {
  __typename?: 'KnowledgeGraphFileMetadata';
  /** Total documents processed */
  documentsProcessed: Scalars['Int']['output'];
  /** File format version */
  formatVersion: Scalars['String']['output'];
  /** JSON export file size in bytes */
  jsonFileSize: Scalars['Int']['output'];
  /** Pickle file size in bytes */
  pickleFileSize: Scalars['Int']['output'];
  /** Processing time in minutes */
  processingTimeMinutes: Scalars['Float']['output'];
};

export type KnowledgeGraphHealthStatus = {
  __typename?: 'KnowledgeGraphHealthStatus';
  /** Number of broken relationships */
  brokenRelationships: Scalars['Int']['output'];
  /** List of health check issues */
  issues: Array<Scalars['String']['output']>;
  /** Last health check timestamp */
  lastCheckedAt: Scalars['DateTime']['output'];
  /** Connection latency to Neo4j in milliseconds */
  neo4jLatency: Scalars['Float']['output'];
  /** Number of orphaned nodes */
  orphanedNodes: Scalars['Int']['output'];
  /** Overall health status */
  status: Scalars['String']['output'];
  /** Connection latency to Weaviate in milliseconds */
  weaviateLatency: Scalars['Float']['output'];
};

export type KnowledgeGraphUsageStats = {
  __typename?: 'KnowledgeGraphUsageStats';
  /** Number of active users in last 30 days */
  activeUsers: Scalars['Int']['output'];
  /** Number of agents using this KG */
  agentCount: Scalars['Int']['output'];
  /** Average query response time in milliseconds */
  avgResponseTime: Scalars['Float']['output'];
  /** Last query timestamp */
  lastUsedAt: Scalars['DateTime']['output'];
  /** Storage size in bytes */
  storageSize: Scalars['Int']['output'];
  /** Number of queries performed on this KG */
  totalQueries: Scalars['Int']['output'];
};

export type Language = {
  __typename?: 'Language';
  /** Count of related entities */
  _count?: Maybe<LanguageCount>;
  agents?: Maybe<Array<Agent>>;
  code: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type LanguageCount = {
  __typename?: 'LanguageCount';
  /** Number of agents using this language */
  agents: Scalars['Int']['output'];
};

export type LastMessageInfo = {
  __typename?: 'LastMessageInfo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type LinkMicrosoftAccountInput = {
  useHardcodedTokens?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ManageInvitationInput = {
  action: Scalars['String']['input'];
  invitationId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type MemberTag = {
  __typename?: 'MemberTag';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Message = {
  __typename?: 'Message';
  /** Count of related entities */
  _count?: Maybe<MessageCount>;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomId: Scalars['ID']['output'];
  /** Unified ContentBlock[] timeline per message — discriminated union of text | thinking | tool_use | tool_result | source | mcq | plan_proposal | artifact | analyzing_attachment | skeleton. Replaces ad-hoc thinkingSteps + text on the frontend. Nullable: pre-2026-05-11 rows render via legacyMessageAdapter. */
  contentBlocks?: Maybe<Scalars['JSON']['output']>;
  /** IDs of context documents attached via @ picker */
  contextDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of context forms attached via @ picker */
  contextFormIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional detailed feedback */
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Rating from 1-5 stars */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Response time in milliseconds */
  responseTimeMs?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<MessageRole>;
  sourceDocuments?: Maybe<Array<SourceDocument>>;
  text?: Maybe<Scalars['String']['output']>;
  /** Agent reasoning trail — array of {kind, label, status, timestamp, details?, toolId?} */
  thinkingSteps?: Maybe<Scalars['JSON']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  /** Attachment ID from platform */
  attachmentId: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** MIME type */
  mimeType: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** Attachment type (image, file, etc.) */
  type: Scalars['String']['output'];
  /** When attachment was uploaded */
  uploadedAt: Scalars['String']['output'];
  /** Attachment URL for display */
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageAttachmentInput = {
  /** Platform-specific attachment ID (e.g., Facebook attachment_id) */
  attachmentId: Scalars['String']['input'];
  /** Original filename of the attachment */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of the attachment */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Size of the attachment in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Type of attachment (image, video, file) */
  type: Scalars['String']['input'];
  /** URL of the attachment (if available) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MessageAttachmentOutput = {
  __typename?: 'MessageAttachmentOutput';
  attachmentId: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageBody = {
  __typename?: 'MessageBody';
  /** Message content */
  content?: Maybe<Scalars['String']['output']>;
  /** Message content type (text, html) */
  contentType?: Maybe<Scalars['String']['output']>;
};

export type MessageBodyInput = {
  /** Message content */
  content: Scalars['String']['input'];
  /** Content type (text, html) */
  contentType?: InputMaybe<Scalars['String']['input']>;
};

export type MessageCount = {
  __typename?: 'MessageCount';
  /** Number of source documents linked to this message */
  sourceDocuments: Scalars['Int']['output'];
};

export type MessageData = {
  __typename?: 'MessageData';
  chatRoomId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type MessageFilters = {
  /** Filter by read/unread status */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by message role (USER, ASSISTANT, SYSTEM) */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Search in message content */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MessageFromIdentity = {
  __typename?: 'MessageFromIdentity';
  /** User display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** User ID */
  id?: Maybe<Scalars['String']['output']>;
  /** User type (aadUser, application, etc) */
  userIdentityType?: Maybe<Scalars['String']['output']>;
};

/** Message importance level */
export enum MessageImportance {
  High = 'HIGH',
  Normal = 'NORMAL',
  Urgent = 'URGENT'
}

export type MessagePaginationInput = {
  /** Number of messages per page */
  limit?: Scalars['Int']['input'];
  /** Page number (starts from 1) */
  page?: Scalars['Int']['input'];
};

export type MessagePaginationResponse = {
  __typename?: 'MessagePaginationResponse';
  hasNewer: Scalars['Boolean']['output'];
  hasNext: Scalars['Boolean']['output'];
  hasOlder: Scalars['Boolean']['output'];
  hasPrev: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Message role */
export enum MessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

/** Type of chat message */
export enum MessageType {
  ChatEvent = 'CHAT_EVENT',
  Message = 'MESSAGE',
  Typing = 'TYPING',
  UnknownFutureValue = 'UNKNOWN_FUTURE_VALUE'
}

export type MessageUser = {
  __typename?: 'MessageUser';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftCalendarSettings = {
  __typename?: 'MicrosoftCalendarSettings';
  calendarsCache?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateFormat: Scalars['String']['output'];
  defaultCalendarId?: Maybe<Scalars['String']['output']>;
  defaultCalendarName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCalendarSync?: Maybe<Scalars['DateTime']['output']>;
  microsoftUserId: Scalars['String']['output'];
  timeFormat: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weekStartsOn: Scalars['Int']['output'];
  workingDays: Array<Scalars['Int']['output']>;
  workingHoursEnd: Scalars['String']['output'];
  workingHoursStart: Scalars['String']['output'];
};

export type MicrosoftChannel = {
  __typename?: 'MicrosoftChannel';
  /** When this record was created in our database */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the channel was created */
  createdDateTime: Scalars['DateTime']['output'];
  /** Current user role in this channel (computed field) */
  currentUserRole?: Maybe<Scalars['String']['output']>;
  /** Optional textual description for the channel */
  description?: Maybe<Scalars['String']['output']>;
  /** Channel display name (max 50 characters) */
  displayName: Scalars['String']['output'];
  /** Email address for the channel */
  email?: Maybe<Scalars['String']['output']>;
  /** Microsoft Channel ID as primary key */
  id: Scalars['ID']['output'];
  /** Indicates whether the channel is archived */
  isArchived: Scalars['Boolean']['output'];
  /** Whether current user is owner of this channel (computed field) */
  isCurrentUserOwner?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the channel should be marked as recommended for all team members */
  isFavoriteByDefault: Scalars['Boolean']['output'];
  /** When this record was last synced from Microsoft Graph */
  lastSyncAt: Scalars['DateTime']['output'];
  /** The type of the channel */
  membershipType: ChannelMembershipType;
  /** Summary of channel membership information */
  summary?: Maybe<ChannelSummary>;
  /** ID of the team that owns this channel */
  teamId: Scalars['ID']['output'];
  /** Microsoft Entra tenant ID */
  tenantId?: Maybe<Scalars['String']['output']>;
  /** When this record was last updated in our database */
  updatedAt: Scalars['DateTime']['output'];
  /** Hyperlink to the channel in Microsoft Teams */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftChat = {
  __typename?: 'MicrosoftChat';
  /** Chat avatar/profile image URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  chatType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdDateTime: Scalars['DateTime']['output'];
  discoveredBy?: Maybe<Scalars['String']['output']>;
  /** Computed display title for the chat */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Whether the chat has unread messages */
  hasUnreadMessages?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isHiddenForAllMembers: Scalars['Boolean']['output'];
  /** Formatted timestamp for display */
  lastActivityDisplay?: Maybe<Scalars['String']['output']>;
  /** Last message in the chat */
  lastMessage?: Maybe<ChatLastMessage>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedDateTime?: Maybe<Scalars['DateTime']['output']>;
  onlineMeetingInfo?: Maybe<Scalars['String']['output']>;
  /** Chat participants/members */
  participants?: Maybe<Array<ChatParticipant>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  /** Number of unread messages */
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewpoint?: Maybe<Scalars['String']['output']>;
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftChatMessage = {
  __typename?: 'MicrosoftChatMessage';
  /** Message attachments (JSON) */
  attachments?: Maybe<Scalars['String']['output']>;
  /** Message body content */
  body?: Maybe<MessageBody>;
  /** Whether current user can delete this message */
  canDelete: Scalars['Boolean']['output'];
  /** Whether current user can edit this message */
  canEdit: Scalars['Boolean']['output'];
  /** Whether current user can pin this message */
  canPin: Scalars['Boolean']['output'];
  /** Whether current user can react to this message */
  canReact: Scalars['Boolean']['output'];
  /** Channel ID (for channel messages) */
  channelId?: Maybe<Scalars['String']['output']>;
  /** Channel identity information */
  channelIdentity?: Maybe<ChannelIdentity>;
  /** Chat ID (for chat messages) */
  chatId?: Maybe<Scalars['String']['output']>;
  /** When record was created in database */
  createdAt: Scalars['DateTime']['output'];
  /** When message was created */
  createdDateTime: Scalars['DateTime']['output'];
  /** When message was deleted */
  deletedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Message version identifier */
  etag?: Maybe<Scalars['String']['output']>;
  /** Event details (JSON) */
  eventDetail?: Maybe<Scalars['String']['output']>;
  /** Message sender information */
  from?: Maybe<MessageFromIdentity>;
  /** Microsoft Message ID */
  id: Scalars['ID']['output'];
  /** Message importance level */
  importance: MessageImportance;
  /** Whether this message was sent by the current user */
  isFromCurrentUser: Scalars['Boolean']['output'];
  /** Last edit timestamp */
  lastEditedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Last modification timestamp */
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Message locale */
  locale: Scalars['String']['output'];
  /** Message mentions (JSON) */
  mentions?: Maybe<Scalars['String']['output']>;
  /** Message history (JSON) */
  messageHistory?: Maybe<Scalars['String']['output']>;
  /** Type of message */
  messageType: MessageType;
  /** Policy violations (JSON) */
  policyViolation?: Maybe<Scalars['String']['output']>;
  /** Message reactions (JSON) */
  reactions?: Maybe<Scalars['String']['output']>;
  /** Reply messages to this message */
  replies?: Maybe<Array<MicrosoftChatMessage>>;
  /** Number of replies to this message */
  repliesCount?: Maybe<Scalars['Int']['output']>;
  /** ID of message being replied to */
  replyToId?: Maybe<Scalars['String']['output']>;
  /** Parent message (if this is a reply) */
  replyToMessage?: Maybe<MicrosoftChatMessage>;
  /** Display name of the message sender (for easy UI access) */
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  /** Microsoft User ID of the message sender */
  senderMicrosoftUserId?: Maybe<Scalars['String']['output']>;
  /** Message subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** Message summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Team ID extracted from channelIdentity */
  teamId?: Maybe<Scalars['String']['output']>;
  /** When record was last updated in database */
  updatedAt: Scalars['DateTime']['output'];
  /** Web URL to message */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftGroupMembership = {
  __typename?: 'MicrosoftGroupMembership';
  createdAt: Scalars['DateTime']['output'];
  groupId: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTeam: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  membershipType: Scalars['String']['output'];
  microsoftUserId: Scalars['String']['output'];
  teamDescription?: Maybe<Scalars['String']['output']>;
  teamDisplayName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MicrosoftSyncHistory = {
  __typename?: 'MicrosoftSyncHistory';
  apiCallsCount: Scalars['Int']['output'];
  changes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration: Scalars['Int']['output'];
  errors?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemsFailed: Scalars['Int']['output'];
  itemsSynced: Scalars['Int']['output'];
  microsoftUserId: Scalars['String']['output'];
  status: MicrosoftSyncStatus;
  syncType: MicrosoftSyncType;
};

export enum MicrosoftSyncStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum MicrosoftSyncType {
  All = 'ALL',
  Calendar = 'CALENDAR',
  Groups = 'GROUPS',
  Presence = 'PRESENCE',
  Profile = 'PROFILE'
}

export type MicrosoftTeamsProfile = {
  __typename?: 'MicrosoftTeamsProfile';
  activity?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  joinedTeamsCache?: Maybe<Scalars['String']['output']>;
  lastPresenceUpdate?: Maybe<Scalars['DateTime']['output']>;
  microsoftUserId: Scalars['String']['output'];
  outOfOfficeSettings?: Maybe<Scalars['String']['output']>;
  preferredCommunicationMethod?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftUser = {
  __typename?: 'MicrosoftUser';
  authenticationMethods?: Maybe<Scalars['String']['output']>;
  businessPhones: Array<Scalars['String']['output']>;
  calendarSettings?: Maybe<MicrosoftCalendarSettings>;
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  groupMemberships: Array<MicrosoftGroupMembership>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isMfaCapable: Scalars['Boolean']['output'];
  isMfaRegistered: Scalars['Boolean']['output'];
  isSsprEnabled: Scalars['Boolean']['output'];
  isSsprRegistered: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  microsoftId: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  syncHistory: Array<MicrosoftSyncHistory>;
  syncStatus: MicrosoftSyncStatus;
  teamsProfile?: Maybe<MicrosoftTeamsProfile>;
  tokenScopes: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  userPrincipalName: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type MicrosoftUserSearchResult = {
  __typename?: 'MicrosoftUserSearchResult';
  department?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  userPrincipalName: Scalars['String']['output'];
};

export type MicrosoftUserSyncResult = {
  __typename?: 'MicrosoftUserSyncResult';
  changes: Scalars['String']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  itemsFailed: Scalars['Int']['output'];
  itemsSynced: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Model = {
  __typename?: 'Model';
  /** Unique model code identifier (e.g., "text-embedding-3-small") */
  code: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the model capabilities */
  description?: Maybe<Scalars['String']['output']>;
  /** The fallback model to use if this model fails */
  fallbackModel?: Maybe<Model>;
  /** ID of the fallback model to use if this model fails */
  fallbackModelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the model is currently active and available for use */
  isActive: Scalars['Boolean']['output'];
  /** Whether this is the default model for its type */
  isDefault: Scalars['Boolean']['output'];
  /** Whether this model serves as a fallback for another model */
  isFallback: Scalars['Boolean']['output'];
  /** Type of AI model: EMBEDDING, RERANKING, or LLM */
  modelType: ModelType;
  /** Display name of the model */
  name: Scalars['String']['output'];
  /** Type-specific parameters. Embedding: {dimensions, batchSize}, Reranking: {topK, threshold}, LLM: {temperature, maxTokens, topP, presencePenalty, frequencyPenalty} */
  parameters?: Maybe<Scalars['JSONObject']['output']>;
  /** Models that use this model as their fallback */
  primaryFor?: Maybe<Array<Model>>;
  /** Model provider (e.g., "OpenAI", "BAAI", "Anthropic") */
  provider: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** AI Model type (Embedding, Reranking, or LLM) */
export enum ModelType {
  /** Text embedding model for converting text to vector representations */
  Embedding = 'EMBEDDING',
  /** Large Language Model for text generation and chat */
  Llm = 'LLM',
  /** Reranking model for improving search result relevance */
  Reranking = 'RERANKING'
}

export type MultiUrlSyncResult = {
  __typename?: 'MultiUrlSyncResult';
  agentId?: Maybe<Scalars['String']['output']>;
  articlesCount: Scalars['Int']['output'];
  deletedCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  newCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a member to Microsoft 365 group */
  addGroupMember: OperationResult;
  addMicrosoftChatMember: Scalars['String']['output'];
  /** Add multiple members to a team tag (bulk operation) */
  addMultipleTagMembers: OperationResult;
  /** Add a member to a team tag */
  addTagMember: TagMember;
  /** Add a member directly to a team (requires owner permissions) */
  addTeamMemberDirect: TeamMember;
  /** Analyze message for analytical intent and generate query suggestions */
  analyzeAnalyticalIntent: ClickHouseIntentAnalysisResponse;
  /** Append an event to task audit log */
  appendTaskEvent: TaskEvent;
  /** Archive a team with database sync */
  archiveTeam: OperationResult;
  /** Assign a tag to a conversation */
  assignConversationTag: ConversationTagAssignment;
  /** Assign a label to a customer (multiple labels allowed) */
  assignCustomerLabel: Scalars['Boolean']['output'];
  buildKnowledgeGraph: JobStatusPayload;
  /** Bulk assign tags to multiple conversations */
  bulkAssignConversationTags: BulkTagOperationResult;
  /** Assign a label to multiple customers (multiple labels allowed) */
  bulkAssignCustomerLabel: BulkOperationResult;
  /** Cancel a running pipeline job */
  cancelKGPipelineJob: KgPipelineJob;
  /** Cancel a task */
  cancelTask: TaskState;
  cancelUehSyncJob: Scalars['Boolean']['output'];
  /** Claim a lease on a task (for workers) */
  claimTaskLease: TaskState;
  /** Clean up orphaned hidden items. Removes records for paths that no longer exist in OneDrive. */
  cleanupOrphanedHiddenItems: Scalars['Int']['output'];
  /** Close a conversation */
  closeConversation: Scalars['Boolean']['output'];
  /** Complete a task successfully */
  completeTask: TaskState;
  consumePlanProposal: BatchPayload;
  countKnowledgeGraphDocuments: Scalars['Int']['output'];
  countUsers: Scalars['Int']['output'];
  createAgent: Agent;
  createAgentFolder: AgentFolder;
  createAgentSyncConfig: AgentSyncConfig;
  createAgentTool: AgentTool;
  /** Create a new API key (admin only). The raw key is only shown once! */
  createApiKey: CreateApiKeyResponse;
  createArtifact: Artifact;
  createChannel: ChannelResponse;
  createChatRoom: ChatRoom;
  /** Create a new conversation note */
  createConversationNote: ConversationNote;
  /** Create a new conversation tag */
  createConversationTag: ConversationTag;
  /** Create a new customer label */
  createCustomerLabel: CustomerLabelInfo;
  createDocument: Document;
  createDocumentVersion: Scalars['Boolean']['output'];
  createFacebookChannel: FacebookChannelResult;
  createFieldCategory: FieldCategory;
  createFieldDefinition: FieldDefinition;
  createFolder: Folder;
  createKGDelta: KgDelta;
  /** Create a new KGPipelineJob */
  createKGPipelineJob: KgPipelineJob;
  /** Create a new Knowledge Graph */
  createKnowledgeGraph: KnowledgeGraph;
  createKnowledgeGraphDocument: KnowledgeGraphDocument;
  createLanguage: Language;
  createMessage: Message;
  /** Create a new Microsoft calendar */
  createMicrosoftCalendar: EventCalendar;
  /** Create a new channel in a team with database sync */
  createMicrosoftChannel: MicrosoftChannel;
  createMicrosoftChat: MicrosoftChat;
  /** Create a new Microsoft calendar event */
  createMicrosoftEvent: Event;
  /** Create a new Microsoft 365 group */
  createMicrosoftGroup: Group;
  createMicrosoftUser: MicrosoftUser;
  createModel: Model;
  /** Create new conversation in the same conversationGroup */
  createNewConversation: Scalars['String']['output'];
  createOneUrlConfig: UrlConfig;
  createOriginalDocument: OriginalDocument;
  createPackage: PackageResponse;
  createParsedDocument: ParsedDocument;
  createPlanProposal: PlanProposal;
  createPlatform: PlatformResponse;
  createPlatformApp: PlatformAppResponse;
  /** Create a new S3Asset */
  createS3Asset: S3Asset;
  createSourceDocument: SourceDocument;
  createSyncArticle: SyncArticle;
  /** Create a new checkpoint */
  createTaskCheckpoint: TaskCheckpoint;
  /** Create a new task state */
  createTaskState: TaskState;
  /** Create a new team (async - use getTeams to see result) */
  createTeam: OperationResult;
  /** Create a new team tag with optional initial members */
  createTeamTag: TeamworkTag;
  /** Create a calendar event for Teams group (Teams Calendar tab functionality) */
  createTeamsCalendarEvent: Event;
  createTool: Tool;
  createUehArticle: UehArticle;
  createUrlConfig: UrlConfig;
  createUser: User;
  createUserAgent: Agent;
  createUserDynamicFields: UserDynamicFields;
  createUserWorkflow: Workflow;
  createWorkflow: Workflow;
  deleteAgent: Agent;
  deleteAgentFolder: AgentFolder;
  deleteAgentSyncConfig: AgentSyncConfig;
  deleteAgentTool: AgentTool;
  /** Delete ALL chats for the current user - DANGEROUS operation! */
  deleteAllMicrosoftChats: Scalars['String']['output'];
  /** Delete an API key permanently (admin only) */
  deleteApiKey: ApiKeyMutationResponse;
  deleteArtifact: Artifact;
  deleteChannel: ChannelResponse;
  deleteChatRoom: ChatRoom;
  /** Delete a conversation note */
  deleteConversationNote: Scalars['Boolean']['output'];
  /** Delete a conversation tag */
  deleteConversationTag: Scalars['Boolean']['output'];
  deleteDocument: Document;
  deleteFieldCategory: FieldCategory;
  deleteFieldDefinition: FieldDefinition;
  deleteFolder: Folder;
  /** Delete a KGPipelineJob */
  deleteKGPipelineJob: KgPipelineJob;
  /** Delete a Knowledge Graph */
  deleteKnowledgeGraph: KnowledgeGraph;
  deleteKnowledgeGraphDocument: KnowledgeGraphDocument;
  /** Batch delete Knowledge Graphs with saga support and impact validation */
  deleteKnowledgeGraphsBatch: BatchPayload;
  deleteLanguage: Language;
  deleteManyAgentFolders: BatchPayload;
  deleteManyAgentSyncConfigs: BatchPayload;
  deleteManyAgentTools: BatchPayload;
  deleteManyAgents: BatchPayload;
  deleteManyArtifacts: BatchPayload;
  deleteManyChatRooms: BatchPayload;
  deleteManyDocuments: BatchPayload;
  deleteManyFolders: BatchPayload;
  deleteManyKnowledgeGraphDocuments: BatchPayload;
  /** Delete multiple Knowledge Graphs */
  deleteManyKnowledgeGraphs: BatchPayload;
  deleteManyLanguages: BatchPayload;
  deleteManyMessages: BatchPayload;
  deleteManyModels: BatchPayload;
  deleteManyParsedDocuments: BatchPayload;
  deleteManySourceDocuments: BatchPayload;
  deleteManyTools: BatchPayload;
  deleteManyUehArticles: BatchPayload;
  deleteManyUsers: BatchPayload;
  deleteManyWorkflows: BatchPayload;
  deleteMessage: Message;
  /** Delete a Microsoft calendar */
  deleteMicrosoftCalendar: OperationResult;
  /** Delete a channel with database sync */
  deleteMicrosoftChannel: OperationResult;
  /** Delete a Microsoft Teams channel message (hard delete - removes completely) */
  deleteMicrosoftChannelMessage: ChannelMessageOperationResult;
  deleteMicrosoftChat: Scalars['Boolean']['output'];
  /** Delete a Microsoft calendar event */
  deleteMicrosoftEvent: OperationResult;
  deleteModel: Model;
  deleteOneFormParsedContent: FormParsedContent;
  deleteOneUrlConfig: UrlConfig;
  deletePackage: PackageResponse;
  deleteParsedDocument: ParsedDocument;
  deletePlatform: PlatformResponse;
  deletePlatformApp: PlatformAppResponse;
  /** Delete an S3Asset */
  deleteS3Asset: S3Asset;
  deleteSourceDocument: SourceDocument;
  deleteSyncArticle?: Maybe<SyncArticle>;
  /** Delete a task_states row by taskId. Refuses non-terminal rows (RUNNING / PENDING / QUEUED / RETRYING) unless force=true. With force=true the row is flipped to CANCELLED first then deleted, so any in-flight worker consume short-circuits cleanly. Replaces the old generic resolver (now `forceDeleteTaskStateRaw`) which would hard-delete RUNNING rows and leave unacked RabbitMQ messages — see plan layer B (2026-05-10). */
  deleteTaskState: TaskState;
  /** Delete team permanently with database cleanup */
  deleteTeam: OperationResult;
  /** Delete a team tag permanently */
  deleteTeamTag: OperationResult;
  /** Delete all terminal tasks (COMPLETED/FAILED/CANCELLED) */
  deleteTerminalTasks: Scalars['Int']['output'];
  deleteTool: Tool;
  deleteUehArticle: UehArticle;
  deleteUser: User;
  deleteUserDynamicFields: UserDynamicFields;
  deleteUserWorkflow: Scalars['Boolean']['output'];
  deleteWorkflow: Workflow;
  /** Disable OneDrive sync for a realm (admin only). Sets syncStatus to DISABLED. */
  disableOneDriveSync: OneDriveSyncToggleResult;
  /** Disable a user: sets Keycloak enabled=false, revokes sessions, sets DB status=blocked */
  disableUser: User;
  duplicateWorkflow: Workflow;
  /** Enable OneDrive sync for a realm (admin only). Sets syncStatus to IDLE. */
  enableOneDriveSync: OneDriveSyncToggleResult;
  /** Enable a user: sets Keycloak enabled=true, sets DB status=active */
  enableUser: User;
  /** Ensure a KG Agent exists for a given user+namespace and sync its root folders */
  ensureKgAgent: Agent;
  /** Execute a ClickHouse analytical query */
  executeClickHouseQuery: ClickHouseQueryResponse;
  exportArticlesToDocuments: ExportToDocumentsResultObject;
  /** Mark a task as failed */
  failTask: TaskState;
  /** Find existing active conversation or create new one for specific user and channel */
  findOrCreateConversationWithChannel: ConversationWithChannelResult;
  /** Force clear ALL token caches (memory + database) for current user (debugging) */
  forceClearMicrosoftTokenCaches: Scalars['Boolean']['output'];
  /** BREAK-GLASS: hard-delete a task_states row via raw Prisma args, bypassing the safe deleteTaskState path. Admin only. Use only when the safe path is blocked by a stuck non-terminal row that cannot be force-cancelled (e.g., DB-level row corruption). */
  forceDeleteTaskStateRaw: TaskState;
  /** Force resync team members to fix role issues */
  forceResyncTeamMembers: OperationResult;
  generate: GenerationPayload;
  generateTeamsAppPackage: GenerateTeamsAppResponse;
  /** Generate intelligent query suggestions for a database */
  getClickHouseQuerySuggestions: ClickHouseSuggestionsResponse;
  handleZaloOAuthCallback: ZaloChannelResponse;
  /** Hide an OneDrive item (file or folder) */
  hideOneDriveItem: HiddenOneDriveItem;
  initializeDefaultUehConfig: UrlConfig;
  /** Invalidate cached schema data for a database */
  invalidateClickHouseCache: Scalars['Boolean']['output'];
  /** Leave a team (current user leaves the team) */
  leaveTeam: OperationResult;
  linkDocumentsToKnowledgeGraph: BatchPayload;
  linkMicrosoftAccount: MicrosoftUser;
  login: AuthResponseWithUser;
  loginAdmin: AuthResponse;
  loginAnonymous: AuthResponse;
  loginWithMicrosoft: MicrosoftUser;
  /** Approve or reject a team invitation (Owner only) */
  manageTeamInvitation: AddMemberResult;
  /** Mark conversation as read */
  markConversationAsRead: Scalars['Boolean']['output'];
  /** Mark a specific message as read */
  markMessageAsRead: Scalars['Boolean']['output'];
  /** Move a FormTemplate to a different FormFolder within the same namespace. Preserves FormTemplate.id (no cascade on FormParsedContent / Message.contextFormIds). 404 on cross-tenant target folder, 409 (ConflictException) if the target folder already contains a template with the same basename. */
  moveFormTemplateToFolder: FormTemplate;
  /** Pin or unpin a conversation note */
  pinConversationNote: ConversationNote;
  /** Pin a message in Microsoft Teams channel (limited support - may not show in Teams UI) */
  pinMicrosoftChannelMessage: ChannelMessageOperationResult;
  /** Pin a message in Microsoft Teams chat */
  pinMicrosoftChatMessage: ChannelMessageOperationResult;
  pingFacebookChannel: FacebookConnectionHealthDto;
  pingZaloChannel: ZaloConnectionHealthDto;
  purgeDocumentVersions: Scalars['Int']['output'];
  /** Record a DLQ entry */
  recordDlqFailure: DlqRecord;
  recreateAgent: AgentRecreationResult;
  refreshFacebookChannelToken: Scalars['Boolean']['output'];
  refreshToken: AuthResponseWithUser;
  refreshZaloChannelToken: Scalars['Boolean']['output'];
  register: AuthResponseWithUser;
  removeChannelFromApp: RemoveChannelFromAppResponse;
  /** Remove a tag from a conversation */
  removeConversationTag: Scalars['Boolean']['output'];
  /** Remove a label from a customer */
  removeCustomerLabel: Scalars['Boolean']['output'];
  /** Remove a member from Microsoft 365 group */
  removeGroupMember: OperationResult;
  removeMicrosoftChatMember: Scalars['Boolean']['output'];
  /** Remove multiple members from a team tag (bulk operation) */
  removeMultipleTagMembers: OperationResult;
  /** Remove a member from a team tag */
  removeTagMember: OperationResult;
  /** Remove a member from a team with database sync */
  removeTeamMember: OperationResult;
  /** Renew a lease on a task */
  renewTaskLease: TaskState;
  /** Reply to a message in a Microsoft Teams channel (threading support) */
  replyToMicrosoftChannelMessage: MicrosoftChatMessage;
  /** Resolve a DLQ record */
  resolveDlqRecord: DlqRecord;
  /** Respond to a Microsoft calendar event invitation */
  respondToMicrosoftEvent: OperationResult;
  /** Restore a soft-deleted Agent. Clears deletedAt and restores the original name. Cascades restore to Workflow, KG, AgentSyncConfig, ApiKey, UehArticle. */
  restoreAgent: Agent;
  restoreChannel: ChannelResponse;
  /** Restore a soft-deleted FormTemplate by clearing `meta.deleted` and `meta.deletedAt`. Idempotent on already-active rows. Tenant-guarded; 404 on cross-tenant id. */
  restoreFormTemplate: FormTemplate;
  /** Revoke an API key (admin only, cannot be undone) */
  revokeApiKey: ApiKeyMutationResponse;
  saveTeamsChannels: SaveTeamsChannelsResponse;
  /** Send a message to a Microsoft Teams channel */
  sendMicrosoftChannelMessage: MicrosoftChatMessage;
  /** Send a message to a Microsoft Teams chat */
  sendMicrosoftChatMessage: MicrosoftChatMessage;
  sendOutboundMessage: SendOutboundMessageResponse;
  sendOutboundMessageWithFiles: SendOutboundMessageWithFilesResponse;
  /** Set a Knowledge Graph as the active version for its namespace */
  setActiveKnowledgeGraph: KnowledgeGraph;
  setDefaultWorkflow: Workflow;
  /** Add a reaction to a Microsoft Teams chat message */
  setMicrosoftChatMessageReaction: ChannelMessageOperationResult;
  /** Add a reaction to a Microsoft Teams channel message */
  setMicrosoftMessageReaction: ChannelMessageOperationResult;
  /** Add a reaction to a Microsoft Teams message reply */
  setMicrosoftMessageReplyReaction: ChannelMessageOperationResult;
  softDeleteDocument: Document;
  softDeleteFolder: Folder;
  /** Soft-delete a FormTemplate by flipping `meta.deleted=true` and stamping `meta.deletedAt`. Identified by FormTemplate.id (UUID) — basenames can collide across FormFolders, so id is the only deterministic key. Idempotent. 404 (NotFoundException) on missing or cross-tenant id. */
  softDeleteFormTemplate: FormTemplate;
  /** Soft delete a Microsoft Teams channel message (hides from view but keeps in system) */
  softDeleteMicrosoftChannelMessage: ChannelMessageOperationResult;
  /** Soft delete a Microsoft Teams chat message */
  softDeleteMicrosoftChatMessage: ChannelMessageOperationResult;
  /** Soft delete a Microsoft Teams message reply */
  softDeleteMicrosoftMessageReply: ChannelMessageOperationResult;
  startConnectionTestJob: Scalars['String']['output'];
  startMultiUrlSyncJob: Scalars['String']['output'];
  startUehSync: Scalars['Boolean']['output'];
  startUehSyncForDate: Scalars['Boolean']['output'];
  startUehSyncForDateRange: Scalars['Boolean']['output'];
  startUehSyncJob: Scalars['String']['output'];
  startUehSyncJobForDate: Scalars['String']['output'];
  startUehSyncJobForDateRange: Scalars['String']['output'];
  syncAndUpdateAgent: Scalars['String']['output'];
  /** Synchronize groups from Microsoft Graph */
  syncMicrosoftGroups: GroupSyncResult;
  syncMicrosoftProfile: MicrosoftUserSyncResult;
  syncMicrosoftProfileById: MicrosoftUserSyncResult;
  syncMultipleUrls: Array<SyncUrlResult>;
  syncUrlConfig: SyncUrlResult;
  syncUrlConfigDateRange: SyncUrlDateRangeResult;
  syncUrlConfigForDate: SyncUrlResult;
  /** Test AddTeamMemberInput type */
  testMemberInput: Scalars['String']['output'];
  /** Test UpdateTeamInput type */
  testTeamInput: Scalars['String']['output'];
  toggleActiveApp: Scalars['Boolean']['output'];
  toggleAgentActive: Agent;
  toggleAgentAssignment: Channel;
  toggleAgentHidden: Agent;
  toggleChatRoomAutoReply: ChatRoom;
  togglePackageAssignment: Channel;
  triggerFacebookPing: FacebookConnectionSummaryDto;
  triggerFacebookTokenRefresh: FacebookTokenRefreshResultDto;
  triggerZaloPing: ZaloConnectionSummaryDto;
  triggerZaloTokenRefresh: ZaloTokenRefreshResultDto;
  /** Unarchive a team with database sync */
  unarchiveTeam: OperationResult;
  /** Restore a soft deleted Microsoft Teams channel message */
  undoSoftDeleteMicrosoftChannelMessage: ChannelMessageOperationResult;
  /** Restore a soft deleted Microsoft Teams chat message */
  undoSoftDeleteMicrosoftChatMessage: ChannelMessageOperationResult;
  /** Restore a soft deleted Microsoft Teams message reply */
  undoSoftDeleteMicrosoftMessageReply: ChannelMessageOperationResult;
  /** Unhide all OneDrive items for the current user. Returns count of unhidden items. */
  unhideAllOneDriveItems: Scalars['Int']['output'];
  /** Unhide a previously hidden OneDrive item */
  unhideOneDriveItem: Scalars['Boolean']['output'];
  unlinkMicrosoftAccount: Scalars['Boolean']['output'];
  /** Unpin a message from Microsoft Teams chat */
  unpinMicrosoftChatMessage: ChannelMessageOperationResult;
  /** Remove a reaction from a Microsoft Teams chat message */
  unsetMicrosoftChatMessageReaction: ChannelMessageOperationResult;
  /** Remove a reaction from a Microsoft Teams channel message */
  unsetMicrosoftMessageReaction: ChannelMessageOperationResult;
  /** Remove a reaction from a Microsoft Teams message reply */
  unsetMicrosoftMessageReplyReaction: ChannelMessageOperationResult;
  updateAgent: Agent;
  /** Update agent data freshness status */
  updateAgentDataStatus: Agent;
  updateAgentFolder: AgentFolder;
  updateAgentFolders: Agent;
  updateAgentSyncConfig: AgentSyncConfig;
  updateAgentTool: AgentTool;
  updateAgentsWithSyncedData: Array<UpdateResult>;
  /** Update an API key (admin only) */
  updateApiKey: ApiKey;
  /** Update API key last used timestamp */
  updateApiKeyLastUsed: Scalars['Boolean']['output'];
  updateArtifact: Artifact;
  updateChannel: ChannelResponse;
  updateChatRoom: ChatRoom;
  updateChatbot: UpdateResult;
  /** Update an existing conversation note */
  updateConversationNote: ConversationNote;
  /** Update an existing conversation tag */
  updateConversationTag: ConversationTag;
  /** Update a single customer field value */
  updateCustomerField: Scalars['Boolean']['output'];
  /** Batch update multiple customer fields */
  updateCustomerFields: Scalars['Boolean']['output'];
  /** Update an existing customer label */
  updateCustomerLabel: CustomerLabelInfo;
  /** Update customer lifecycle stage */
  updateCustomerStage: Scalars['Boolean']['output'];
  updateDocument: Document;
  updateFieldCategory: FieldCategory;
  updateFieldDefinition: FieldDefinition;
  updateFolder: Folder;
  /** Update a KGPipelineJob */
  updateKGPipelineJob: KgPipelineJob;
  /** Update a Knowledge Graph */
  updateKnowledgeGraph: KnowledgeGraph;
  updateKnowledgeGraphDocument: KnowledgeGraphDocument;
  /** Update Knowledge Graph metadata and progress information */
  updateKnowledgeGraphMetadata: KnowledgeGraph;
  updateLanguage: Language;
  updateManySyncArticles: BatchPayload;
  /** Update a team member role with database sync */
  updateMemberRole: TeamMember;
  updateMessage: Message;
  /** Update Microsoft calendar properties */
  updateMicrosoftCalendar: EventCalendar;
  /** Update channel properties with database sync */
  updateMicrosoftChannel: MicrosoftChannel;
  /** Update content of a Microsoft Teams channel message */
  updateMicrosoftChannelMessage: MicrosoftChatMessage;
  /** Update content of a Microsoft Teams channel reply message */
  updateMicrosoftChannelReply: MicrosoftChatMessage;
  updateMicrosoftChat: MicrosoftChat;
  /** Update content of a Microsoft Teams chat message */
  updateMicrosoftChatMessage: MicrosoftChatMessage;
  /** Update content of a Microsoft Teams chat reply message */
  updateMicrosoftChatReply: MicrosoftChatMessage;
  /** Update an existing Microsoft calendar event */
  updateMicrosoftEvent: Event;
  /** Update an existing Microsoft 365 group */
  updateMicrosoftGroup: Group;
  updateModel: Model;
  updateMyUser: User;
  updateOneUrlConfig: UrlConfig;
  updatePackage: PackageResponse;
  updatePackageStatus: PackageResponse;
  updateParsedDocument: ParsedDocument;
  updatePlatform: PlatformResponse;
  /** Update an S3Asset */
  updateS3Asset: S3Asset;
  updateSourceDocument: SourceDocument;
  updateSyncArticle: SyncArticle;
  /** Update task progress */
  updateTaskProgress: TaskState;
  /** Update a task state */
  updateTaskState: TaskState;
  /** Update team properties with database sync */
  updateTeam: Team;
  /** Update an existing team tag */
  updateTeamTag: TeamworkTag;
  updateTeamsChannelAgent: UpdateChannelAgentResponse;
  updateTool: Tool;
  updateUehArticle: UehArticle;
  updateUser: User;
  updateUserAgent: Agent;
  updateUserDynamicFields: UserDynamicFields;
  updateUserFieldValue: UserDynamicFields;
  updateUserWorkflow: Workflow;
  updateWorkflow: Workflow;
  upsertOneFormFolder: FormFolder;
  upsertOneFormParsedContent: FormParsedContent;
  upsertOneFormTemplate: FormTemplate;
  upsertRetentionSettings: RetentionSettings;
  upsertUserDynamicFields: UserDynamicFields;
  validateUrlConfig: ValidateUrlResult;
  webhookCreateSocialUser: SocialUserData;
  webhookDecrementUserQuota: ChannelUserQuota;
  webhookFindOrCreateChatRoom: ChatRoomData;
  webhookSaveMessage: MessageData;
  webhookUpdateChannelTokens: Scalars['Boolean']['output'];
};


export type MutationAddGroupMemberArgs = {
  input: AddGroupMemberInput;
};


export type MutationAddMicrosoftChatMemberArgs = {
  chatId: Scalars['String']['input'];
  input: AddChatMemberInput;
};


export type MutationAddMultipleTagMembersArgs = {
  input: BulkAddTagMembersInput;
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAddTagMemberArgs = {
  input: AddTagMemberInput;
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAddTeamMemberDirectArgs = {
  input: AddTeamMemberInput;
  teamId: Scalars['ID']['input'];
};


export type MutationAnalyzeAnalyticalIntentArgs = {
  message: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAppendTaskEventArgs = {
  eventPayload?: InputMaybe<Scalars['JSONObject']['input']>;
  eventType: Scalars['String']['input'];
  taskStateId: Scalars['String']['input'];
};


export type MutationArchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignConversationTagArgs = {
  input: AssignTagInput;
};


export type MutationAssignCustomerLabelArgs = {
  input: AssignCustomerLabelInput;
};


export type MutationBuildKnowledgeGraphArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationBulkAssignConversationTagsArgs = {
  input: BulkTagOperationInput;
};


export type MutationBulkAssignCustomerLabelArgs = {
  customerIds: Array<Scalars['String']['input']>;
  labelId: Scalars['String']['input'];
};


export type MutationCancelKgPipelineJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCancelTaskArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type MutationCancelUehSyncJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationClaimTaskLeaseArgs = {
  durationMs: Scalars['Int']['input'];
  leaseOwner: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationCleanupOrphanedHiddenItemsArgs = {
  validPaths: Array<Scalars['String']['input']>;
};


export type MutationCloseConversationArgs = {
  chatRoomId: Scalars['String']['input'];
  closedBy: Scalars['String']['input'];
};


export type MutationCompleteTaskArgs = {
  resultData?: InputMaybe<Scalars['JSONObject']['input']>;
  taskId: Scalars['String']['input'];
};


export type MutationConsumePlanProposalArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCountKnowledgeGraphDocumentsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationCountUsersArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationCreateAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateAgentFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateAgentSyncConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateAgentToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateArtifactArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateChannelArgs = {
  input: CreateChannelDto;
};


export type MutationCreateChatRoomArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateConversationNoteArgs = {
  input: CreateConversationNoteInput;
};


export type MutationCreateConversationTagArgs = {
  input: CreateConversationTagInput;
};


export type MutationCreateCustomerLabelArgs = {
  input: CreateCustomerLabelInput;
};


export type MutationCreateDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateDocumentVersionArgs = {
  assets?: InputMaybe<Scalars['JSON']['input']>;
  changeType: Scalars['String']['input'];
  changedBy: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  md5Hash: Scalars['String']['input'];
  regions?: InputMaybe<Scalars['JSON']['input']>;
  s3MarkdownPath?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFacebookChannelArgs = {
  input: CreateFacebookChannelDto;
};


export type MutationCreateFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateKgDeltaArgs = {
  addedNodes: Scalars['Int']['input'];
  addedRelationships: Scalars['Int']['input'];
  knowledgeGraphId: Scalars['String']['input'];
  s3DeltaManifest?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateKgPipelineJobArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateKnowledgeGraphArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateKnowledgeGraphDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateLanguageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateMessageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateMicrosoftCalendarArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateMicrosoftChannelArgs = {
  input: CreateChannelInput;
  teamId: Scalars['ID']['input'];
};


export type MutationCreateMicrosoftChatArgs = {
  input: CreateMicrosoftChatInput;
};


export type MutationCreateMicrosoftEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateMicrosoftGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateMicrosoftUserArgs = {
  input: CreateMicrosoftUserInput;
};


export type MutationCreateModelArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateNewConversationArgs = {
  currentChatRoomId: Scalars['String']['input'];
};


export type MutationCreateOneUrlConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateOriginalDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreatePackageArgs = {
  input: CreatePackageDto;
};


export type MutationCreateParsedDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreatePlanProposalArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreatePlatformArgs = {
  input: CreatePlatformDto;
};


export type MutationCreatePlatformAppArgs = {
  input: CreatePlatformAppDto;
};


export type MutationCreateS3AssetArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateSourceDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateSyncArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateTaskCheckpointArgs = {
  checkpointData: Scalars['JSONObject']['input'];
  itemsProcessed: Scalars['Int']['input'];
  itemsTotal?: InputMaybe<Scalars['Int']['input']>;
  progressPercentage: Scalars['Int']['input'];
  s3CheckpointPath?: InputMaybe<Scalars['String']['input']>;
  taskStateId: Scalars['String']['input'];
};


export type MutationCreateTaskStateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamTagArgs = {
  input: CreateTagInput;
  teamId: Scalars['ID']['input'];
};


export type MutationCreateTeamsCalendarEventArgs = {
  input: TeamsCalendarEventInput;
};


export type MutationCreateToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateUehArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateUrlConfigArgs = {
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  displayUrl: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateUserAgentArgs = {
  createAgentDto: CreateAgentDto;
};


export type MutationCreateUserDynamicFieldsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationCreateUserWorkflowArgs = {
  input: CreateWorkflowDto;
};


export type MutationCreateWorkflowArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteAgentFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteAgentSyncConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteAgentToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArtifactArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatRoomArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteConversationNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteConversationTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  args: Scalars['JSONObject']['input'];
  cascadeSyncArticle?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteKgPipelineJobArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteKnowledgeGraphArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteKnowledgeGraphDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteKnowledgeGraphsBatchArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteLanguageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyAgentFoldersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyAgentSyncConfigsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyAgentToolsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyAgentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyArtifactsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyChatRoomsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
  cascadeSyncArticle?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteManyFoldersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyKnowledgeGraphDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyKnowledgeGraphsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyLanguagesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyMessagesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyModelsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyParsedDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManySourceDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyToolsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyUehArticlesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyUsersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteManyWorkflowsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteMessageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteMicrosoftCalendarArgs = {
  calendarId: Scalars['String']['input'];
};


export type MutationDeleteMicrosoftChannelArgs = {
  channelId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationDeleteMicrosoftChatArgs = {
  chatId: Scalars['String']['input'];
};


export type MutationDeleteMicrosoftEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationDeleteModelArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteOneFormParsedContentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteOneUrlConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeletePackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteParsedDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeletePlatformArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlatformAppArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteS3AssetArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteSourceDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteSyncArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteTaskStateArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['String']['input'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamTagArgs = {
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTerminalTasksArgs = {
  namespace?: InputMaybe<Scalars['String']['input']>;
  olderThanDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteUehArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteUserDynamicFieldsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDeleteUserWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationDisableOneDriveSyncArgs = {
  realm: Scalars['String']['input'];
};


export type MutationDisableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDuplicateWorkflowArgs = {
  id: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};


export type MutationEnableOneDriveSyncArgs = {
  realm: Scalars['String']['input'];
};


export type MutationEnableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationEnsureKgAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationExecuteClickHouseQueryArgs = {
  database?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportArticlesToDocumentsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  urlConfigId: Scalars['String']['input'];
};


export type MutationFailTaskArgs = {
  errorData: Scalars['JSONObject']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationFindOrCreateConversationWithChannelArgs = {
  input: ConversationWithChannelInput;
};


export type MutationForceDeleteTaskStateRawArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationForceResyncTeamMembersArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationGenerateArgs = {
  input: GenerateInput;
};


export type MutationGenerateTeamsAppPackageArgs = {
  platformAppId: Scalars['ID']['input'];
};


export type MutationGetClickHouseQuerySuggestionsArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  database: Scalars['String']['input'];
  maxSuggestions?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHandleZaloOAuthCallbackArgs = {
  input: ZaloOAuthCallbackDto;
};


export type MutationHideOneDriveItemArgs = {
  path: Scalars['String']['input'];
};


export type MutationInitializeDefaultUehConfigArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInvalidateClickHouseCacheArgs = {
  database: Scalars['String']['input'];
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationLinkDocumentsToKnowledgeGraphArgs = {
  actorUserId: Scalars['String']['input'];
  documents: Array<Scalars['JSONObject']['input']>;
  knowledgeGraphId: Scalars['String']['input'];
};


export type MutationLinkMicrosoftAccountArgs = {
  input?: InputMaybe<LinkMicrosoftAccountInput>;
};


export type MutationLoginArgs = {
  input: LoginDto;
};


export type MutationLoginAdminArgs = {
  input: LoginDto;
};


export type MutationLoginWithMicrosoftArgs = {
  input?: InputMaybe<LinkMicrosoftAccountInput>;
};


export type MutationManageTeamInvitationArgs = {
  input: ManageInvitationInput;
};


export type MutationMarkConversationAsReadArgs = {
  conversationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationMarkMessageAsReadArgs = {
  messageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationMoveFormTemplateToFolderArgs = {
  folderId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationPinConversationNoteArgs = {
  input: PinNoteInput;
};


export type MutationPinMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationPinMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationPingFacebookChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationPingZaloChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationPurgeDocumentVersionsArgs = {
  retentionDays?: Scalars['Int']['input'];
};


export type MutationRecordDlqFailureArgs = {
  failureReason: Scalars['String']['input'];
  originalMessage: Scalars['JSONObject']['input'];
  originalQueue: Scalars['String']['input'];
  taskStateId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecreateAgentArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationRefreshFacebookChannelTokenArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenDto;
};


export type MutationRefreshZaloChannelTokenArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationRegisterArgs = {
  input: RegisterDto;
};


export type MutationRemoveChannelFromAppArgs = {
  input: RemoveChannelFromAppDto;
};


export type MutationRemoveConversationTagArgs = {
  input: RemoveTagInput;
};


export type MutationRemoveCustomerLabelArgs = {
  labelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveGroupMemberArgs = {
  input: RemoveGroupMemberInput;
};


export type MutationRemoveMicrosoftChatMemberArgs = {
  chatId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type MutationRemoveMultipleTagMembersArgs = {
  input: BulkRemoveTagMembersInput;
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveTagMemberArgs = {
  membershipId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  membershipId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRenewTaskLeaseArgs = {
  durationMs: Scalars['Int']['input'];
  leaseOwner: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationReplyToMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  input: CreateChannelReplyInput;
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationResolveDlqRecordArgs = {
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  resolvedBy: Scalars['String']['input'];
};


export type MutationRespondToMicrosoftEventArgs = {
  input: RespondToEventInput;
};


export type MutationRestoreAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreFormTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveTeamsChannelsArgs = {
  input: SaveTeamsChannelsInput;
};


export type MutationSendMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  input: SendChannelMessageInput;
  teamId: Scalars['String']['input'];
};


export type MutationSendMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  input: CreateMicrosoftChatMessageInput;
};


export type MutationSendOutboundMessageArgs = {
  input: SendOutboundMessageInput;
};


export type MutationSendOutboundMessageWithFilesArgs = {
  input: SendOutboundMessageWithFilesInput;
};


export type MutationSetActiveKnowledgeGraphArgs = {
  knowledgeGraphId: Scalars['String']['input'];
};


export type MutationSetDefaultWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetMicrosoftChatMessageReactionArgs = {
  chatId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
};


export type MutationSetMicrosoftMessageReactionArgs = {
  channelId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationSetMicrosoftMessageReplyReactionArgs = {
  channelId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationSoftDeleteDocumentArgs = {
  cascadeSyncArticle?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSoftDeleteFolderArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSoftDeleteFormTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationSoftDeleteMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationSoftDeleteMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationSoftDeleteMicrosoftMessageReplyArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationStartConnectionTestJobArgs = {
  requestedBy?: Scalars['String']['input'];
};


export type MutationStartMultiUrlSyncJobArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['String']['input']>;
  urls: Array<Scalars['String']['input']>;
};


export type MutationStartUehSyncForDateArgs = {
  date: Scalars['String']['input'];
};


export type MutationStartUehSyncForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationStartUehSyncJobArgs = {
  requestedBy?: Scalars['String']['input'];
};


export type MutationStartUehSyncJobForDateArgs = {
  date: Scalars['String']['input'];
  requestedBy?: Scalars['String']['input'];
};


export type MutationStartUehSyncJobForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  requestedBy?: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationSyncAndUpdateAgentArgs = {
  agentId: Scalars['String']['input'];
  syncUrls: Array<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncMicrosoftGroupsArgs = {
  input?: InputMaybe<GroupSyncInput>;
};


export type MutationSyncMicrosoftProfileByIdArgs = {
  microsoftUserId: Scalars['ID']['input'];
};


export type MutationSyncMultipleUrlsArgs = {
  displayUrls: Array<Scalars['String']['input']>;
};


export type MutationSyncUrlConfigArgs = {
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncUrlConfigDateRangeArgs = {
  endDate: Scalars['String']['input'];
  id: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationSyncUrlConfigForDateArgs = {
  date: Scalars['String']['input'];
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTestMemberInputArgs = {
  input: AddTeamMemberInput;
};


export type MutationTestTeamInputArgs = {
  input: UpdateTeamInput;
};


export type MutationToggleActiveAppArgs = {
  channelId: Scalars['ID']['input'];
  platformAppId: Scalars['ID']['input'];
};


export type MutationToggleAgentActiveArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleAgentAssignmentArgs = {
  agentId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
};


export type MutationToggleAgentHiddenArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleChatRoomAutoReplyArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationTogglePackageAssignmentArgs = {
  channelId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type MutationUnarchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUndoSoftDeleteMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUndoSoftDeleteMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationUndoSoftDeleteMicrosoftMessageReplyArgs = {
  channelId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUnhideOneDriveItemArgs = {
  path: Scalars['String']['input'];
};


export type MutationUnpinMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  pinnedMessageId: Scalars['String']['input'];
};


export type MutationUnsetMicrosoftChatMessageReactionArgs = {
  chatId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
};


export type MutationUnsetMicrosoftMessageReactionArgs = {
  channelId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUnsetMicrosoftMessageReplyReactionArgs = {
  channelId: Scalars['String']['input'];
  input: SetReactionInput;
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUpdateAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateAgentDataStatusArgs = {
  agentId: Scalars['String']['input'];
  dataStatus: AgentDataStatus;
  dataStatusReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAgentFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateAgentFoldersArgs = {
  agentId: Scalars['String']['input'];
  folderIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateAgentSyncConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateAgentToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateAgentsWithSyncedDataArgs = {
  agentIds: Array<Scalars['String']['input']>;
  requestedBy?: Scalars['String']['input'];
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiKeyInput;
};


export type MutationUpdateApiKeyLastUsedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateArtifactArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelDto;
};


export type MutationUpdateChatRoomArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateChatbotArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationUpdateConversationNoteArgs = {
  id: Scalars['String']['input'];
  input: UpdateConversationNoteInput;
};


export type MutationUpdateConversationTagArgs = {
  id: Scalars['String']['input'];
  input: UpdateConversationTagInput;
};


export type MutationUpdateCustomerFieldArgs = {
  input: UpdateDynamicFieldInput;
};


export type MutationUpdateCustomerFieldsArgs = {
  updates: Scalars['JSONObject']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateCustomerLabelArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomerLabelInput;
};


export type MutationUpdateCustomerStageArgs = {
  input: UpdateCustomerStageInput;
};


export type MutationUpdateDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateKgPipelineJobArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateKnowledgeGraphArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateKnowledgeGraphDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateKnowledgeGraphMetadataArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateLanguageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateManySyncArticlesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateMemberRoleArgs = {
  membershipId: Scalars['ID']['input'];
  roles: Array<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateMessageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateMicrosoftCalendarArgs = {
  calendarId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMicrosoftChannelArgs = {
  channelId: Scalars['ID']['input'];
  input: UpdateChannelInput;
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateMicrosoftChannelMessageArgs = {
  channelId: Scalars['String']['input'];
  input: UpdateMicrosoftChatMessageInput;
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUpdateMicrosoftChannelReplyArgs = {
  channelId: Scalars['String']['input'];
  input: UpdateMicrosoftChatMessageInput;
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationUpdateMicrosoftChatArgs = {
  chatId: Scalars['String']['input'];
  input: UpdateMicrosoftChatInput;
};


export type MutationUpdateMicrosoftChatMessageArgs = {
  chatId: Scalars['String']['input'];
  input: UpdateMicrosoftChatMessageInput;
  messageId: Scalars['String']['input'];
};


export type MutationUpdateMicrosoftChatReplyArgs = {
  chatId: Scalars['String']['input'];
  input: UpdateMicrosoftChatMessageInput;
  messageId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};


export type MutationUpdateMicrosoftEventArgs = {
  eventId: Scalars['String']['input'];
  input: UpdateEventInput;
};


export type MutationUpdateMicrosoftGroupArgs = {
  groupId: Scalars['String']['input'];
  input: UpdateGroupInput;
};


export type MutationUpdateModelArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateMyUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateOneUrlConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdatePackageArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePackageDto;
};


export type MutationUpdatePackageStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateParsedDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdatePlatformArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformDto;
};


export type MutationUpdateS3AssetArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateSourceDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateSyncArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateTaskProgressArgs = {
  progressMessage?: InputMaybe<Scalars['String']['input']>;
  progressPercentage: Scalars['Int']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationUpdateTaskStateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateTeamTagArgs = {
  input: UpdateTagInput;
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateTeamsChannelAgentArgs = {
  agentId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
};


export type MutationUpdateToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateUehArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateUserAgentArgs = {
  id: Scalars['String']['input'];
  updateAgentDto: UpdateAgentDto;
};


export type MutationUpdateUserDynamicFieldsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpdateUserFieldValueArgs = {
  fieldName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  value: Scalars['JSONObject']['input'];
};


export type MutationUpdateUserWorkflowArgs = {
  id: Scalars['String']['input'];
  input: UpdateWorkflowDto;
};


export type MutationUpdateWorkflowArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpsertOneFormFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpsertOneFormParsedContentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpsertOneFormTemplateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type MutationUpsertRetentionSettingsArgs = {
  documentRetentionDays: Scalars['Int']['input'];
  kgRetentionDays: Scalars['Int']['input'];
  namespace: Scalars['String']['input'];
};


export type MutationUpsertUserDynamicFieldsArgs = {
  fieldValues: Scalars['JSONObject']['input'];
  userId: Scalars['String']['input'];
};


export type MutationValidateUrlConfigArgs = {
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  displayUrl: Scalars['String']['input'];
};


export type MutationWebhookCreateSocialUserArgs = {
  input: CreateSocialUserInput;
};


export type MutationWebhookDecrementUserQuotaArgs = {
  input: DecrementQuotaInput;
};


export type MutationWebhookFindOrCreateChatRoomArgs = {
  input: FindOrCreateChatRoomInput;
};


export type MutationWebhookSaveMessageArgs = {
  input: SaveMessageInput;
};


export type MutationWebhookUpdateChannelTokensArgs = {
  input: UpdateChannelTokensInput;
};

export type MyTeamTagsResponse = {
  __typename?: 'MyTeamTagsResponse';
  tagCards: Array<TagCard>;
  teamTagSettings: TeamTagSettings;
};

export type NoteAuthor = {
  __typename?: 'NoteAuthor';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type NoteAuthorStats = {
  __typename?: 'NoteAuthorStats';
  /** Author details */
  author: NoteAuthor;
  /** Last note created date */
  lastNoteAt: Scalars['String']['output'];
  /** Count of notes created */
  noteCount: Scalars['Int']['output'];
};

/** Priority levels for conversation notes */
export enum NotePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type NotePriorityStats = {
  __typename?: 'NotePriorityStats';
  /** Count of notes */
  count: Scalars['Int']['output'];
  /** Most recent note date */
  lastCreatedAt: Scalars['String']['output'];
  /** Priority level */
  priority: NotePriority;
};

/** Types of conversation notes */
export enum NoteType {
  Escalation = 'ESCALATION',
  FollowUp = 'FOLLOW_UP',
  General = 'GENERAL',
  Important = 'IMPORTANT',
  Resolution = 'RESOLUTION'
}

export type NoteTypeStats = {
  __typename?: 'NoteTypeStats';
  /** Count of notes */
  count: Scalars['Int']['output'];
  /** Most recent note date */
  lastCreatedAt: Scalars['String']['output'];
  /** Note type */
  noteType: NoteType;
};

/** OneDrive credential status for a realm */
export type OneDriveCredentialStatus = {
  __typename?: 'OneDriveCredentialStatus';
  accountEmail?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  realm: Scalars['String']['output'];
  syncStatus: OneDriveSyncStatus;
};

export type OneDriveFolder = {
  __typename?: 'OneDriveFolder';
  children?: Maybe<Array<OneDriveFolder>>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFolder: Scalars['Boolean']['output'];
  lastModified: Scalars['String']['output'];
  metadata?: Maybe<OneDriveFolderMetadata>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type OneDriveFolderMetadata = {
  __typename?: 'OneDriveFolderMetadata';
  childCount?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OneDriveFolderTree = {
  __typename?: 'OneDriveFolderTree';
  breadcrumb?: Maybe<Array<OneDriveFolder>>;
  currentFolder?: Maybe<OneDriveFolder>;
  currentPath: Scalars['String']['output'];
  hasMore: Scalars['Boolean']['output'];
  items: Array<OneDriveFolder>;
  totalCount: Scalars['Int']['output'];
};

/** OneDrive sync status */
export enum OneDriveSyncStatus {
  Disabled = 'DISABLED',
  Error = 'ERROR',
  Idle = 'IDLE',
  Refreshing = 'REFRESHING',
  Syncing = 'SYNCING'
}

/** Result of enable/disable sync operation */
export type OneDriveSyncToggleResult = {
  __typename?: 'OneDriveSyncToggleResult';
  message: Scalars['String']['output'];
  realm: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  syncStatus: OneDriveSyncStatus;
};

export type OnlineMeetingInfo = {
  __typename?: 'OnlineMeetingInfo';
  conferenceId?: Maybe<Scalars['String']['output']>;
  dialinUrl?: Maybe<Scalars['String']['output']>;
  joinUrl?: Maybe<Scalars['String']['output']>;
  quickDial?: Maybe<Scalars['String']['output']>;
  tollFreeNumbers?: Maybe<Array<Scalars['String']['output']>>;
  tollNumber?: Maybe<Scalars['String']['output']>;
};

/** Online meeting provider for events */
export enum OnlineMeetingProvider {
  SkypeForBusiness = 'SKYPE_FOR_BUSINESS',
  SkypeForConsumer = 'SKYPE_FOR_CONSUMER',
  TeamsForBusiness = 'TEAMS_FOR_BUSINESS',
  Unknown = 'UNKNOWN'
}

export type OperationResult = {
  __typename?: 'OperationResult';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OriginalDocument = {
  __typename?: 'OriginalDocument';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** OneDrive download URL */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** File extension (without dot) */
  fileExtension: Scalars['String']['output'];
  /** Original filename with extension */
  fileName: Scalars['String']['output'];
  /** Full path in OneDrive sync directory */
  filePath: Scalars['String']['output'];
  /** File size in bytes */
  fileSize: Scalars['BigInt']['output'];
  folder?: Maybe<Folder>;
  /** Optional folder organization */
  folderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** File's last modified timestamp */
  lastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** MD5 hash for duplicate detection */
  md5Hash: Scalars['String']['output'];
  /** Additional OneDrive metadata (creator, tags, etc.) */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** MIME type (e.g., "application/pdf") */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** OneDrive item ID (if available) */
  oneDriveItemId?: Maybe<Scalars['String']['output']>;
  /** File sync status */
  status: FileStatus;
  /** When file was synced from OneDrive */
  syncedAt: Scalars['DateTime']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  /** User ID who owns this file */
  userId: Scalars['String']['output'];
  /** OneDrive web URL */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type Package = {
  __typename?: 'Package';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['String']['output'];
  durationDays: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  messageCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packageType: Scalars['String']['output'];
  platformType?: Maybe<PlatformCode>;
  price: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type PackageResponse = {
  __typename?: 'PackageResponse';
  message: Scalars['String']['output'];
  package: Package;
};

export type PaginationInput = {
  /** Number of items per page */
  limit?: Scalars['Int']['input'];
  /** Page number (starts from 1) */
  page?: Scalars['Int']['input'];
};

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  /** Whether there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items per page */
  limit: Scalars['Int']['output'];
  /** Next page number */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Current page number (1-based) */
  page: Scalars['Int']['output'];
  /** Previous page number */
  previousPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of items */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  hasNext: Scalars['Boolean']['output'];
  hasPrev: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ParsedDocument = {
  __typename?: 'ParsedDocument';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['String']['output']>;
  extractedImages?: Maybe<Scalars['JSON']['output']>;
  extractedTables?: Maybe<Scalars['JSON']['output']>;
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  hasDiagrams: Scalars['Boolean']['output'];
  hasImages: Scalars['Boolean']['output'];
  hasTables: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  markdownLength: Scalars['Int']['output'];
  markdownMd5: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  ocrConfidence?: Maybe<Scalars['Float']['output']>;
  parseDuration: Scalars['Float']['output'];
  parseVersion: Scalars['String']['output'];
  parseWarnings?: Maybe<Scalars['JSON']['output']>;
  parsedAt: Scalars['DateTime']['output'];
  sourceMd5: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  validationStatus: Scalars['String']['output'];
};

/** Subtypes of people entities */
export enum PeopleSubtype {
  Guest = 'GUEST',
  MtoUser = 'MTO_USER',
  OrganizationUser = 'ORGANIZATION_USER',
  PublicDistributionList = 'PUBLIC_DISTRIBUTION_LIST',
  UnifiedGroup = 'UNIFIED_GROUP'
}

/** Types of people entities */
export enum PeopleType {
  Group = 'GROUP',
  Other = 'OTHER',
  Person = 'PERSON'
}

export type PinNoteInput = {
  /** Pin status */
  isPinned: Scalars['Boolean']['input'];
  /** Note ID to pin/unpin */
  noteId: Scalars['String']['input'];
};

export type PlanProposal = {
  __typename?: 'PlanProposal';
  chatRoomId: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  namespace: Scalars['String']['output'];
  priorArtifactId?: Maybe<Scalars['String']['output']>;
  proposedSlots?: Maybe<Scalars['JSONObject']['output']>;
  reasoning: Scalars['String']['output'];
  status: PlanProposalStatus;
  summary: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum PlanProposalStatus {
  Consumed = 'CONSUMED',
  Pending = 'PENDING'
}

export type Platform = {
  __typename?: 'Platform';
  code: PlatformCode;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformApp = {
  __typename?: 'PlatformApp';
  /** Channel platform app relationships */
  channelPlatformApps?: Maybe<Array<ChannelPlatformApp>>;
  /** Platform-specific configuration including credentials */
  config: Scalars['JSONObject']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** App icon URL (automatically fetched for Facebook apps) */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Platform this app belongs to */
  platform: Platform;
  /** ID of the platform this app belongs to */
  platformId: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who created this app */
  user: User;
  /** ID of the user who created this app */
  userId: Scalars['ID']['output'];
  /** Verification token for webhook security */
  verificationToken?: Maybe<Scalars['String']['output']>;
  /** Webhook URL for receiving messages from platform */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type PlatformAppResponse = {
  __typename?: 'PlatformAppResponse';
  message: Scalars['String']['output'];
  platformApp: PlatformApp;
};

export type PlatformAppsResponse = {
  __typename?: 'PlatformAppsResponse';
  /** Total count of platform apps */
  count: Scalars['Int']['output'];
  /** List of platform apps */
  data: Array<PlatformApp>;
  /** Pagination metadata */
  meta: PaginationMeta;
};

export type PlatformAppsStatsResponse = {
  __typename?: 'PlatformAppsStatsResponse';
  /** Facebook platform apps count */
  facebook: Scalars['Int']['output'];
  /** Teams platform apps count */
  teams: Scalars['Int']['output'];
  /** Total platform apps count */
  total: Scalars['Int']['output'];
  /** Website platform apps count */
  website: Scalars['Int']['output'];
  /** Zalo platform apps count */
  zalo: Scalars['Int']['output'];
};

/** Available platform codes for messaging platforms */
export enum PlatformCode {
  Facebook = 'facebook',
  Teams = 'teams',
  Website = 'website',
  Zalo = 'zalo'
}

export type PlatformInfo = {
  __typename?: 'PlatformInfo';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PlatformResponse = {
  __typename?: 'PlatformResponse';
  message: Scalars['String']['output'];
  platform: Platform;
};

/** Preferred data location for the group */
export enum PreferredDataLocation {
  Apc = 'APC',
  Aus = 'AUS',
  Can = 'CAN',
  Eur = 'EUR',
  Fra = 'FRA',
  Gbr = 'GBR',
  Ind = 'IND',
  Jpn = 'JPN',
  Kor = 'KOR',
  Nam = 'NAM',
  Zaf = 'ZAF'
}

export type ProcessedAttachment = {
  __typename?: 'ProcessedAttachment';
  attachmentId: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProposedNewTime = {
  __typename?: 'ProposedNewTime';
  /** Proposed end time in ISO 8601 format */
  end: Scalars['String']['output'];
  /** Proposed start time in ISO 8601 format */
  start: Scalars['String']['output'];
  /** Time zone identifier */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ProposedNewTimeInput = {
  /** Proposed end time in ISO 8601 format */
  end: Scalars['String']['input'];
  /** Proposed start time in ISO 8601 format */
  start: Scalars['String']['input'];
  /** Time zone identifier */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Advanced search with filters and scenarios */
  advancedSearch: UnifiedSearchResponse;
  /** Get a single API key by ID (admin only) */
  apiKey: ApiKey;
  /** List all API keys (admin only) */
  apiKeys: Array<ApiKey>;
  /** Get permissions for a specific calendar as JSON string */
  calendarPermissions: Scalars['String']['output'];
  /** Get calendar statistics for current user as JSON string */
  calendarStats: Scalars['String']['output'];
  /** Get events in calendar view format for optimal calendar display */
  calendarView: Array<Event>;
  /** Quick check if current user can delete the team */
  canCurrentUserDeleteTeam: Scalars['Boolean']['output'];
  /** Quick check if current user can manage team settings */
  canCurrentUserManageTeam: Scalars['Boolean']['output'];
  channel: Channel;
  channels: ChannelsResponse;
  channelsByPlatformApp: Array<Channel>;
  channelsStats: ChannelsStatsResponse;
  /** Get database schema information with optional AI analysis */
  clickhouseDatabaseSchema: ClickHouseSchemaResponse;
  /** Get list of available ClickHouse databases */
  clickhouseDatabases: ClickHouseDatabasesResponse;
  /** Get ClickHouse service health status */
  clickhouseHealth: ClickHouseHealthResponse;
  /** Get detailed information about a specific conversation */
  conversationDetail: ConversationListItem;
  /** Get conversation history for a specific conversation group */
  conversationHistory: ConversationHistoryResponse;
  /** Get conversation history by active conversation ID */
  conversationHistoryByActiveId: ConversationHistoryResponse;
  /** Get messages for a specific conversation with pagination and filters */
  conversationMessages: ConversationMessagesResponse;
  /** Get a specific conversation note by ID */
  conversationNote: ConversationNote;
  /** Get comprehensive statistics about conversation notes */
  conversationNoteStats: ConversationNoteStats;
  /** Get conversation notes with optional filters and pagination */
  conversationNotes: ConversationNoteListResponse;
  /** Get all notes for a specific conversation */
  conversationNotesByConversation: Array<ConversationNote>;
  /** Get conversation statistics for dashboard */
  conversationStats: Scalars['String']['output'];
  /** Get a specific conversation tag by ID */
  conversationTag: ConversationTag;
  /** Get all tag assignments for a specific conversation */
  conversationTagAssignments: Array<ConversationTagAssignment>;
  /** Get comprehensive statistics about conversation tags */
  conversationTagStats: ConversationTagStats;
  /** Get all conversation tags with optional filters */
  conversationTags: ConversationTagListResponse;
  /** Get complete conversation detail with messages - ideal for conversation view */
  conversationWithMessages: ConversationDetailResponse;
  /** Get paginated list of conversations with filtering and sorting */
  conversations: ConversationListResponse;
  /** Count DLQ records */
  countDlqRecords: Scalars['Int']['output'];
  countDocuments: Scalars['Int']['output'];
  countFieldCategory: Scalars['Int']['output'];
  countFieldDefinition: Scalars['Int']['output'];
  countFolders: Scalars['Int']['output'];
  /** Count KGPipelineJobs that match the filter */
  countKGPipelineJobs: Scalars['Int']['output'];
  countKnowledgeGraphs: Scalars['Int']['output'];
  countMessages: Scalars['Int']['output'];
  countOriginalDocuments: Scalars['Int']['output'];
  /** Count S3Assets that match the filter */
  countS3Assets: Scalars['Int']['output'];
  /** Count tasks matching criteria */
  countTaskStates: Scalars['Int']['output'];
  countWorkflows: Scalars['Int']['output'];
  currentMicrosoftUser?: Maybe<MicrosoftUser>;
  /** Get customer score distribution for analytics */
  customerScoreDistribution: Array<CustomerScoreDistribution>;
  debugPlatformApp: Scalars['String']['output'];
  /** Discover and sync group calendars from Microsoft Graph */
  discoverGroupCalendars: Array<EventCalendar>;
  /** Discover and sync personal calendars from Microsoft Graph */
  discoverPersonalCalendars: Array<EventCalendar>;
  findActiveFieldCategories: Array<FieldCategory>;
  findActiveFieldDefinitions: Array<FieldDefinition>;
  /** Find active Knowledge Graphs by namespace (shared access) */
  findActiveKnowledgeGraphsByNamespace: Array<KnowledgeGraph>;
  /** Find active Knowledge Graphs for user */
  findActiveKnowledgeGraphsByUser: Array<KnowledgeGraph>;
  /** Find API key by hash (for validation) */
  findApiKeyByHash?: Maybe<ApiKey>;
  /** Find documents by MD5 hashes with OR fallback (sourceDocumentMd5 OR originalMarkdownMd5) */
  findDocumentsByMd5: Array<Document>;
  /** Find soft-deleted documents eligible for hard purge */
  findDocumentsForPurge: Array<Document>;
  findFieldCategoryWithFields?: Maybe<FieldCategory>;
  findFieldDefinitionsByCategory: Array<FieldDefinition>;
  findFirstAgent?: Maybe<Agent>;
  findFirstAgentFolder?: Maybe<AgentFolder>;
  findFirstAgentSyncConfig?: Maybe<AgentSyncConfig>;
  findFirstAgentTool?: Maybe<AgentTool>;
  findFirstArtifact?: Maybe<Artifact>;
  findFirstChatRoom?: Maybe<ChatRoom>;
  findFirstDocument?: Maybe<Document>;
  findFirstFolder?: Maybe<Folder>;
  findFirstFormFolder?: Maybe<FormFolder>;
  findFirstFormTemplate?: Maybe<FormTemplate>;
  /** Find the first KGPipelineJob that matches the filter */
  findFirstKGPipelineJob?: Maybe<KgPipelineJob>;
  findFirstKnowledgeGraph?: Maybe<KnowledgeGraph>;
  findFirstKnowledgeGraphDocument?: Maybe<KnowledgeGraphDocument>;
  findFirstLanguage?: Maybe<Language>;
  findFirstMessage?: Maybe<Message>;
  findFirstModel?: Maybe<Model>;
  findFirstOriginalDocument?: Maybe<OriginalDocument>;
  findFirstParsedDocument?: Maybe<ParsedDocument>;
  /** Find the first S3Asset that matches the filter */
  findFirstS3Asset?: Maybe<S3Asset>;
  findFirstSourceDocument?: Maybe<SourceDocument>;
  findFirstTool?: Maybe<Tool>;
  findFirstUehArticle?: Maybe<UehArticle>;
  findFirstUrlConfig?: Maybe<UrlConfig>;
  findFirstUser?: Maybe<User>;
  findFirstWorkflow?: Maybe<Workflow>;
  findFolderById?: Maybe<Folder>;
  /** Get one FormTemplate by `formId` in the JWT-bound product namespace. Returns null on cross-tenant probe. */
  findFormTemplateByFormId?: Maybe<FormTemplate>;
  /** Per-folder FormTemplate counts for the JWT-bound namespace. One grouped SQL query. Powers the folder badges on /admin/forms + the @-picker so the FE can render the folder tree without fetching templates. */
  findFormTemplateCountsByFolder: Array<FormTemplateFolderCount>;
  /** List authored form templates in the JWT-bound product namespace. Substring filter on `formId`, optional `includeDeleted`. */
  findFormTemplatesPaginated: FormTemplateConnection;
  /** Find KGPipelineJobs by user and namespace */
  findKGPipelineJobsByUserAndNamespace: Array<KgPipelineJob>;
  /** Find Knowledge Graph by user, namespace, and workflow type */
  findKnowledgeGraphByUserNamespaceAndType?: Maybe<KnowledgeGraph>;
  /** Find Knowledge Graphs by namespace only (shared access) */
  findKnowledgeGraphsByNamespace: Array<KnowledgeGraph>;
  /** Find Knowledge Graphs by pickle MD5 hash */
  findKnowledgeGraphsByPickleMd5: Array<KnowledgeGraph>;
  /** Find Knowledge Graphs by user and namespace */
  findKnowledgeGraphsByUserAndNamespace: Array<KnowledgeGraph>;
  /** Find Knowledge Graphs by user ID */
  findKnowledgeGraphsByUserId: Array<KnowledgeGraph>;
  /** Find the latest KGPipelineJob for a user in a namespace */
  findLatestKGPipelineJob?: Maybe<KgPipelineJob>;
  findManyAgentFolders: Array<AgentFolder>;
  findManyAgentSyncConfigs: Array<AgentSyncConfig>;
  findManyAgentTools: Array<AgentTool>;
  findManyAgents: Array<Agent>;
  findManyArtifacts: Array<Artifact>;
  findManyChatRooms: Array<ChatRoom>;
  /** Find DLQ records */
  findManyDlqRecords: Array<DlqRecord>;
  findManyDocuments: Array<Document>;
  findManyFieldCategory: Array<FieldCategory>;
  findManyFieldDefinition: Array<FieldDefinition>;
  findManyFolders: Array<Folder>;
  findManyFormFolders: Array<FormFolder>;
  findManyFormTemplates: Array<FormTemplate>;
  /** Find multiple KGPipelineJobs */
  findManyKGPipelineJobs: Array<KgPipelineJob>;
  findManyKnowledgeGraphDocuments: Array<KnowledgeGraphDocument>;
  findManyKnowledgeGraphs: Array<KnowledgeGraph>;
  /** Find Knowledge Graphs with enhanced metadata for management interface */
  findManyKnowledgeGraphsWithMetadata: Array<KnowledgeGraph>;
  findManyLanguages: Array<Language>;
  findManyMessages: Array<Message>;
  findManyModels: Array<Model>;
  findManyOriginalDocuments: Array<OriginalDocument>;
  findManyParsedDocuments: Array<ParsedDocument>;
  /** Find multiple S3Assets */
  findManyS3Assets: Array<S3Asset>;
  findManySourceDocuments: Array<SourceDocument>;
  findManySyncArticles: Array<SyncArticle>;
  /** Find tasks matching criteria */
  findManyTaskStates: Array<TaskState>;
  findManyTools: Array<Tool>;
  findManyUehArticles: Array<UehArticle>;
  findManyUrlConfigs: Array<UrlConfig>;
  findManyUsers: Array<User>;
  findManyWorkflows: Array<Workflow>;
  findMyFirstUser: User;
  findMyUniqueUser: User;
  findPlanProposal?: Maybe<PlanProposal>;
  /** Find all running pipeline jobs for a user */
  findRunningKGPipelineJobs: Array<KgPipelineJob>;
  /** Find S3Assets by document ID */
  findS3AssetsByDocument: Array<S3Asset>;
  /** Find S3Assets by KnowledgeGraph ID */
  findS3AssetsByKnowledgeGraph: Array<S3Asset>;
  /** Find S3Assets by Pipeline Job ID */
  findS3AssetsByPipelineJob: Array<S3Asset>;
  /** Find a task by unique taskId */
  findTaskByTaskId?: Maybe<TaskState>;
  /** Find checkpoints for a task */
  findTaskCheckpoints: Array<TaskCheckpoint>;
  /** Find events for a task */
  findTaskEvents: Array<TaskEvent>;
  /** Find tasks for a specific user */
  findTasksByUser: Array<TaskState>;
  findUniqueAgent?: Maybe<Agent>;
  findUniqueAgentFolder?: Maybe<AgentFolder>;
  findUniqueAgentSyncConfig?: Maybe<AgentSyncConfig>;
  findUniqueAgentTool?: Maybe<AgentTool>;
  findUniqueArtifact?: Maybe<Artifact>;
  findUniqueChatRoom?: Maybe<ChatRoom>;
  /** Find a DLQ record by ID */
  findUniqueDlqRecord?: Maybe<DlqRecord>;
  findUniqueDocument?: Maybe<Document>;
  findUniqueFieldCategory?: Maybe<FieldCategory>;
  findUniqueFieldDefinition?: Maybe<FieldDefinition>;
  findUniqueFolder?: Maybe<Folder>;
  findUniqueFormParsedContent?: Maybe<FormParsedContent>;
  findUniqueFormTemplate?: Maybe<FormTemplate>;
  /** Find a unique KGPipelineJob */
  findUniqueKGPipelineJob?: Maybe<KgPipelineJob>;
  findUniqueKnowledgeGraph?: Maybe<KnowledgeGraph>;
  findUniqueKnowledgeGraphDocument?: Maybe<KnowledgeGraphDocument>;
  findUniqueLanguage?: Maybe<Language>;
  findUniqueMessage?: Maybe<Message>;
  findUniqueModel?: Maybe<Model>;
  findUniqueOriginalDocument?: Maybe<OriginalDocument>;
  findUniqueParsedDocument?: Maybe<ParsedDocument>;
  /** Find a unique S3Asset */
  findUniqueS3Asset?: Maybe<S3Asset>;
  findUniqueSourceDocument?: Maybe<SourceDocument>;
  findUniqueSyncArticle?: Maybe<SyncArticle>;
  /** Find a checkpoint by ID */
  findUniqueTaskCheckpoint?: Maybe<TaskCheckpoint>;
  /** Find a task by ID */
  findUniqueTaskState?: Maybe<TaskState>;
  findUniqueTool?: Maybe<Tool>;
  findUniqueUehArticle?: Maybe<UehArticle>;
  findUniqueUrlConfig?: Maybe<UrlConfig>;
  findUniqueUser?: Maybe<User>;
  findUniqueUserDynamicFields?: Maybe<UserDynamicFields>;
  findUniqueWorkflow?: Maybe<Workflow>;
  findUserDynamicFieldsByUserId?: Maybe<UserDynamicFields>;
  generateTeamsAppManifest: GenerateTeamsAppResponse;
  /** Get active conversation in the same conversationGroup */
  getActiveConversationInGroup?: Maybe<ConversationListItem>;
  getAllUrlConfigs: Array<UrlConfig>;
  getArticlesByAgent: Array<UehArticle>;
  /** Get events from a specific calendar with filtering */
  getCalendarEvents: Array<Event>;
  /** Get channel messages with replies in Microsoft Teams style structure */
  getChannelMessagesWithReplies: Array<TeamsMessageThread>;
  getChatRoomAutoReply?: Maybe<ChatRoom>;
  getChatbotUpdateStatus: Scalars['String']['output'];
  /** Get current user role and permissions in a team - use this for frontend permission checks */
  getCurrentUserTeamRole?: Maybe<CurrentUserTeamContext>;
  /** Get customer dashboard with filtering, pagination and sorting */
  getCustomerDashboard: CustomerDashboardResponse;
  /** Get customer dynamic fields for conversation sidebar */
  getCustomerFields: CustomerFieldsInfo;
  /** Get all customer labels with usage counts */
  getCustomerLabels: CustomerLabelsResponse;
  /** Get customer score breakdown */
  getCustomerScore: CustomerScore;
  /** Get customer statistics for sidebar counts */
  getCustomerSidebarStats: CustomerSidebarStats;
  getDocumentVersion?: Maybe<DocumentVersion>;
  getDocumentVersions: Array<DocumentVersion>;
  getDocumentsByKnowledgeGraphId: Array<KnowledgeGraphDocument>;
  /** Get a specific calendar event by ID */
  getEvent: Event;
  getFacebookChannelHealth?: Maybe<FacebookConnectionHealthDto>;
  getFacebookConnectionHealth: FacebookConnectionSummaryDto;
  /** Get calendar events for a Teams group (Teams Calendar tab functionality) */
  getGroupCalendarEvents: Array<Event>;
  getKGDeltas: Array<KgDelta>;
  getKnowledgeGraphDocumentStats: Scalars['JSONObject']['output'];
  /** Get health status and connectivity for a Knowledge Graph */
  getKnowledgeGraphHealth: KnowledgeGraphHealthStatus;
  /** Get usage analytics for a specific Knowledge Graph */
  getKnowledgeGraphUsageStats: KnowledgeGraphUsageStats;
  getKnowledgeGraphsByDocumentId: Array<KnowledgeGraphDocument>;
  getLastWeekdayDate: Scalars['String']['output'];
  /** Get the latest checkpoint for a task */
  getLatestCheckpoint?: Maybe<TaskCheckpoint>;
  /** Get channel details by ID with database sync */
  getMicrosoftChannel: MicrosoftChannel;
  /** Get messages from a Microsoft Teams channel with advanced filtering */
  getMicrosoftChannelMessages: Array<MicrosoftChatMessage>;
  /** Get messages from a Microsoft Teams chat with pagination */
  getMicrosoftChatMessages: Array<MicrosoftChatMessage>;
  /** Get all pinned messages in Microsoft Teams chat formatted for UI display */
  getMicrosoftChatPinnedMessages: Array<MicrosoftChatMessage>;
  /** Get all favorite channels for a team */
  getMicrosoftFavoriteChannels: Array<MicrosoftChannel>;
  /** Get a specific message by ID (works for both chat and channel messages) */
  getMicrosoftMessage?: Maybe<MicrosoftChatMessage>;
  /** Get replies for a specific channel message (threading support) */
  getMicrosoftMessageReplies: Array<MicrosoftChatMessage>;
  /** Get all private channels for a team */
  getMicrosoftPrivateChannels: Array<MicrosoftChannel>;
  /** Get all standard (public) channels for a team */
  getMicrosoftStandardChannels: Array<MicrosoftChannel>;
  /** Get all channels for a team with database sync and role information */
  getMicrosoftTeamChannels: Array<MicrosoftChannel>;
  /** Get my sent invitations (for regular members to track their requests) */
  getMyTeamInvitations: Array<TeamInvitation>;
  /** Get tags in Microsoft Teams-compatible format with team settings */
  getMyTeamTags: MyTeamTagsResponse;
  /** Get simple list of tags assigned to the current user (backward compatibility) */
  getMyTeamTagsSimple: Array<TeamworkTag>;
  /** Get OneDrive credential status for a realm (admin only) */
  getOneDriveCredentialStatus?: Maybe<OneDriveCredentialStatus>;
  /** Get OneDrive folder tree structure with optional path parameter */
  getOneDriveFolderTree: OneDriveFolderTree;
  getRecentUehSyncJobs: Array<JobInfo>;
  getRetentionSettings?: Maybe<RetentionSettings>;
  getSuggestedSyncDates: Array<Scalars['String']['output']>;
  getSyncStatistics: SyncStatistics;
  getSyncableUrls: Array<SyncUrlConfig>;
  /** Get members of a specific tag with optional filtering */
  getTagMembers: Array<TagMember>;
  /** Get task statistics */
  getTaskStatistics: TaskStatistics;
  /** Get team details by ID with database sync */
  getTeam: Team;
  getTeamChannels: TeamChannelsResponse;
  /** Get all members of a team with their roles and permissions */
  getTeamMembers: Array<TeamMemberWithPermissions>;
  /** Get pending invitations for a team (Owner only) */
  getTeamPendingInvitations: Array<TeamInvitation>;
  /** Get specific tag details by ID */
  getTeamTag: TeamworkTag;
  /** Get all tags for a team with optional filtering and search */
  getTeamTags: Array<TeamworkTag>;
  /** Get all teams for current user with database sync and role information */
  getTeams: Array<Team>;
  getTeamsFromApp: TeamsResponse;
  getUehArticles: Array<UehArticle>;
  getUehArticlesCount: Scalars['Int']['output'];
  getUehSyncQueueStats: QueueStats;
  getUehSyncStatus?: Maybe<JobInfo>;
  /** Get unresolved DLQ records */
  getUnresolvedDlqRecords: Array<DlqRecord>;
  getUrlConfigsCount: Scalars['Int']['output'];
  getUrlFoldersForAgent: Array<UrlConfig>;
  getUserAgents: Array<Agent>;
  /** Get channel history for a specific user - shows all channels where user has had interactions */
  getUserChannelHistory: Array<UserChannelSummary>;
  getUserFieldValue?: Maybe<Scalars['JSONObject']['output']>;
  /** Get labels assigned to a specific user */
  getUserLabels: Array<CustomerLabelInfo>;
  getUserWorkflows: Array<Workflow>;
  getZaloChannelHealth?: Maybe<ZaloConnectionHealthDto>;
  getZaloConnectionHealth: ZaloConnectionSummaryDto;
  hello: Scalars['String']['output'];
  helloWorld: Scalars['String']['output'];
  /** Get all hidden OneDrive items for the current user */
  hiddenOneDriveItems: Array<HiddenOneDriveItem>;
  /** Get paths of all hidden OneDrive items (optimized for filtering) */
  hiddenOneDrivePaths: Array<Scalars['String']['output']>;
  /** Get high priority notes that need attention */
  highPriorityNotes: Array<ConversationNote>;
  me?: Maybe<UserInfo>;
  /** Get a specific Microsoft calendar by ID */
  microsoftCalendar: EventCalendar;
  /** Get all Microsoft calendars for the current user */
  microsoftCalendars: Array<EventCalendar>;
  microsoftChat?: Maybe<MicrosoftChat>;
  microsoftChatMembers: Array<ChatMember>;
  microsoftChats: Array<MicrosoftChat>;
  /** Get a specific Microsoft calendar event by ID */
  microsoftEvent: Event;
  /** Get attendees for a specific Microsoft calendar event */
  microsoftEventAttendees: Array<EventAttendee>;
  /** Get Microsoft calendar events with advanced filtering */
  microsoftEvents: Array<Event>;
  /** Find optimal meeting times for multiple attendees */
  microsoftFindMeetingTimes: Array<Scalars['String']['output']>;
  /** Get free/busy information for scheduling meetings */
  microsoftFreeBusy: Array<FreeBusyResult>;
  /** Get a specific Microsoft 365 group by ID */
  microsoftGroup: Group;
  /** Get all Microsoft 365 groups for the current user */
  microsoftGroups: Array<Group>;
  /** Get the primary Microsoft calendar for the current user */
  microsoftPrimaryCalendar: EventCalendar;
  /** Get Microsoft Teams groups for the current user */
  microsoftTeamsGroups: Array<Group>;
  microsoftUser?: Maybe<MicrosoftUser>;
  microsoftUserByMicrosoftId?: Maybe<MicrosoftUser>;
  microsoftUserByUPN?: Maybe<MicrosoftUser>;
  /** Get events for a specific month (current month by default) */
  monthEvents: Array<Event>;
  /** Get all my Microsoft calendars */
  myCalendars: Array<EventCalendar>;
  /** Get notes created by the current user */
  myConversationNotes: Array<ConversationNote>;
  /** Get calendars that I own */
  myOwnedCalendars: Array<EventCalendar>;
  package: Package;
  packages: Array<Package>;
  /** Teams-style people picker search - exactly like Microsoft Teams new chat functionality */
  peoplePickerSearch: UnifiedSearchResponse;
  /** Get all pinned notes for a conversation or globally */
  pinnedConversationNotes: Array<ConversationNote>;
  platform: Platform;
  platformApp: PlatformApp;
  platformApps: Array<PlatformApp>;
  platformAppsStats: PlatformAppsStatsResponse;
  platformAppsWithQuery: PlatformAppsResponse;
  platforms: Array<Platform>;
  /** Preview the impact of deleting specific Knowledge Graphs */
  previewKnowledgeGraphOperations: KnowledgeGraphDeletionPreview;
  refreshMicrosoftChats: Array<MicrosoftChat>;
  /** Search calendars by name or owner */
  searchCalendars: Array<EventCalendar>;
  /** Search for channels only */
  searchChannels: UnifiedSearchResponse;
  /** Search channels by display name */
  searchMicrosoftChannels: Array<MicrosoftChannel>;
  /** Search Microsoft Teams chat messages using Microsoft Graph Search API with KQL support */
  searchMicrosoftChatMessages: ChatMessageSearchResponse;
  searchMicrosoftUsers: Array<MicrosoftUserSearchResult>;
  /** Search for people only - optimized for user selection scenarios */
  searchPeople: UnifiedSearchResponse;
  /** Search existing team members (includes only current team members) */
  searchTeamMembers: UserSearchResponse;
  /** Search existing team members for tag assignment (DEPRECATED: Use searchTeamMembers with forTags=true) */
  searchTeamMembersForTags: UserSearchResponse;
  /** Search for teams only */
  searchTeams: UnifiedSearchResponse;
  /** Search across Microsoft 365 entities (People, Teams, Channels, Chats) like Microsoft Teams */
  searchUnified: UnifiedSearchResponse;
  /** Search users in organization for adding to team (Microsoft Teams-compatible) */
  searchUsers: UserSearchResponse;
  searchUsersByFieldValue: Array<UserDynamicFields>;
  /** Search users available to add to a specific team (excludes current members) */
  searchUsersForTeam: UserSearchResponse;
  /** Get calendars shared with me */
  sharedCalendars: Array<EventCalendar>;
  /** Get events for today */
  todayEvents: Array<Event>;
  /** Get upcoming events (next N events) */
  upcomingEvents: Array<Event>;
  validateFieldValues: FieldValidationResult;
  validateSyncUrls: Array<ValidationResult>;
  webhookGetActiveAgents: Array<ChannelAgentData>;
  webhookGetActiveChannelAgent?: Maybe<ChannelAgentData>;
  webhookGetChannelByPageId?: Maybe<ChannelTokensData>;
  webhookGetChannelWithTokens?: Maybe<ChannelTokensData>;
  webhookGetChatRoomMessages: Array<MessageData>;
  webhookGetUserByPlatformId?: Maybe<SocialUserData>;
  webhookGetUserQuota?: Maybe<ChannelUserQuota>;
  /** Get events for a specific week (current week by default) */
  weekEvents: Array<Event>;
};


export type QueryAdvancedSearchArgs = {
  input: AdvancedSearchInput;
};


export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiKeysArgs = {
  filter?: InputMaybe<ApiKeyFilterInput>;
};


export type QueryCalendarPermissionsArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarViewArgs = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanCurrentUserDeleteTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryCanCurrentUserManageTeamArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelsArgs = {
  query?: InputMaybe<ChannelsQueryDto>;
};


export type QueryChannelsByPlatformAppArgs = {
  platformAppId: Scalars['ID']['input'];
};


export type QueryClickhouseDatabaseSchemaArgs = {
  database: Scalars['String']['input'];
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  includeLlmAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConversationDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryConversationHistoryArgs = {
  conversationGroup: Scalars['String']['input'];
};


export type QueryConversationHistoryByActiveIdArgs = {
  activeConversationId: Scalars['String']['input'];
};


export type QueryConversationMessagesArgs = {
  conversationId: Scalars['String']['input'];
  filters?: InputMaybe<MessageFilters>;
  pagination?: InputMaybe<MessagePaginationInput>;
};


export type QueryConversationNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryConversationNoteStatsArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConversationNotesArgs = {
  filters?: InputMaybe<ConversationNoteFilters>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  sorting?: InputMaybe<ConversationNoteSorting>;
};


export type QueryConversationNotesByConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryConversationTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryConversationTagAssignmentsArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryConversationTagsArgs = {
  filters?: InputMaybe<ConversationTagFilters>;
};


export type QueryConversationWithMessagesArgs = {
  conversationId: Scalars['String']['input'];
  messageFilters?: InputMaybe<MessageFilters>;
  messagePagination?: InputMaybe<MessagePaginationInput>;
};


export type QueryConversationsArgs = {
  filters?: InputMaybe<ConversationFilters>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<ConversationSorting>;
};


export type QueryCountDlqRecordsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryCountDocumentsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryCountFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryCountFoldersArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountKgPipelineJobsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountKnowledgeGraphsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountMessagesArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountOriginalDocumentsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountS3AssetsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCountTaskStatesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryCountWorkflowsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryDebugPlatformAppArgs = {
  platformAppId: Scalars['ID']['input'];
};


export type QueryFindActiveKnowledgeGraphsByNamespaceArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindActiveKnowledgeGraphsByUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindApiKeyByHashArgs = {
  keyHash: Scalars['String']['input'];
};


export type QueryFindDocumentsByMd5Args = {
  md5List: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFindDocumentsForPurgeArgs = {
  before: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
};


export type QueryFindFieldCategoryWithFieldsArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryFindFieldDefinitionsByCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryFindFirstAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstAgentFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstAgentSyncConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstAgentToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstArtifactArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstChatRoomArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstFormFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstFormTemplateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstKgPipelineJobArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstKnowledgeGraphArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstKnowledgeGraphDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstLanguageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstMessageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstModelArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstOriginalDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstParsedDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstS3AssetArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstSourceDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstUehArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstUrlConfigArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryFindFirstUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFirstWorkflowArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindFolderByIdArgs = {
  id: Scalars['String']['input'];
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubFolders?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindFormTemplateByFormIdArgs = {
  formId: Scalars['String']['input'];
};


export type QueryFindFormTemplatesPaginatedArgs = {
  input?: InputMaybe<FindFormTemplatesInput>;
};


export type QueryFindKgPipelineJobsByUserAndNamespaceArgs = {
  namespace: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryFindKnowledgeGraphByUserNamespaceAndTypeArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindKnowledgeGraphsByNamespaceArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindKnowledgeGraphsByPickleMd5Args = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindKnowledgeGraphsByUserAndNamespaceArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindKnowledgeGraphsByUserIdArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindLatestKgPipelineJobArgs = {
  namespace: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryFindManyAgentFoldersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyAgentSyncConfigsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyAgentToolsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyAgentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyArtifactsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyChatRoomsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyDlqRecordsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyFoldersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyFormFoldersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyFormTemplatesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyKgPipelineJobsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyKnowledgeGraphDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyKnowledgeGraphsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyKnowledgeGraphsWithMetadataArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyLanguagesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyMessagesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyModelsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyOriginalDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyParsedDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyS3AssetsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManySourceDocumentsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManySyncArticlesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyTaskStatesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyToolsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyUehArticlesArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyUrlConfigsArgs = {
  args?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryFindManyUsersArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindManyWorkflowsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindMyFirstUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindMyUniqueUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindPlanProposalArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindRunningKgPipelineJobsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryFindS3AssetsByDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryFindS3AssetsByKnowledgeGraphArgs = {
  knowledgeGraphId: Scalars['String']['input'];
};


export type QueryFindS3AssetsByPipelineJobArgs = {
  pipelineJobId: Scalars['String']['input'];
};


export type QueryFindTaskByTaskIdArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryFindTaskCheckpointsArgs = {
  taskStateId: Scalars['String']['input'];
};


export type QueryFindTaskEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskStateId: Scalars['String']['input'];
};


export type QueryFindTasksByUserArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFindUniqueAgentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueAgentFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueAgentSyncConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueAgentToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueArtifactArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueChatRoomArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueDlqRecordArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueFieldCategoryArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueFieldDefinitionArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueFolderArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueFormParsedContentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueFormTemplateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueKgPipelineJobArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueKnowledgeGraphArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueKnowledgeGraphDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueLanguageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueMessageArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueModelArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueOriginalDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueParsedDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueS3AssetArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueSourceDocumentArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueSyncArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueTaskCheckpointArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueTaskStateArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueToolArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueUehArticleArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueUrlConfigArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueUserArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueUserDynamicFieldsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUniqueWorkflowArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryFindUserDynamicFieldsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGenerateTeamsAppManifestArgs = {
  platformAppId: Scalars['ID']['input'];
};


export type QueryGetActiveConversationInGroupArgs = {
  chatRoomId: Scalars['String']['input'];
};


export type QueryGetArticlesByAgentArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryGetCalendarEventsArgs = {
  calendarId: Scalars['String']['input'];
  filter?: InputMaybe<EventFilterInput>;
};


export type QueryGetChannelMessagesWithRepliesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  channelId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['String']['input'];
};


export type QueryGetChatRoomAutoReplyArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryGetChatbotUpdateStatusArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryGetCurrentUserTeamRoleArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryGetCustomerDashboardArgs = {
  filters?: InputMaybe<CustomerFilters>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<CustomerSorting>;
};


export type QueryGetCustomerFieldsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetCustomerScoreArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetDocumentVersionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDocumentVersionsArgs = {
  documentId: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryGetDocumentsByKnowledgeGraphIdArgs = {
  knowledgeGraphId: Scalars['String']['input'];
};


export type QueryGetEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetFacebookChannelHealthArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryGetGroupCalendarEventsArgs = {
  input: GroupCalendarInput;
};


export type QueryGetKgDeltasArgs = {
  knowledgeGraphId: Scalars['String']['input'];
};


export type QueryGetKnowledgeGraphDocumentStatsArgs = {
  knowledgeGraphId: Scalars['String']['input'];
};


export type QueryGetKnowledgeGraphHealthArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryGetKnowledgeGraphUsageStatsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QueryGetKnowledgeGraphsByDocumentIdArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetLatestCheckpointArgs = {
  taskStateId: Scalars['String']['input'];
};


export type QueryGetMicrosoftChannelArgs = {
  channelId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetMicrosoftChannelMessagesArgs = {
  channelId: Scalars['String']['input'];
  filter?: InputMaybe<ChannelMessageFilter>;
  teamId: Scalars['String']['input'];
};


export type QueryGetMicrosoftChatMessagesArgs = {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMicrosoftChatPinnedMessagesArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryGetMicrosoftFavoriteChannelsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetMicrosoftMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type QueryGetMicrosoftMessageRepliesArgs = {
  channelId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type QueryGetMicrosoftPrivateChannelsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetMicrosoftStandardChannelsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetMicrosoftTeamChannelsArgs = {
  filter?: InputMaybe<ChannelFilter>;
  teamId: Scalars['ID']['input'];
};


export type QueryGetMyTeamInvitationsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetMyTeamTagsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetMyTeamTagsSimpleArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetOneDriveCredentialStatusArgs = {
  realm: Scalars['String']['input'];
};


export type QueryGetOneDriveFolderTreeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRetentionSettingsArgs = {
  namespace: Scalars['String']['input'];
};


export type QueryGetSyncStatisticsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTagMembersArgs = {
  filter?: InputMaybe<TagMemberFilterInput>;
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetTaskStatisticsArgs = {
  namespace?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTeamChannelsArgs = {
  platformAppId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamMembersArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryGetTeamPendingInvitationsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamTagArgs = {
  tagId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamsFromAppArgs = {
  platformAppId: Scalars['ID']['input'];
};


export type QueryGetUehArticlesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryGetUehArticlesCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUehSyncStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetUnresolvedDlqRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserAgentsArgs = {
  query?: InputMaybe<AgentQueryDto>;
};


export type QueryGetUserChannelHistoryArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserFieldValueArgs = {
  fieldName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserLabelsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserWorkflowsArgs = {
  query?: InputMaybe<WorkflowQueryDto>;
};


export type QueryGetZaloChannelHealthArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryHelloArgs = {
  name: Scalars['String']['input'];
};


export type QueryHighPriorityNotesArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeArgs = {
  token: Scalars['String']['input'];
};


export type QueryMicrosoftCalendarArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryMicrosoftChatArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryMicrosoftChatMembersArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryMicrosoftEventArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryMicrosoftEventAttendeesArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryMicrosoftEventsArgs = {
  filter?: InputMaybe<EventFilterInput>;
};


export type QueryMicrosoftFindMeetingTimesArgs = {
  attendees: Array<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryMicrosoftFreeBusyArgs = {
  input: FreeBusyQueryInput;
};


export type QueryMicrosoftGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryMicrosoftGroupsArgs = {
  filter?: InputMaybe<GroupFilter>;
};


export type QueryMicrosoftUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMicrosoftUserByMicrosoftIdArgs = {
  microsoftId: Scalars['String']['input'];
};


export type QueryMicrosoftUserByUpnArgs = {
  userPrincipalName: Scalars['String']['input'];
};


export type QueryMonthEventsArgs = {
  monthOffset?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyConversationNotesArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPackagesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPeoplePickerSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryPinnedConversationNotesArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformAppArgs = {
  id: Scalars['ID']['input'];
  includeChannels?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlatformAppsArgs = {
  includeChannels?: InputMaybe<Scalars['Boolean']['input']>;
  platformCode?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformAppsWithQueryArgs = {
  query: GetAllPlatformAppsQueryInput;
};


export type QueryPlatformsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewKnowledgeGraphOperationsArgs = {
  args: Scalars['JSONObject']['input'];
};


export type QuerySearchCalendarsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchChannelsArgs = {
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchMicrosoftChannelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerySearchMicrosoftChatMessagesArgs = {
  input: ChatMessageSearchInput;
};


export type QuerySearchMicrosoftUsersArgs = {
  input: SearchMicrosoftUsersInput;
};


export type QuerySearchPeopleArgs = {
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchTeamMembersArgs = {
  enableGuest?: InputMaybe<Scalars['Boolean']['input']>;
  forTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
  includeDLs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerySearchTeamMembersForTagsArgs = {
  enableGuest?: InputMaybe<Scalars['Boolean']['input']>;
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
  includeDLs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type QuerySearchTeamsArgs = {
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchUnifiedArgs = {
  options?: InputMaybe<SearchOptionsInput>;
  query: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  enableGuest?: InputMaybe<Scalars['Boolean']['input']>;
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
  includeDLs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
};


export type QuerySearchUsersByFieldValueArgs = {
  fieldName: Scalars['String']['input'];
  value: Scalars['JSONObject']['input'];
};


export type QuerySearchUsersForTeamArgs = {
  enableGuest?: InputMaybe<Scalars['Boolean']['input']>;
  includeBots?: InputMaybe<Scalars['Boolean']['input']>;
  includeDLs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryTodayEventsArgs = {
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingEventsArgs = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateFieldValuesArgs = {
  fieldValues: Scalars['JSONObject']['input'];
};


export type QueryValidateSyncUrlsArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type QueryWebhookGetActiveChannelAgentArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryWebhookGetChannelByPageIdArgs = {
  input: GetChannelByPageIdInput;
};


export type QueryWebhookGetChannelWithTokensArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryWebhookGetChatRoomMessagesArgs = {
  chatRoomId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebhookGetUserByPlatformIdArgs = {
  input: GetUserByPlatformIdInput;
};


export type QueryWebhookGetUserQuotaArgs = {
  channelId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryWeekEventsArgs = {
  timeZone?: InputMaybe<Scalars['String']['input']>;
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueStats = {
  __typename?: 'QueueStats';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  stuck: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type RecurrencePattern = {
  __typename?: 'RecurrencePattern';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  firstDayOfWeek?: Maybe<DayOfWeek>;
  index?: Maybe<Scalars['String']['output']>;
  interval: Scalars['Int']['output'];
  month?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type RecurrencePatternInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  /** First day of week for weekly patterns */
  firstDayOfWeek?: InputMaybe<DayOfWeek>;
  index?: InputMaybe<WeekIndex>;
  interval?: Scalars['Int']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  type: RecurrencePatternType;
};

/** Type of recurrence pattern */
export enum RecurrencePatternType {
  AbsoluteMonthly = 'ABSOLUTE_MONTHLY',
  AbsoluteYearly = 'ABSOLUTE_YEARLY',
  Daily = 'DAILY',
  RelativeMonthly = 'RELATIVE_MONTHLY',
  RelativeYearly = 'RELATIVE_YEARLY',
  Weekly = 'WEEKLY'
}

export type RecurrenceRange = {
  __typename?: 'RecurrenceRange';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  numberOfOccurrences?: Maybe<Scalars['Int']['output']>;
  recurrenceTimeZone?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type RecurrenceRangeInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  numberOfOccurrences?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  type: RecurrenceRangeType;
};

/** Type of recurrence range */
export enum RecurrenceRangeType {
  EndDate = 'END_DATE',
  NoEnd = 'NO_END',
  Numbered = 'NUMBERED'
}

export type RefreshTokenDto = {
  refresh_token: Scalars['String']['input'];
};

export type RegisterDto = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RelationshipInfo = {
  __typename?: 'RelationshipInfo';
  hasExistingRelationship: Scalars['Boolean']['output'];
  relationshipCreated: Scalars['Boolean']['output'];
  wasActivated: Scalars['Boolean']['output'];
};

export type RemoveChannelFromAppDto = {
  /** Channel ID to remove from the app */
  channelId: Scalars['String']['input'];
  /** Platform App ID */
  platformAppId: Scalars['String']['input'];
};

export type RemoveChannelFromAppResponse = {
  __typename?: 'RemoveChannelFromAppResponse';
  /** Whether the channel was soft deleted due to no remaining active apps */
  channelSoftDeleted: Scalars['Boolean']['output'];
  /** Result message */
  message: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type RemoveGroupMemberInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveTagInput = {
  /** Conversation ID */
  conversationId: Scalars['String']['input'];
  /** Tag ID */
  tagId: Scalars['String']['input'];
};

export type RespondToEventInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  response: Scalars['String']['input'];
  sendResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response status for event attendees */
export enum ResponseStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  None = 'NONE',
  NotResponded = 'NOT_RESPONDED',
  Organizer = 'ORGANIZER',
  TentativelyAccepted = 'TENTATIVELY_ACCEPTED'
}

export type RetentionSettings = {
  __typename?: 'RetentionSettings';
  createdAt: Scalars['DateTime']['output'];
  documentRetentionDays: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  kgRetentionDays: Scalars['Int']['output'];
  namespace: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** User role */
export enum Role {
  Admin = 'ADMIN',
  Facebook = 'FACEBOOK',
  Moderator = 'MODERATOR',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER',
  Website = 'WEBSITE',
  Zalo = 'ZALO'
}

/** S3 Asset - Tracks files stored in MinIO/S3 buckets for KG Pipeline */
export type S3Asset = {
  __typename?: 'S3Asset';
  /** Type of asset (IMAGE, SHEET_CSV, MARKDOWN, etc.) */
  assetType: S3AssetType;
  /** S3 bucket name (kg-parsed-data, kg-images, kg-sheets, kg-exports) */
  bucket: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Document ID if linked to a document */
  documentId?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  fileSize: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** KnowledgeGraph ID if linked to a KG */
  knowledgeGraphId?: Maybe<Scalars['String']['output']>;
  /** MD5 hash of file content for deduplication */
  md5Hash: Scalars['String']['output'];
  /** MIME type (e.g., "image/png", "text/markdown") */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Full S3 object key (path) */
  objectKey: Scalars['String']['output'];
  /** Original filename */
  originalName?: Maybe<Scalars['String']['output']>;
  /** Original path before processing */
  originalPath?: Maybe<Scalars['String']['output']>;
  /** Pipeline job ID that created this asset */
  pipelineJobId?: Maybe<Scalars['String']['output']>;
  /** Which module (1-4) created this asset */
  pipelineStage?: Maybe<Scalars['Int']['output']>;
  /** When this asset was processed */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of S3 asset in the KG Pipeline storage */
export enum S3AssetType {
  /** Image files (png, jpg, etc.) */
  Image = 'IMAGE',
  /** Markdown document content */
  Markdown = 'MARKDOWN',
  /** md5_mapping.json file */
  Md5Mapping = 'MD5_MAPPING',
  /** KG pickle export files */
  Pickle = 'PICKLE',
  /** CSV spreadsheet data */
  SheetCsv = 'SHEET_CSV',
  /** Parquet spreadsheet data */
  SheetParquet = 'SHEET_PARQUET'
}

export type SaveMessageInput = {
  chatRoomId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  text: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveTeamsChannelsInput = {
  platformAppId: Scalars['ID']['input'];
  selectedChannels: Array<SelectedChannelInput>;
};

export type SaveTeamsChannelsResponse = {
  __typename?: 'SaveTeamsChannelsResponse';
  message?: Maybe<Scalars['String']['output']>;
  savedChannels: Array<AssignedChannelData>;
  success: Scalars['Boolean']['output'];
};

/** Types of entities that can be searched */
export enum SearchEntityType {
  Channel = 'CHANNEL',
  Chat = 'CHAT',
  DriveItem = 'DRIVE_ITEM',
  Message = 'MESSAGE',
  People = 'PEOPLE',
  Team = 'TEAM'
}

export type SearchFilterInput = {
  /** Filter by company */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Filter by department */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Filter by people subtypes */
  peopleSubtypes?: InputMaybe<Array<PeopleSubtype>>;
  /** Filter by people types */
  peopleTypes?: InputMaybe<Array<PeopleType>>;
};

export type SearchGroup = {
  __typename?: 'SearchGroup';
  /** Search suggestions in this group */
  suggestions: Array<SearchSuggestion>;
  /** Type of entities in this group */
  type: SearchEntityType;
};

export type SearchInstrumentation = {
  __typename?: 'SearchInstrumentation';
  /** Trace ID for debugging and monitoring */
  traceId: Scalars['String']['output'];
};

export type SearchMicrosoftUsersInput = {
  query: Scalars['String']['input'];
  select?: InputMaybe<Array<Scalars['String']['input']>>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchOptionsInput = {
  /** Include channels in search results */
  includeChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include chats in search results */
  includeChats?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include people in search results */
  includePeople?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include teams in search results */
  includeTeams?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of results per entity type */
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** Chat type (for chats) */
  chatType?: Maybe<Scalars['String']['output']>;
  /** Company name (for people) */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Department (for people) */
  department?: Maybe<Scalars['String']['output']>;
  /** Description (for teams/channels) */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email addresses (only for People entities) */
  emailAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** External directory object ID */
  externalDirectoryObjectId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** IM address (SIP) */
  imAddress?: Maybe<Scalars['String']['output']>;
  /** Job title (for people) */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Microsoft Resource Identifier */
  mri?: Maybe<Scalars['String']['output']>;
  /** Subtype of people entity (only for People entities) */
  peopleSubtype?: Maybe<PeopleSubtype>;
  /** Type of people entity (only for People entities) */
  peopleType?: Maybe<PeopleType>;
  /** Properties that matched the query */
  propertyHits: Array<Scalars['String']['output']>;
  /** Original query text */
  queryText: Scalars['String']['output'];
  /** Reference ID for tracking */
  referenceId: Scalars['String']['output'];
  /** Team ID (for channels) */
  teamId?: Maybe<Scalars['String']['output']>;
  /** Display text */
  text: Scalars['String']['output'];
  /** Topic (for chats) */
  topic?: Maybe<Scalars['String']['output']>;
  /** User principal name */
  userPrincipalName?: Maybe<Scalars['String']['output']>;
  /** Web URL */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type SelectedChannelInput = {
  /** Optional: Assign agent immediately, or leave empty to assign later */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
  channelName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
  teamName: Scalars['String']['input'];
};

export type SendChannelMessageInput = {
  /** Message attachments (JSON string) */
  attachments?: InputMaybe<Scalars['String']['input']>;
  /** Message content and type */
  body: MessageBodyInput;
  /** Message importance level */
  importance?: InputMaybe<MessageImportance>;
  /** Message mentions (JSON string) */
  mentions?: InputMaybe<Scalars['String']['input']>;
  /** ID of message being replied to (for threading) */
  replyToId?: InputMaybe<Scalars['String']['input']>;
  /** Message subject */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SendOutboundMessageInput = {
  /** Optional: Agent/Staff ID sending the message. If not provided, will use current user from context */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  /** Attachments to send with the message */
  attachments?: InputMaybe<Array<MessageAttachmentInput>>;
  /** ID of the chat room to send message to */
  chatRoomId: Scalars['ID']['input'];
  /** Text content of the message to send */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendOutboundMessageResponse = {
  __typename?: 'SendOutboundMessageResponse';
  /** Attachments that were sent with the message */
  attachments?: Maybe<Array<MessageAttachmentOutput>>;
  error?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  /** Platform where message was sent (facebook, zalo, website) */
  platform?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** Text content that was sent */
  text?: Maybe<Scalars['String']['output']>;
};

export type SendOutboundMessageWithFilesInput = {
  /** Optional: Agent/Staff ID sending the message. If not provided, will use current user from context */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the chat room to send message to */
  chatRoomId: Scalars['ID']['input'];
  /** Files to upload and send as attachments */
  files?: InputMaybe<Array<FileUploadInput>>;
  /** Text content of the message to send */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendOutboundMessageWithFilesResponse = {
  __typename?: 'SendOutboundMessageWithFilesResponse';
  error?: Maybe<Scalars['String']['output']>;
  /** Number of files processed */
  filesProcessed?: Maybe<Scalars['Int']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  /** Platform where message was sent (facebook, zalo, website) */
  platform?: Maybe<Scalars['String']['output']>;
  /** Processed attachments that were uploaded and sent */
  processedAttachments?: Maybe<Array<ProcessedAttachment>>;
  success: Scalars['Boolean']['output'];
  /** Text content that was sent */
  text?: Maybe<Scalars['String']['output']>;
};

export type SetReactionInput = {
  /** Unicode emoji to set as reaction (e.g., "👍", "❤️", "😂") */
  reactionType: Scalars['String']['input'];
};

export type SocialUserData = {
  __typename?: 'SocialUserData';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGuest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  platformType?: Maybe<PlatformCode>;
  platformUserId?: Maybe<Scalars['String']['output']>;
  realm: Scalars['String']['output'];
};

/** Sort direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceDocument = {
  __typename?: 'SourceDocument';
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type SyncArticle = {
  __typename?: 'SyncArticle';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  duplicateOfId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  menu?: Maybe<Scalars['String']['output']>;
  namespace: Scalars['String']['output'];
  rawContentMd5: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourcePublishedAt?: Maybe<Scalars['DateTime']['output']>;
  splitCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type SyncDateStats = {
  __typename?: 'SyncDateStats';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SyncStatistics = {
  __typename?: 'SyncStatistics';
  averageSyncDuration: Scalars['Int']['output'];
  failedSyncs: Scalars['Int']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  successfulSyncs: Scalars['Int']['output'];
  syncsByDate: Array<SyncDateStats>;
  totalArticlesAdded: Scalars['Int']['output'];
  totalArticlesDeleted: Scalars['Int']['output'];
  totalArticlesProcessed: Scalars['Int']['output'];
  totalArticlesUpdated: Scalars['Int']['output'];
  totalSyncs: Scalars['Int']['output'];
};

export type SyncUrlConfig = {
  __typename?: 'SyncUrlConfig';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SyncUrlDateRangeResult = {
  __typename?: 'SyncUrlDateRangeResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  syncedDates: Array<Scalars['String']['output']>;
  totalArticles: Scalars['Int']['output'];
  totalNew: Scalars['Int']['output'];
  totalUpdated: Scalars['Int']['output'];
};

export type SyncUrlResult = {
  __typename?: 'SyncUrlResult';
  articlesCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  newCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  syncDate?: Maybe<Scalars['String']['output']>;
  updatedCount: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TagAssignedByUser = {
  __typename?: 'TagAssignedByUser';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type TagCard = {
  __typename?: 'TagCard';
  currentMemberIsPartOfTag: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
  memberIds: Array<Scalars['String']['output']>;
  scheduledMembers: Array<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagId: Scalars['String']['output'];
  tagName: Scalars['String']['output'];
  tagType: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Categories for conversation tags */
export enum TagCategory {
  Complaint = 'COMPLAINT',
  Customer = 'CUSTOMER',
  General = 'GENERAL',
  Sales = 'SALES',
  Support = 'SUPPORT',
  Technical = 'TECHNICAL'
}

export type TagFilterInput = {
  assignedToCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<TagType>;
};

export type TagMember = {
  __typename?: 'TagMember';
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tagId: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type TagMemberFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** The type of the teamwork tag */
export enum TagType {
  Scheduled = 'SCHEDULED',
  Standard = 'STANDARD',
  UnknownFutureValue = 'UNKNOWN_FUTURE_VALUE'
}

export type TagUsageStats = {
  __typename?: 'TagUsageStats';
  /** Number of conversations with this tag */
  conversationCount: Scalars['Int']['output'];
  /** Last used date */
  lastUsedAt: Scalars['String']['output'];
  /** Tag details */
  tag: ConversationTag;
};

/** Task checkpoint for resume capability */
export type TaskCheckpoint = {
  __typename?: 'TaskCheckpoint';
  /** Checkpoint state data */
  checkpointData: Scalars['JSONObject']['output'];
  /** Checkpoint sequence number */
  checkpointNumber: Scalars['Int']['output'];
  /** When checkpoint was created */
  createdAt: Scalars['DateTime']['output'];
  /** Checkpoint ID */
  id: Scalars['String']['output'];
  /** Number of items processed at checkpoint */
  itemsProcessed: Scalars['Int']['output'];
  /** Total items to process */
  itemsTotal?: Maybe<Scalars['Int']['output']>;
  /** Progress percentage at checkpoint time */
  progressPercentage: Scalars['Int']['output'];
  /** S3 path for large checkpoint data */
  s3CheckpointPath?: Maybe<Scalars['String']['output']>;
  /** Parent task state */
  taskState?: Maybe<TaskState>;
  /** Parent task state ID */
  taskStateId: Scalars['String']['output'];
};

/** Task lifecycle event (audit log) */
export type TaskEvent = {
  __typename?: 'TaskEvent';
  /** When event occurred */
  createdAt: Scalars['DateTime']['output'];
  /** Event-specific payload data */
  eventPayload: Scalars['JSONObject']['output'];
  /** Event type */
  eventType: TaskEventType;
  /** Event ID */
  id: Scalars['String']['output'];
  /** Parent task state */
  taskState?: Maybe<TaskState>;
  /** Parent task state ID */
  taskStateId: Scalars['String']['output'];
};

/** Task event types for audit log */
export enum TaskEventType {
  /** Task cancelled */
  Cancelled = 'CANCELLED',
  /** Checkpoint saved */
  Checkpointed = 'CHECKPOINTED',
  /** Task finished successfully */
  Completed = 'COMPLETED',
  /** Task failed (may retry) */
  Failed = 'FAILED',
  /** Progress update */
  Progress = 'PROGRESS',
  /** Task sent to message queue */
  Queued = 'QUEUED',
  /** Task re-sent to queue */
  Requeued = 'REQUEUED',
  /** Task resumed from checkpoint */
  Resumed = 'RESUMED',
  /** Task scheduled for retry */
  Retrying = 'RETRYING',
  /** Lease expired, task stale */
  StaleDetected = 'STALE_DETECTED',
  /** Worker began processing */
  Started = 'STARTED',
  /** Task initially created */
  Submitted = 'SUBMITTED'
}

/** Priority level for task queue routing */
export enum TaskPriority {
  /** Lowest priority, batch processing */
  Batch = 'BATCH',
  /** Highest priority, dedicated queue */
  Critical = 'CRITICAL',
  /** High priority tasks */
  High = 'HIGH',
  /** Low priority, background tasks */
  Low = 'LOW',
  /** Standard priority (default) */
  Normal = 'NORMAL'
}

/** Worker v2 task state tracking */
export type TaskState = {
  __typename?: 'TaskState';
  /** Related entity counts */
  _count?: Maybe<TaskStateCount>;
  /** Total number of checkpoints created */
  checkpointCount: Scalars['Int']['output'];
  /** Task checkpoints */
  checkpoints?: Maybe<Array<TaskCheckpoint>>;
  /** When task completed (success or failure) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Dead letter queue records */
  dlqRecords?: Maybe<Array<DlqRecord>>;
  /** Duration in minutes (calculated) */
  durationMinutes?: Maybe<Scalars['Float']['output']>;
  /** Error details if failed */
  errorData?: Maybe<Scalars['JSONObject']['output']>;
  /** Task events (audit log) */
  events?: Maybe<Array<TaskEvent>>;
  id: Scalars['ID']['output'];
  /** Task input parameters */
  inputData?: Maybe<Scalars['JSONObject']['output']>;
  /** Whether the task is stale (lease expired while RUNNING) */
  isStale: Scalars['Boolean']['output'];
  /** Last successful checkpoint ID */
  lastCheckpointId?: Maybe<Scalars['String']['output']>;
  /** When the lease expires (for stale detection) */
  leaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Worker ID that holds the lease */
  leaseOwner?: Maybe<Scalars['String']['output']>;
  /** Maximum retry attempts allowed */
  maxRetries: Scalars['Int']['output'];
  /** Product namespace */
  namespace?: Maybe<Scalars['String']['output']>;
  /** Next scheduled retry time */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  /** Task priority for queue routing */
  priority: TaskPriority;
  /** Human-readable progress message */
  progressMessage?: Maybe<Scalars['String']['output']>;
  /** Progress percentage (0-100) */
  progressPercentage: Scalars['Int']['output'];
  /** Task result/output data */
  resultData?: Maybe<Scalars['JSONObject']['output']>;
  /** Current retry attempt count */
  retryCount: Scalars['Int']['output'];
  /** Scheduled execution time */
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** When task started executing */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current task status */
  status: TaskStatus;
  /** Unique task identifier for idempotency */
  taskId: Scalars['String']['output'];
  /** Task type (e.g., kg_import, kg_build, document_ingest) */
  taskType: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Task owner */
  user?: Maybe<User>;
  /** User who owns this task */
  userId: Scalars['String']['output'];
  /** Version for optimistic locking */
  version: Scalars['Int']['output'];
};

export type TaskStateCount = {
  __typename?: 'TaskStateCount';
  /** Number of checkpoints for this task */
  checkpoints: Scalars['Int']['output'];
  /** Number of DLQ records for this task */
  dlqRecords: Scalars['Int']['output'];
  /** Number of events for this task */
  events: Scalars['Int']['output'];
};

/** Task statistics summary */
export type TaskStatistics = {
  __typename?: 'TaskStatistics';
  /** Average task duration in minutes */
  avgDurationMinutes?: Maybe<Scalars['Float']['output']>;
  /** Total cancelled tasks */
  cancelledCount: Scalars['Int']['output'];
  /** Total completed tasks */
  completedCount: Scalars['Int']['output'];
  /** When statistics were computed */
  computedAt: Scalars['DateTime']['output'];
  /** Total failed tasks */
  failedCount: Scalars['Int']['output'];
  /** Total pending tasks */
  pendingCount: Scalars['Int']['output'];
  /** Total queued tasks */
  queuedCount: Scalars['Int']['output'];
  /** Total retrying tasks */
  retryingCount: Scalars['Int']['output'];
  /** Total running tasks */
  runningCount: Scalars['Int']['output'];
  /** Statistics period start */
  since?: Maybe<Scalars['DateTime']['output']>;
  /** Success rate percentage */
  successRate?: Maybe<Scalars['Float']['output']>;
  /** Unresolved DLQ records count */
  unresolvedDlqCount: Scalars['Int']['output'];
};

/** Task lifecycle status */
export enum TaskStatus {
  /** Task cancelled by user/admin */
  Cancelled = 'CANCELLED',
  /** Task finished successfully */
  Completed = 'COMPLETED',
  /** Task failed after all retries */
  Failed = 'FAILED',
  /** Task paused (checkpoint saved) */
  Paused = 'PAUSED',
  /** Task created, not yet queued */
  Pending = 'PENDING',
  /** Task sent to RabbitMQ */
  Queued = 'QUEUED',
  /** Task failed, awaiting retry */
  Retrying = 'RETRYING',
  /** Worker is processing */
  Running = 'RUNNING'
}

export type Team = {
  __typename?: 'Team';
  classSettings?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdDateTime: Scalars['DateTime']['output'];
  /** Current user role in this team (computed field) */
  currentUserRole?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discoveredBy?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  funSettings?: Maybe<Scalars['String']['output']>;
  guestSettings?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  /** Whether current user is owner of this team (computed field) */
  isCurrentUserOwner?: Maybe<Scalars['Boolean']['output']>;
  isMembershipLimitedToOwners: Scalars['Boolean']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  memberSettings?: Maybe<Scalars['String']['output']>;
  messagingSettings?: Maybe<Scalars['String']['output']>;
  /** User permissions for this team */
  permissions?: Maybe<TeamPermissions>;
  specialization: TeamSpecialization;
  /** Team statistics and member info */
  stats?: Maybe<TeamStats>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: TeamVisibility;
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type TeamChannelsResponse = {
  __typename?: 'TeamChannelsResponse';
  channels: Array<ChannelData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TeamData = {
  __typename?: 'TeamData';
  channelCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type TeamFunSettingsInput = {
  /** Enable custom memes */
  allowCustomMemes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable Giphy usage */
  allowGiphy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable stickers and memes */
  allowStickersAndMemes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Giphy content rating (Strict or Moderate) */
  giphyContentRating?: InputMaybe<Scalars['String']['input']>;
};

export type TeamGuestSettingsInput = {
  /** Guests can add and update channels */
  allowCreateUpdateChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Guests can delete channels */
  allowDeleteChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy: Scalars['String']['output'];
  invitedByDisplayName: Scalars['String']['output'];
  invitedUserDisplayName: Scalars['String']['output'];
  invitedUserEmail: Scalars['String']['output'];
  invitedUserId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  roles: Array<ConversationMemberRole>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  visibleHistoryStartDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamMemberPermissions = {
  __typename?: 'TeamMemberPermissions';
  /** Can archive team */
  canArchiveTeam: Scalars['Boolean']['output'];
  /** Can create channels */
  canCreateChannels: Scalars['Boolean']['output'];
  /** Can delete channels */
  canDeleteChannels: Scalars['Boolean']['output'];
  /** Can delete the team */
  canDeleteTeam: Scalars['Boolean']['output'];
  /** Can add/remove members */
  canManageMembers: Scalars['Boolean']['output'];
  /** Can manage tags */
  canManageTags: Scalars['Boolean']['output'];
  /** Can manage team settings */
  canManageTeam: Scalars['Boolean']['output'];
  /** Can view team analytics */
  canViewAnalytics: Scalars['Boolean']['output'];
};

export type TeamMemberSettingsInput = {
  /** Members can add and update channels */
  allowAddRemoveApps?: InputMaybe<Scalars['Boolean']['input']>;
  /** Members can add and remove tabs */
  allowAddRemoveTabs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Members can create private channels */
  allowCreatePrivateChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Members can create and update channels */
  allowCreateUpdateChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Members can create, update, and remove connectors */
  allowCreateUpdateRemoveConnectors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Members can delete and restore channels */
  allowDeleteChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMemberWithPermissions = {
  __typename?: 'TeamMemberWithPermissions';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Computed permissions based on role */
  permissions: TeamMemberPermissions;
  /** Primary role (highest role if multiple) */
  primaryRole: ConversationMemberRole;
  roles: Array<ConversationMemberRole>;
  /** Tags assigned to this member */
  tags: Array<MemberTag>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  visibleHistoryStartDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamMessagingSettingsInput = {
  /** Enable @channel or @[channel name] mentions */
  allowChannelMentions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable owners to delete any message */
  allowOwnerDeleteMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable @team or @[team name] mentions */
  allowTeamMentions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable users to delete their messages */
  allowUserDeleteMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable users to edit their messages */
  allowUserEditMessages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamPermissions = {
  __typename?: 'TeamPermissions';
  /** Can create channels in this team */
  canCreateChannels: Scalars['Boolean']['output'];
  /** Can delete channels in this team */
  canDeleteChannels: Scalars['Boolean']['output'];
  /** Can delete this team */
  canDeleteTeam: Scalars['Boolean']['output'];
  /** Can manage apps and tabs */
  canManageApps: Scalars['Boolean']['output'];
  /** Can manage existing channels */
  canManageChannels: Scalars['Boolean']['output'];
  /** Can add/remove team members */
  canManageMembers: Scalars['Boolean']['output'];
  /** Can manage team settings */
  canManageTeam: Scalars['Boolean']['output'];
  /** Can send messages in team channels */
  canSendMessages: Scalars['Boolean']['output'];
};

/** Indicates whether the team is intended for a particular use case */
export enum TeamSpecialization {
  EducationClass = 'EDUCATION_CLASS',
  EducationProfessionalLearningCommunity = 'EDUCATION_PROFESSIONAL_LEARNING_COMMUNITY',
  EducationStaff = 'EDUCATION_STAFF',
  EducationStandard = 'EDUCATION_STANDARD',
  HealthcareCareCoordination = 'HEALTHCARE_CARE_COORDINATION',
  HealthcareStandard = 'HEALTHCARE_STANDARD',
  None = 'NONE',
  UnknownFutureValue = 'UNKNOWN_FUTURE_VALUE'
}

export type TeamStats = {
  __typename?: 'TeamStats';
  /** Number of guests in this team */
  guestCount: Scalars['Int']['output'];
  /** Total number of members in this team */
  memberCount: Scalars['Int']['output'];
  /** Number of owners in this team */
  ownerCount: Scalars['Int']['output'];
  /** Number of regular members (excluding owners) */
  regularMemberCount: Scalars['Int']['output'];
};

export type TeamTagSettings = {
  __typename?: 'TeamTagSettings';
  automaticTagsNeedsRefresh: Scalars['Boolean']['output'];
  disallowedSources: Array<Scalars['String']['output']>;
  enableAutomaticTags?: Maybe<Scalars['Boolean']['output']>;
  onlyOwnersCanUpdate: Scalars['Boolean']['output'];
  tagCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/** The visibility of the team */
export enum TeamVisibility {
  HiddenMembership = 'HIDDEN_MEMBERSHIP',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type TeamsAppManifest = {
  __typename?: 'TeamsAppManifest';
  appId: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  developerName: Scalars['String']['output'];
  manifestJson: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TeamsCalendarEventInput = {
  attendeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  isAllDay?: Scalars['Boolean']['input'];
  isOnlineMeeting?: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type TeamsMessageThread = {
  __typename?: 'TeamsMessageThread';
  /** Timestamp of the last reply */
  lastReplyAt?: Maybe<Scalars['DateTime']['output']>;
  /** Parent message */
  parentMessage: MicrosoftChatMessage;
  /** Replies to the parent message */
  replies: Array<MicrosoftChatMessage>;
  /** Number of replies */
  replyCount: Scalars['Int']['output'];
};

export type TeamsResponse = {
  __typename?: 'TeamsResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  teams: Array<TeamData>;
};

export type TeamworkTag = {
  __typename?: 'TeamworkTag';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt: Scalars['DateTime']['output'];
  memberCount: Scalars['Int']['output'];
  tagType: TagType;
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Tool = {
  __typename?: 'Tool';
  /** Count of related entities */
  _count?: Maybe<ToolCount>;
  agentTools?: Maybe<Array<AgentTool>>;
  /** Auth mode: forward_token | api_key | none */
  callbackAuthMode?: Maybe<Scalars['String']['output']>;
  /** Custom headers for callback request */
  callbackHeaders?: Maybe<Scalars['JSONObject']['output']>;
  /** HTTP method: POST, GET, PUT */
  callbackMethod?: Maybe<Scalars['String']['output']>;
  /** Callback timeout in milliseconds */
  callbackTimeout?: Maybe<Scalars['Int']['output']>;
  /** External endpoint URL for callback */
  callbackUrl?: Maybe<Scalars['String']['output']>;
  configSchema?: Maybe<Scalars['JSONObject']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ToolCount = {
  __typename?: 'ToolCount';
  /** Number of agent tools using this tool */
  agentTools: Scalars['Int']['output'];
};

export type UehArticle = {
  __typename?: 'UehArticle';
  agentId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  htmlContent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  linkNguon: Scalars['String']['output'];
  markdownContent: Scalars['String']['output'];
  menu: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  status: UehArticleStatus;
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  weaviateId?: Maybe<Scalars['String']['output']>;
};

/** UEH Article synchronization status */
export enum UehArticleStatus {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Synced = 'SYNCED'
}

export type UnifiedSearchResponse = {
  __typename?: 'UnifiedSearchResponse';
  /** Grouped search results by entity type */
  groups: Array<SearchGroup>;
  /** Instrumentation data */
  instrumentation: SearchInstrumentation;
};

export type UpdateAgentDto = {
  agentType?: InputMaybe<AgentType>;
  audience?: InputMaybe<AgentAudience>;
  clearFolders?: InputMaybe<Scalars['Boolean']['input']>;
  clearTools?: InputMaybe<Scalars['Boolean']['input']>;
  folderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Form templates folder path. Accepted for forward compatibility; the underlying column was removed in migration 20260309300000_remove_agent_form_folder_path and the value is currently not persisted. */
  formFolderPath?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Explicit Knowledge Graph to bind this agent to. Mutually exclusive with linkActiveKg; when both are set, the explicit ID wins. */
  knowledgeGraphId?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['String']['input']>;
  /** When true, auto-resolve the latest COMPLETED Knowledge Graph in the namespace inferred from the user. Ignored when knowledgeGraphId is provided. */
  linkActiveKg?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AgentStatus>;
  toolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** React Flow workflow definition (nodes, edges, viewport, metadata). When provided, a Workflow row is created and linked to the agent. */
  workflowDefinition?: InputMaybe<Scalars['JSONObject']['input']>;
};

/** Input for updating an API key */
export type UpdateApiKeyInput = {
  /** Update daily limit (set to 0 to remove) */
  dailyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Update expiration date */
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  /** Update the key name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Update rate limit */
  rateLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Update scopes */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateChannelAgentResponse = {
  __typename?: 'UpdateChannelAgentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedChannel?: Maybe<AssignedChannelData>;
};

export type UpdateChannelDto = {
  /** Channel ID to update */
  id: Scalars['String']['input'];
  /** Channel avatar/image URL */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Enable unlimited messaging for enterprise channels */
  isUnlimitedMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Channel/page display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** External platform page/channel ID */
  pageId?: InputMaybe<Scalars['String']['input']>;
  /** Platform ID */
  platformId?: InputMaybe<Scalars['String']['input']>;
  /** Platform-specific webhook URL */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelInput = {
  /** Optional textual description for the channel */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Channel display name (max 50 characters) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether channel should be marked as recommended */
  isFavoriteByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChannelTokensInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  channelPlatformAppId: Scalars['ID']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateConversationNoteInput = {
  /** Note content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Pin this note */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of note */
  noteType?: InputMaybe<NoteType>;
  /** Priority level */
  priority?: InputMaybe<NotePriority>;
};

export type UpdateConversationTagInput = {
  /** Tag category */
  category?: InputMaybe<TagCategory>;
  /** Tag display color (hex) */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Tag description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display order */
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Is tag active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tag name (unique) */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerLabelInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerStageInput = {
  /** Customer lifecycle stage (null to clear) */
  stage?: InputMaybe<CustomerStage>;
  userId: Scalars['String']['input'];
};

export type UpdateDynamicFieldInput = {
  fieldKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventInput = {
  attendees?: InputMaybe<Array<AttendeeInput>>;
  body?: InputMaybe<EventBodyInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<EventClassification>;
  end?: InputMaybe<Scalars['String']['input']>;
  endTimeZone?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<EventImportance>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<EventLocationInput>;
  onlineMeetingProvider?: InputMaybe<OnlineMeetingProvider>;
  recurrence?: InputMaybe<EventRecurrenceInput>;
  sensitivity?: InputMaybe<EventSensitivity>;
  showAs?: InputMaybe<EventShowAs>;
  start?: InputMaybe<Scalars['String']['input']>;
  startTimeZone?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  allowExternalSenders?: InputMaybe<Scalars['Boolean']['input']>;
  autoSubscribeNewMembers?: InputMaybe<Scalars['Boolean']['input']>;
  classification?: InputMaybe<GroupClassification>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  mailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  securityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<GroupVisibility>;
};

export type UpdateMicrosoftChatInput = {
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMicrosoftChatMessageInput = {
  /** Updated message attachments (JSON string) */
  attachments?: InputMaybe<Scalars['String']['input']>;
  /** Updated message content */
  body?: InputMaybe<MessageBodyInput>;
  /** Updated message subject */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePackageDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformDto = {
  code?: InputMaybe<PlatformCode>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResult = {
  __typename?: 'UpdateResult';
  agentId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exportResult?: Maybe<ExportResult>;
  success: Scalars['Boolean']['output'];
  syncResults?: Maybe<Array<MultiUrlSyncResult>>;
};

export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  /** Label for data or business sensitivity */
  classification?: InputMaybe<Scalars['String']['input']>;
  /** Description for the team (max 1,024 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the team */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Fun features (Giphy, stickers, memes) */
  funSettingsInput?: InputMaybe<TeamFunSettingsInput>;
  /** Guest permissions and capabilities */
  guestSettingsInput?: InputMaybe<TeamGuestSettingsInput>;
  /** Member permissions and capabilities */
  memberSettingsInput?: InputMaybe<TeamMemberSettingsInput>;
  /** Messaging and mention settings */
  messagingSettingsInput?: InputMaybe<TeamMessagingSettingsInput>;
  /** Visibility of the team */
  visibility?: InputMaybe<TeamVisibility>;
};

/** Input for updating an existing workflow */
export type UpdateWorkflowDto = {
  /** Workflow definition containing nodes, edges, and viewport */
  definition?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Optional description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether workflow is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is the default workflow */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** New workflow name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UrlConfig = {
  __typename?: 'UrlConfig';
  apiClientId?: Maybe<Scalars['String']['output']>;
  apiClientSecret?: Maybe<Scalars['String']['output']>;
  apiEndpoint: Scalars['String']['output'];
  apiHeaders?: Maybe<Scalars['JSONObject']['output']>;
  articles?: Maybe<Array<UehArticle>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  displayUrl: Scalars['String']['output'];
  folder?: Maybe<Folder>;
  folderId?: Maybe<Scalars['String']['output']>;
  folderName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  syncConfigs?: Maybe<Array<AgentSyncConfig>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type User = {
  __typename?: 'User';
  /** Count of related entities */
  _count?: Maybe<UserCount>;
  chatRooms?: Maybe<Array<ChatRoom>>;
  createdAgents?: Maybe<Array<Agent>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Array<Document>>;
  dynamicFields?: Maybe<UserDynamicFields>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  folders?: Maybe<Array<Folder>>;
  id: Scalars['ID']['output'];
  knowledgeGraphs?: Maybe<Array<KnowledgeGraph>>;
  lastName?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Message>>;
  role: Role;
  sourceDocuments?: Maybe<Array<SourceDocument>>;
  status: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type UserChannelInfo = {
  __typename?: 'UserChannelInfo';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: UserChannelPlatformInfo;
};

export type UserChannelPlatformInfo = {
  __typename?: 'UserChannelPlatformInfo';
  code: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type UserChannelSummary = {
  __typename?: 'UserChannelSummary';
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  conversationCount: Scalars['Int']['output'];
  hasActiveConversation: Scalars['Boolean']['output'];
  lastInteractionAt: Scalars['DateTime']['output'];
  mostRecentConversation?: Maybe<ConversationSummary>;
  platform: UserChannelPlatformInfo;
  platformIcon?: Maybe<Scalars['String']['output']>;
  platformName: Scalars['String']['output'];
  remainingMessages: Scalars['Int']['output'];
};

export type UserCount = {
  __typename?: 'UserCount';
  /** Number of chat rooms owned by this user */
  chatRooms: Scalars['Int']['output'];
  /** Number of agents created by this user */
  createdAgents: Scalars['Int']['output'];
  /** Number of documents owned by this user */
  documents: Scalars['Int']['output'];
  /** Number of folders owned by this user */
  folders: Scalars['Int']['output'];
  /** Number of knowledge graphs owned by this user */
  knowledgeGraphs: Scalars['Int']['output'];
  /** Number of messages created by this user */
  messages: Scalars['Int']['output'];
  /** Number of source documents owned by this user */
  sourceDocuments: Scalars['Int']['output'];
};

export type UserDynamicFields = {
  __typename?: 'UserDynamicFields';
  completedFields: Array<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  fieldValues: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedField?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type UserPresence = {
  __typename?: 'UserPresence';
  activity: Scalars['String']['output'];
  availability: Scalars['String']['output'];
};

export type UserSearchResponse = {
  __typename?: 'UserSearchResponse';
  type: Scalars['String']['output'];
  value: Array<UserSearchResult>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBot: Scalars['Boolean']['output'];
  isDL: Scalars['Boolean']['output'];
  isGuest: Scalars['Boolean']['output'];
  isShortProfile: Scalars['Boolean']['output'];
  isSipDisabled: Scalars['Boolean']['output'];
  mri: Scalars['String']['output'];
  objectId: Scalars['ID']['output'];
  objectType: Scalars['String']['output'];
  peopleSubType: Scalars['String']['output'];
  peopleType: Scalars['String']['output'];
  presence?: Maybe<UserPresence>;
  responseSourceInformation: Scalars['String']['output'];
  sipProxyAddress?: Maybe<Scalars['String']['output']>;
  smtpAddresses: Array<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userPrincipalName: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type ValidateUrlResult = {
  __typename?: 'ValidateUrlResult';
  accessible: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  accessible: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  responseTime: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

/** Week index for monthly recurrence patterns */
export enum WeekIndex {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type Workflow = {
  __typename?: 'Workflow';
  agents?: Maybe<Array<Agent>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  definition: Scalars['JSONObject']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Query parameters for filtering workflows */
export type WorkflowQueryDto = {
  /** Filter by active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by default status */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Records to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Max records to return */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ZaloChannelResponse = {
  __typename?: 'ZaloChannelResponse';
  channel: Channel;
  /** Whether this was an update to existing channel */
  isUpdate: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Whether this channel was restored from soft delete */
  wasRestored: Scalars['Boolean']['output'];
};

export type ZaloConnectionHealthDto = {
  __typename?: 'ZaloConnectionHealthDto';
  channelId: Scalars['String']['output'];
  consecutiveFailures: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isHealthy: Scalars['Boolean']['output'];
  lastPingAt: Scalars['DateTime']['output'];
  oaId: Scalars['String']['output'];
  oaName?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  tokenStatus: Scalars['String']['output'];
};

export type ZaloConnectionSummaryDto = {
  __typename?: 'ZaloConnectionSummaryDto';
  connections: Array<ZaloConnectionHealthDto>;
  expiredTokens: Scalars['Int']['output'];
  expiringTokens: Scalars['Int']['output'];
  healthy: Scalars['Int']['output'];
  invalidTokens: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unhealthy: Scalars['Int']['output'];
};

export type ZaloOAuthCallbackDto = {
  /** Zalo app ID */
  appId: Scalars['String']['input'];
  /** Zalo OAuth authorization code from callback */
  code: Scalars['String']['input'];
  /** Enable unlimited messaging for enterprise Zalo channel */
  isUnlimitedMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zalo Official Account ID */
  oaId: Scalars['String']['input'];
};

export type ZaloTokenRefreshResultDto = {
  __typename?: 'ZaloTokenRefreshResultDto';
  failed: Scalars['Int']['output'];
  failedChannels: Array<Scalars['String']['output']>;
  refreshed: Scalars['Int']['output'];
  refreshedChannels: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type GetChatRoomsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetChatRoomsQuery = { __typename?: 'Query', findManyChatRooms: Array<{ __typename?: 'ChatRoom', id: string, name?: string | null, userId: string, agentId?: string | null, lastMessageId?: string | null, createdAt: any, updatedAt: any, lastMessage?: { __typename?: 'Message', id: string, text?: string | null, role?: MessageRole | null, createdAt: any } | null }> };

export type GetChatRoomsPaginatedQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetChatRoomsPaginatedQuery = { __typename?: 'Query', findManyChatRooms: Array<{ __typename?: 'ChatRoom', id: string, name?: string | null, userId: string, agentId?: string | null, lastMessageId?: string | null, createdAt: any, updatedAt: any, lastMessage?: { __typename?: 'Message', id: string, text?: string | null, role?: MessageRole | null, createdAt: any } | null }> };

export type GetMessagesByChatRoomQueryVariables = Exact<{
  chatRoomId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetMessagesByChatRoomQuery = { __typename?: 'Query', findManyMessages: Array<{ __typename?: 'Message', id: string, text?: string | null, role?: MessageRole | null, userId?: string | null, chatRoomId: string, rating?: number | null, feedback?: string | null, contextDocumentIds?: Array<string> | null, contextFormIds?: Array<string> | null, thinkingSteps?: any | null, contentBlocks?: any | null, createdAt: any, updatedAt: any, sourceDocuments?: Array<{ __typename?: 'SourceDocument', id: string, title: string, content: string, score: number, metadata?: any | null, messageId: string, createdAt: any, updatedAt: any, userId: string }> | null }> };

export type GetFoldersQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetFoldersQuery = { __typename?: 'Query', findManyFolders: Array<{ __typename?: 'Folder', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, parentId?: string | null, userId: string, documents?: Array<{ __typename?: 'Document', id: string, title: string, extension: string, fileSize: number, status: DocumentStatus, folderId: string, userId: string, source?: string | null, text?: string | null, originalMarkdownMd5?: string | null, processedMarkdownMd5?: string | null, sourceDocumentMd5?: string | null, sourceFilename?: string | null, sourceType?: string | null, sourceFileS3Key?: string | null, parsedAt?: any | null, assets?: any | null, regions?: any | null, createdAt: any, updatedAt: any }> | null, subFolders?: Array<{ __typename?: 'Folder', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, parentId?: string | null, userId: string }> | null }> };

export type GetAllFoldersForPickerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFoldersForPickerQuery = { __typename?: 'Query', findManyFolders: Array<{ __typename?: 'Folder', id: string, name: string, parentId?: string | null, documents?: Array<{ __typename?: 'Document', id: string, title: string, sourceFilename?: string | null }> | null }> };

export type SearchDocumentsByContentQueryVariables = Exact<{
  query: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDocumentsByContentQuery = { __typename?: 'Query', findManyDocuments: Array<{ __typename?: 'Document', id: string, title: string, sourceFilename?: string | null, folderId: string }> };

export type CreateRootFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type CreateRootFolderMutation = { __typename?: 'Mutation', createFolder: { __typename?: 'Folder', id: string, name: string, description?: string | null, parentId?: string | null, userId: string, createdAt: any, updatedAt: any } };

export type CreateFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder: { __typename?: 'Folder', id: string, name: string, description?: string | null, parentId?: string | null, userId: string, createdAt: any, updatedAt: any } };

export type GetDocumentsQueryVariables = Exact<{
  folderId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDocumentsQuery = { __typename?: 'Query', findManyDocuments: Array<{ __typename?: 'Document', id: string, title: string, extension: string, fileSize: number, status: DocumentStatus, folderId: string, userId: string, source?: string | null, text?: string | null, originalMarkdownMd5?: string | null, processedMarkdownMd5?: string | null, sourceDocumentMd5?: string | null, sourceFilename?: string | null, sourceType?: string | null, sourceFileS3Key?: string | null, parsedAt?: any | null, assets?: any | null, regions?: any | null, createdAt: any, updatedAt: any }> };

export type SoftDeleteDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type SoftDeleteDocumentMutation = { __typename?: 'Mutation', softDeleteDocument: { __typename?: 'Document', id: string, deletedAt?: any | null } };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, title: string, status: DocumentStatus, updatedAt: any } };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'Query', findManyLanguages: Array<{ __typename?: 'Language', id: string, code: string, name: string }> };

export type GetAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsQuery = { __typename?: 'Query', findManyAgents: Array<{ __typename?: 'Agent', id: string, name: string, agentType: AgentType, audience: AgentAudience, userId: string, languageId: string, knowledgeGraphId?: string | null, hidden: boolean, formFolderPath?: string | null, isMultiagent: boolean, workflowId?: string | null, dataStatus: AgentDataStatus, dataStatusAt?: any | null, dataStatusReason?: string | null, status: AgentStatus, createdAt: any, updatedAt: any, workflow?: { __typename?: 'Workflow', id: string, name: string, definition: any } | null, knowledgeGraph?: { __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus, isActive: boolean, folderSnapshot?: any | null } | null, agentFolders?: Array<{ __typename?: 'AgentFolder', agentId: string, folderId: string }> | null, language?: { __typename?: 'Language', id: string, name: string, code: string, createdAt: any, updatedAt: any } | null }> };

export type GetSelectableAgentsQueryVariables = Exact<{
  audience?: InputMaybe<AgentAudience>;
}>;


export type GetSelectableAgentsQuery = { __typename?: 'Query', getUserAgents: Array<{ __typename?: 'Agent', id: string, name: string, agentType: AgentType, audience: AgentAudience, status: AgentStatus, knowledgeGraphId?: string | null, workflowId?: string | null, createdAt: any, updatedAt: any, workflow?: { __typename?: 'Workflow', id: string, definition: any } | null, language?: { __typename?: 'Language', id: string, name: string, code: string } | null }> };

export type ToggleAgentHiddenMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ToggleAgentHiddenMutation = { __typename?: 'Mutation', toggleAgentHidden: { __typename?: 'Agent', id: string, hidden: boolean } };

export type CreateChatRoomMutationVariables = Exact<{
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
  agentName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateChatRoomMutation = { __typename?: 'Mutation', createChatRoom: { __typename?: 'ChatRoom', id: string, name?: string | null, userId: string, agentId?: string | null, createdAt: any, updatedAt: any, agent?: { __typename?: 'Agent', id: string, name: string, workflowId?: string | null, workflow?: { __typename?: 'Workflow', id: string, definition: any } | null } | null } };

export type DeleteChatRoomMessagesMutationVariables = Exact<{
  chatRoomId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type DeleteChatRoomMessagesMutation = { __typename?: 'Mutation', deleteManyMessages: { __typename?: 'BatchPayload', count: number } };

export type DeleteChatRoomMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type DeleteChatRoomMutation = { __typename?: 'Mutation', deleteChatRoom: { __typename?: 'ChatRoom', id: string, name?: string | null, userId: string, lastMessageId?: string | null, createdAt: any, updatedAt: any } };

export type GetUserInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserInfoQuery = { __typename?: 'Query', findMyFirstUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, createdAt: any, updatedAt: any } };

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateMyUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, createdAt: any, updatedAt: any } };

export type GetSourceDocumentsQueryVariables = Exact<{
  messageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetSourceDocumentsQuery = { __typename?: 'Query', findManySourceDocuments: Array<{ __typename?: 'SourceDocument', id: string, title: string, content: string, score: number, metadata?: any | null, messageId: string, userId: string, createdAt: any, updatedAt: any, message?: { __typename?: 'Message', id: string, text?: string | null, role?: MessageRole | null } | null }> };

export type RateMessageMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
}>;


export type RateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: string, rating?: number | null, feedback?: string | null, updatedAt: any } };

export type GetAgentByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentByIdQuery = { __typename?: 'Query', findFirstAgent?: { __typename?: 'Agent', id: string, name: string, agentType: AgentType, audience: AgentAudience, languageId: string, knowledgeGraphId?: string | null, hidden: boolean, formFolderPath?: string | null, isMultiagent: boolean, workflowId?: string | null, status: AgentStatus, createdAt: any, updatedAt: any, workflow?: { __typename?: 'Workflow', id: string, name: string, definition: any } | null, knowledgeGraph?: { __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus } | null, agentFolders?: Array<{ __typename?: 'AgentFolder', agentId: string, folderId: string }> | null, language?: { __typename?: 'Language', id: string, code: string, name: string } | null } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', findManyUsers: Array<{ __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any }> };

export type GetUsersPaginatedQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetUsersPaginatedQuery = { __typename?: 'Query', findManyUsers: Array<{ __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any }> };

export type CountUsersMutationVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CountUsersMutation = { __typename?: 'Mutation', countUsers: number };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null } };

export type DisableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any } };

export type EnableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: { __typename?: 'User', id: string, email?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, role: Role, status: string, createdAt: any, updatedAt: any } };

export type EnsureKgAgentMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type EnsureKgAgentMutation = { __typename?: 'Mutation', ensureKgAgent: { __typename?: 'Agent', id: string, name: string, knowledgeGraphId?: string | null, workflowId?: string | null, workflow?: { __typename?: 'Workflow', id: string, definition: any } | null, knowledgeGraph?: { __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus } | null, agentFolders?: Array<{ __typename?: 'AgentFolder', agentId: string, folderId: string }> | null } };

export type GetKgStatusQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
}>;


export type GetKgStatusQuery = { __typename?: 'Query', findKnowledgeGraphByUserNamespaceAndType?: { __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus, workflowType: KgType, totalSteps: number, completedSteps: number, progressData?: any | null, completedAt?: any | null, errorMessage?: string | null, createdAt: any, pickleMd5?: string | null, knowledgeGraphDocuments?: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> | null } | null };

export type GetKgImportsHistoryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetKgImportsHistoryQuery = { __typename?: 'Query', findKnowledgeGraphsByUserAndNamespace: Array<{ __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus, workflowType: KgType, totalSteps: number, completedSteps: number, progressData?: any | null, completedAt?: any | null, errorMessage?: string | null, createdAt: any, pickleMd5?: string | null, knowledgeGraphDocuments?: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> | null }> };

export type GetKgCompositionQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
}>;


export type GetKgCompositionQuery = { __typename?: 'Query', findActiveKnowledgeGraphsByUser: Array<{ __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus, progressData?: any | null, completedAt?: any | null, createdAt: any, knowledgeGraphDocuments?: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> | null }> };

export type GetKnowledgeGraphsByUserAndNamespaceQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
}>;


export type GetKnowledgeGraphsByUserAndNamespaceQuery = { __typename?: 'Query', findKnowledgeGraphsByUserAndNamespace: Array<{ __typename?: 'KnowledgeGraph', id: string, userId: string, workflowType: KgType, sourceType: KgSourceType, namespace: string, version: string, status: KgStatus, totalSteps: number, completedSteps: number, progressData?: any | null, validationTree?: any | null, pickleMd5?: string | null, errorMessage?: string | null, createdAt: any, completedAt?: any | null, knowledgeGraphDocuments?: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> | null }> };

export type GetKnowledgeGraphByUserNamespaceAndTypeQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  workflowType: Scalars['String']['input'];
}>;


export type GetKnowledgeGraphByUserNamespaceAndTypeQuery = { __typename?: 'Query', findKnowledgeGraphByUserNamespaceAndType?: { __typename?: 'KnowledgeGraph', id: string, userId: string, workflowType: KgType, sourceType: KgSourceType, namespace: string, version: string, status: KgStatus, totalSteps: number, completedSteps: number, progressData?: any | null, validationTree?: any | null, pickleMd5?: string | null, errorMessage?: string | null, createdAt: any, completedAt?: any | null, knowledgeGraphDocuments?: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> | null } | null };

export type GetKnowledgeGraphDocumentStatsQueryVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
}>;


export type GetKnowledgeGraphDocumentStatsQuery = { __typename?: 'Query', getKnowledgeGraphDocumentStats: any };

export type GetDocumentsByKnowledgeGraphIdQueryVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
}>;


export type GetDocumentsByKnowledgeGraphIdQuery = { __typename?: 'Query', getDocumentsByKnowledgeGraphId: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus } | null }> };

export type GetKgDocumentCountMutationVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
}>;


export type GetKgDocumentCountMutation = { __typename?: 'Mutation', countKnowledgeGraphDocuments: number };

export type GetKgDocumentsPaginatedQueryVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetKgDocumentsPaginatedQuery = { __typename?: 'Query', findManyKnowledgeGraphDocuments: Array<{ __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus, fileSize: number, extension: string, sourceFilename?: string | null, sourceType?: string | null, sourceDocumentMd5?: string | null, parsedAt?: any | null, createdAt: any, updatedAt: any } | null }> };

export type GetFoldersWithDocumentCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoldersWithDocumentCountQuery = { __typename?: 'Query', findManyFolders: Array<{ __typename?: 'Folder', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, parentId?: string | null, userId: string, _count?: { __typename?: 'FolderCount', documents: number, subFolders: number } | null, subFolders?: Array<{ __typename?: 'Folder', id: string, name: string, _count?: { __typename?: 'FolderCount', documents: number } | null }> | null }> };

export type GetFolderDocumentsPaginatedQueryVariables = Exact<{
  folderId?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFolderDocumentsPaginatedQuery = { __typename?: 'Query', findManyDocuments: Array<{ __typename?: 'Document', id: string, title: string, extension: string, fileSize: number, status: DocumentStatus, folderId: string, userId: string, source?: string | null, text?: string | null, originalMarkdownMd5?: string | null, processedMarkdownMd5?: string | null, sourceDocumentMd5?: string | null, sourceFilename?: string | null, sourceType?: string | null, sourceFileS3Key?: string | null, parsedAt?: any | null, assets?: any | null, regions?: any | null, createdAt: any, updatedAt: any }> };

export type GetKgStatusOptimizedQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
}>;


export type GetKgStatusOptimizedQuery = { __typename?: 'Query', findKnowledgeGraphsByNamespace: Array<{ __typename?: 'KnowledgeGraph', id: string, namespace: string, version: string, status: KgStatus, workflowType: KgType, totalSteps: number, completedSteps: number, progressData?: any | null, completedAt?: any | null, errorMessage?: string | null, createdAt: any, pickleMd5?: string | null, totalNodes: number, totalRelationships: number, _count?: { __typename?: 'KnowledgeGraphCount', knowledgeGraphDocuments: number } | null }> };

export type KgDocumentFragmentFragment = { __typename?: 'KnowledgeGraphDocument', id: string, documentId: string, nodeCount: number, relationshipCount: number, document?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus, fileSize: number, extension: string, sourceFilename?: string | null, sourceType?: string | null, sourceDocumentMd5?: string | null, parsedAt?: any | null, createdAt: any, updatedAt: any } | null } & { ' $fragmentName'?: 'KgDocumentFragmentFragment' };

export type FolderCountFragmentFragment = { __typename?: 'Folder', id: string, name: string, description?: string | null, _count?: { __typename?: 'FolderCount', documents: number, subFolders: number } | null } & { ' $fragmentName'?: 'FolderCountFragmentFragment' };

export type GetKgDocumentsCountMutationVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
}>;


export type GetKgDocumentsCountMutation = { __typename?: 'Mutation', countKnowledgeGraphDocuments: number };

export type GetKgMetricsLightweightQueryVariables = Exact<{
  knowledgeGraphId: Scalars['String']['input'];
}>;


export type GetKgMetricsLightweightQuery = { __typename?: 'Query', getKnowledgeGraphDocumentStats: any };

export type GetAllModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllModelsQuery = { __typename?: 'Query', findManyModels: Array<{ __typename?: 'Model', id: string, code: string, name: string, description?: string | null, modelType: ModelType, provider: string, isActive: boolean, isDefault: boolean, isFallback: boolean, fallbackModelId?: string | null, parameters?: any | null, createdAt: any, updatedAt: any, fallbackModel?: { __typename?: 'Model', id: string, code: string, name: string, provider: string, modelType: ModelType, parameters?: any | null } | null }> };

export type GetModelsByTypeQueryVariables = Exact<{
  modelType: ModelType;
}>;


export type GetModelsByTypeQuery = { __typename?: 'Query', findManyModels: Array<{ __typename?: 'Model', id: string, code: string, name: string, description?: string | null, modelType: ModelType, provider: string, isActive: boolean, isDefault: boolean, isFallback: boolean, fallbackModelId?: string | null, parameters?: any | null, createdAt: any, updatedAt: any, fallbackModel?: { __typename?: 'Model', id: string, code: string, name: string, provider: string, modelType: ModelType, parameters?: any | null } | null }> };

export type UpdateModelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
}>;


export type UpdateModelMutation = { __typename?: 'Mutation', updateModel: { __typename?: 'Model', id: string, code: string, name: string, description?: string | null, modelType: ModelType, provider: string, isActive: boolean, isDefault: boolean, isFallback: boolean, fallbackModelId?: string | null, parameters?: any | null, createdAt: any, updatedAt: any, fallbackModel?: { __typename?: 'Model', id: string, code: string, name: string, provider: string, modelType: ModelType, parameters?: any | null } | null } };

export type GetDocumentContentQueryVariables = Exact<{
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetDocumentContentQuery = { __typename?: 'Query', findManyDocuments: Array<{ __typename?: 'Document', id: string, title: string, text?: string | null, source?: string | null, sourceFileS3Key?: string | null }> };

export type GetDocumentVersionsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  take: Scalars['Int']['input'];
}>;


export type GetDocumentVersionsQuery = { __typename?: 'Query', getDocumentVersions: Array<{ __typename?: 'DocumentVersion', id: string, md5Hash: string, changeType: string, changedBy: string, createdAt: any }> };

export type FindFormTemplatesPaginatedQueryVariables = Exact<{
  input?: InputMaybe<FindFormTemplatesInput>;
}>;


export type FindFormTemplatesPaginatedQuery = { __typename?: 'Query', findFormTemplatesPaginated: { __typename?: 'FormTemplateConnection', total: number, items: Array<{ __typename?: 'FormTemplate', id: string, formId: string, folderId?: string | null, md5: string, version: number, meta: any, authoredBy?: string | null, createdAt: any, updatedAt: any }> } };

export type FindManyFormFoldersQueryVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type FindManyFormFoldersQuery = { __typename?: 'Query', findManyFormFolders: Array<{ __typename?: 'FormFolder', id: string, namespace: string, name: string, parentId?: string | null, createdAt: any, updatedAt: any }> };

export type FindFormTemplateCountsByFolderQueryVariables = Exact<{ [key: string]: never; }>;


export type FindFormTemplateCountsByFolderQuery = { __typename?: 'Query', findFormTemplateCountsByFolder: Array<{ __typename?: 'FormTemplateFolderCount', folderId: string, count: number }> };

export type FindFormParsedContentQueryVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type FindFormParsedContentQuery = { __typename?: 'Query', findUniqueFormParsedContent?: { __typename?: 'FormParsedContent', id: string, formTemplateId: string, text: string, originalMarkdownMd5: string, parsedAt: any, assets: any } | null };

export type SoftDeleteFormTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SoftDeleteFormTemplateMutation = { __typename?: 'Mutation', softDeleteFormTemplate: { __typename?: 'FormTemplate', id: string, formId: string, meta: any, updatedAt: any } };

export type RestoreFormTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreFormTemplateMutation = { __typename?: 'Mutation', restoreFormTemplate: { __typename?: 'FormTemplate', id: string, formId: string, meta: any, updatedAt: any } };

export type MoveFormTemplateToFolderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;


export type MoveFormTemplateToFolderMutation = { __typename?: 'Mutation', moveFormTemplateToFolder: { __typename?: 'FormTemplate', id: string, formId: string, folderId?: string | null, meta: any, updatedAt: any } };

export type GetApiKeysQueryVariables = Exact<{
  filter?: InputMaybe<ApiKeyFilterInput>;
}>;


export type GetApiKeysQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'ApiKey', id: string, keyPrefix: string, name: string, agentId?: string | null, scopes: Array<string>, rateLimit: number, dailyLimit?: number | null, status: ApiKeyStatus, usageCount: number, lastUsedAt?: any | null, createdAt: any, expiresAt?: any | null }> };

export type GetApiKeyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApiKeyQuery = { __typename?: 'Query', apiKey: { __typename?: 'ApiKey', id: string, keyPrefix: string, name: string, agentId?: string | null, scopes: Array<string>, rateLimit: number, dailyLimit?: number | null, status: ApiKeyStatus, usageCount: number, lastUsedAt?: any | null, createdAt: any, expiresAt?: any | null } };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreateApiKeyResponse', rawKey: string, apiKey: { __typename?: 'ApiKey', id: string, keyPrefix: string, name: string, agentId?: string | null, scopes: Array<string>, rateLimit: number, dailyLimit?: number | null, status: ApiKeyStatus, createdAt: any, expiresAt?: any | null } } };

export type UpdateApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateApiKeyInput;
}>;


export type UpdateApiKeyMutation = { __typename?: 'Mutation', updateApiKey: { __typename?: 'ApiKey', id: string, keyPrefix: string, name: string, agentId?: string | null, scopes: Array<string>, rateLimit: number, dailyLimit?: number | null, status: ApiKeyStatus, usageCount: number, lastUsedAt?: any | null, createdAt: any, expiresAt?: any | null } };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey: { __typename?: 'ApiKeyMutationResponse', success: boolean, message: string, apiKeyId?: string | null } };

export type RevokeApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey: { __typename?: 'ApiKeyMutationResponse', success: boolean, message: string, apiKeyId?: string | null } };

export type GetHiddenOneDriveItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHiddenOneDriveItemsQuery = { __typename?: 'Query', hiddenOneDriveItems: Array<{ __typename?: 'HiddenOneDriveItem', id: string, userId: string, path: string, hiddenAt: any }> };

export type GetHiddenOneDrivePathsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHiddenOneDrivePathsQuery = { __typename?: 'Query', hiddenOneDrivePaths: Array<string> };

export type HideOneDriveItemMutationVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type HideOneDriveItemMutation = { __typename?: 'Mutation', hideOneDriveItem: { __typename?: 'HiddenOneDriveItem', id: string, userId: string, path: string, hiddenAt: any } };

export type UnhideOneDriveItemMutationVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type UnhideOneDriveItemMutation = { __typename?: 'Mutation', unhideOneDriveItem: boolean };

export type UnhideAllOneDriveItemsMutationVariables = Exact<{ [key: string]: never; }>;


export type UnhideAllOneDriveItemsMutation = { __typename?: 'Mutation', unhideAllOneDriveItems: number };

export type CleanupOrphanedHiddenItemsMutationVariables = Exact<{
  validPaths: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CleanupOrphanedHiddenItemsMutation = { __typename?: 'Mutation', cleanupOrphanedHiddenItems: number };

export type GetOriginalDocumentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOriginalDocumentsQuery = { __typename?: 'Query', findManyOriginalDocuments: Array<{ __typename?: 'OriginalDocument', id: string, fileName: string, filePath: string, fileExtension: string, fileSize: any, mimeType?: string | null, md5Hash: string, oneDriveItemId?: string | null, webUrl?: string | null, downloadUrl?: string | null, syncedAt: any, lastModifiedAt?: any | null, status: FileStatus, userId: string, folderId?: string | null, metadata?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, username?: string | null, email?: string | null } | null, folder?: { __typename?: 'Folder', id: string, name: string } | null }> };

export type GetOriginalDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOriginalDocumentQuery = { __typename?: 'Query', findUniqueOriginalDocument?: { __typename?: 'OriginalDocument', id: string, fileName: string, filePath: string, fileExtension: string, fileSize: any, mimeType?: string | null, md5Hash: string, oneDriveItemId?: string | null, webUrl?: string | null, downloadUrl?: string | null, syncedAt: any, lastModifiedAt?: any | null, status: FileStatus, userId: string, folderId?: string | null, metadata?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', id: string, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null } | null } | null };

export type CountOriginalDocumentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CountOriginalDocumentsQuery = { __typename?: 'Query', countOriginalDocuments: number };

export type GetUserDocumentsForPickerQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserDocumentsForPickerQuery = { __typename?: 'Query', findManyDocuments: Array<{ __typename?: 'Document', id: string, title: string, extension: string, fileSize: number, status: DocumentStatus, folderId: string, createdAt: any }> };

export type CreateAgentMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type CreateAgentMutation = { __typename?: 'Mutation', createAgent: { __typename?: 'Agent', id: string, name: string, agentType: AgentType, userId: string, languageId: string, workflowId?: string | null, status: AgentStatus, createdAt: any, updatedAt: any } };

export type CreateAgentSyncConfigMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type CreateAgentSyncConfigMutation = { __typename?: 'Mutation', createAgentSyncConfig: { __typename?: 'AgentSyncConfig', id: string, agentId: string, syncUrls: Array<string>, folderId: string, autoUpdate: boolean, lastSyncAt?: any | null, createdAt: any, updatedAt: any } };

export type UpdateAgentSyncConfigMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type UpdateAgentSyncConfigMutation = { __typename?: 'Mutation', updateAgentSyncConfig: { __typename?: 'AgentSyncConfig', id: string, agentId: string, syncUrls: Array<string>, folderId: string, autoUpdate: boolean, lastSyncAt?: any | null, createdAt: any, updatedAt: any } };

export type DeleteAgentSyncConfigMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type DeleteAgentSyncConfigMutation = { __typename?: 'Mutation', deleteAgentSyncConfig: { __typename?: 'AgentSyncConfig', id: string } };

export type GetAgentSyncConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentSyncConfigsQuery = { __typename?: 'Query', findManyAgentSyncConfigs: Array<{ __typename?: 'AgentSyncConfig', id: string, agentId: string, syncUrls: Array<string>, folderId: string, autoUpdate: boolean, lastSyncAt?: any | null, createdAt: any, updatedAt: any, agent?: { __typename?: 'Agent', id: string, name: string, status: AgentStatus, createdAt: any, updatedAt: any } | null, targetFolder?: { __typename?: 'Folder', id: string, name: string, description?: string | null, userId: string, createdAt: any, updatedAt: any } | null }> };

export type RecreateAgentMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type RecreateAgentMutation = { __typename?: 'Mutation', recreateAgent: { __typename?: 'AgentRecreationResult', userId: string, config: { __typename?: 'AgentRecreationConfig', name: string, languageId: string, folderIds: Array<string>, tools?: any | null } } };

export type UpdateAgentConfigMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  updates: Scalars['JSONObject']['input'];
}>;


export type UpdateAgentConfigMutation = { __typename?: 'Mutation', updateAgent: { __typename?: 'Agent', id: string, name: string, status: AgentStatus, agentType: AgentType, languageId: string, userId: string, workflowId?: string | null, createdAt: any, updatedAt: any } };

export type UpdateAgentFoldersMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  folderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateAgentFoldersMutation = { __typename?: 'Mutation', updateAgentFolders: { __typename?: 'Agent', id: string, name: string, status: AgentStatus, agentType: AgentType, languageId: string, userId: string, workflowId?: string | null, createdAt: any, updatedAt: any } };

export type UpdateAgentStatusMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateAgentStatusMutation = { __typename?: 'Mutation', updateAgent: { __typename?: 'Agent', id: string, name: string, status: AgentStatus, createdAt: any, updatedAt: any } };

export type GetAllUrlConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUrlConfigsQuery = { __typename?: 'Query', getAllUrlConfigs: Array<{ __typename?: 'UrlConfig', id: string, displayUrl: string, apiEndpoint: string, apiClientId?: string | null, folderName: string, folderId?: string | null, lastSyncAt?: any | null, createdAt: any, updatedAt: any, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null, createdAt: any } | null }> };

export type GetUrlConfigDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUrlConfigDetailsQuery = { __typename?: 'Query', findUniqueUrlConfig?: { __typename?: 'UrlConfig', id: string, displayUrl: string, apiEndpoint: string, folderName: string, folderId?: string | null, lastSyncAt?: any | null, apiClientId?: string | null, createdAt: any, updatedAt: any, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null, documents?: Array<{ __typename?: 'Document', id: string, title: string, status: DocumentStatus, createdAt: any, updatedAt: any }> | null } | null } | null };

export type FindUniqueUrlConfigQueryVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type FindUniqueUrlConfigQuery = { __typename?: 'Query', findUniqueUrlConfig?: { __typename?: 'UrlConfig', id: string, displayUrl: string, apiEndpoint: string, apiClientId?: string | null, folderName: string, folderId?: string | null, lastSyncAt?: any | null, createdAt: any, updatedAt: any, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null } | null } | null };

export type GetUrlConfigsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUrlConfigsCountQuery = { __typename?: 'Query', getUrlConfigsCount: number };

export type GetUrlFoldersForAgentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUrlFoldersForAgentQuery = { __typename?: 'Query', getUrlFoldersForAgent: Array<{ __typename?: 'UrlConfig', id: string, displayUrl: string, folderName: string, folderId?: string | null, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null } | null }> };

export type CreateUrlConfigMutationVariables = Exact<{
  displayUrl: Scalars['String']['input'];
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  folderName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUrlConfigMutation = { __typename?: 'Mutation', createUrlConfig: { __typename?: 'UrlConfig', id: string, displayUrl: string, apiEndpoint: string, folderName: string, folderId?: string | null, lastSyncAt?: any | null, createdAt: any, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null } | null } };

export type DeleteOneUrlConfigMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type DeleteOneUrlConfigMutation = { __typename?: 'Mutation', deleteOneUrlConfig: { __typename?: 'UrlConfig', id: string, displayUrl: string } };

export type ValidateUrlConfigMutationVariables = Exact<{
  displayUrl: Scalars['String']['input'];
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateUrlConfigMutation = { __typename?: 'Mutation', validateUrlConfig: { __typename?: 'ValidateUrlResult', valid: boolean, accessible: boolean, error?: string | null } };

export type CreateUrlAgentMutationVariables = Exact<{
  createAgentDto: CreateAgentDto;
}>;


export type CreateUrlAgentMutation = { __typename?: 'Mutation', createUserAgent: { __typename?: 'Agent', id: string, name: string, status: AgentStatus, agentType: AgentType, languageId: string, userId: string, workflowId?: string | null, createdAt: any, updatedAt: any } };

export type CreateUrlAgentSyncConfigMutationVariables = Exact<{
  args: Scalars['JSONObject']['input'];
}>;


export type CreateUrlAgentSyncConfigMutation = { __typename?: 'Mutation', createAgentSyncConfig: { __typename?: 'AgentSyncConfig', id: string, agentId: string, syncUrls: Array<string>, folderId: string, autoUpdate: boolean, lastSyncAt?: any | null, createdAt: any, updatedAt: any } };

export type GetUehArticlesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUehArticlesQuery = { __typename?: 'Query', getUehArticles: Array<{ __typename?: 'UehArticle', id: number, linkNguon: string, title: string, menu: string, sourceUrl?: string | null, htmlContent: string, markdownContent: string, lastUpdatedAt: any, weaviateId?: string | null, status: UehArticleStatus, createdAt: any, updatedAt: any }> };

export type GetUehArticlesCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUehArticlesCountQuery = { __typename?: 'Query', getUehArticlesCount: number };

export type GetAllUehArticlesSourceUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUehArticlesSourceUrlsQuery = { __typename?: 'Query', getUehArticles: Array<{ __typename?: 'UehArticle', sourceUrl?: string | null }> };

export type GetArticlesByAgentQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GetArticlesByAgentQuery = { __typename?: 'Query', getArticlesByAgent: Array<{ __typename?: 'UehArticle', id: number, linkNguon: string, title: string, menu: string, htmlContent: string, markdownContent: string, lastUpdatedAt: any, weaviateId?: string | null, status: UehArticleStatus, sourceUrl?: string | null, agentId?: string | null, createdAt: any, updatedAt: any }> };

export type GetChatbotUpdateStatusQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GetChatbotUpdateStatusQuery = { __typename?: 'Query', getChatbotUpdateStatus: string };

export type GetLastWeekdayDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastWeekdayDateQuery = { __typename?: 'Query', getLastWeekdayDate: string };

export type GetRecentUehSyncJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentUehSyncJobsQuery = { __typename?: 'Query', getRecentUehSyncJobs: Array<{ __typename?: 'JobInfo', id: string, status: string, progress: number, data?: string | null, result?: string | null, error?: string | null, createdAt: any, completedAt?: any | null }> };

export type GetUehSyncStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetUehSyncStatusQuery = { __typename?: 'Query', getUehSyncStatus?: { __typename?: 'JobInfo', id: string, status: string, progress: number, data?: string | null, result?: string | null, error?: string | null, createdAt: any, completedAt?: any | null } | null };

export type GetUehSyncQueueStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUehSyncQueueStatsQuery = { __typename?: 'Query', getUehSyncQueueStats: { __typename?: 'QueueStats', waiting: number, active: number, completed: number, failed: number, delayed: number, stuck: number } };

export type GetSyncStatisticsQueryVariables = Exact<{
  agentId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSyncStatisticsQuery = { __typename?: 'Query', getSyncStatistics: { __typename?: 'SyncStatistics', totalSyncs: number, successfulSyncs: number, failedSyncs: number, totalArticlesProcessed: number, totalArticlesAdded: number, totalArticlesUpdated: number, totalArticlesDeleted: number, averageSyncDuration: number, lastSyncAt?: any | null, syncsByDate: Array<{ __typename?: 'SyncDateStats', date: string, count: number, success: boolean }> } };

export type StartUehSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type StartUehSyncMutation = { __typename?: 'Mutation', startUehSync: boolean };

export type StartUehSyncJobMutationVariables = Exact<{
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartUehSyncJobMutation = { __typename?: 'Mutation', startUehSyncJob: string };

export type CancelUehSyncJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CancelUehSyncJobMutation = { __typename?: 'Mutation', cancelUehSyncJob: boolean };

export type InitializeDefaultUehConfigMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitializeDefaultUehConfigMutation = { __typename?: 'Mutation', initializeDefaultUehConfig: { __typename?: 'UrlConfig', id: string, displayUrl: string, apiEndpoint: string, folderName: string, folderId?: string | null, createdAt: any, folder?: { __typename?: 'Folder', id: string, name: string, description?: string | null } | null } };

export type ExportArticlesToDocumentsMutationVariables = Exact<{
  urlConfigId: Scalars['String']['input'];
  agentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportArticlesToDocumentsMutation = { __typename?: 'Mutation', exportArticlesToDocuments: { __typename?: 'ExportToDocumentsResultObject', success: boolean, documentsCreated: number, documentsUpdated: number, documentsDeleted: number, totalProcessed: number, folderId: string, error?: string | null } };

export type GetSuggestedSyncDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestedSyncDatesQuery = { __typename?: 'Query', getSuggestedSyncDates: Array<string> };

export type GetSyncableUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSyncableUrlsQuery = { __typename?: 'Query', getSyncableUrls: Array<{ __typename?: 'SyncUrlConfig', url: string, name: string, description: string, active: boolean }> };

export type GetMultiUrlSyncStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetMultiUrlSyncStatusQuery = { __typename?: 'Query', getUehSyncStatus?: { __typename?: 'JobInfo', id: string, status: string, progress: number, data?: string | null, result?: string | null, error?: string | null, createdAt: any, completedAt?: any | null } | null };

export type ValidateSyncUrlsQueryVariables = Exact<{
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidateSyncUrlsQuery = { __typename?: 'Query', validateSyncUrls: Array<{ __typename?: 'ValidationResult', url: string, valid: boolean, accessible: boolean, responseTime: number, error?: string | null }> };

export type SyncUrlConfigMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncUrlConfigMutation = { __typename?: 'Mutation', syncUrlConfig: { __typename?: 'SyncUrlResult', success: boolean, articlesCount: number, newCount: number, updatedCount: number, url?: string | null, error?: string | null, syncDate?: string | null } };

export type SyncUrlConfigForDateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  date: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncUrlConfigForDateMutation = { __typename?: 'Mutation', syncUrlConfigForDate: { __typename?: 'SyncUrlResult', success: boolean, articlesCount: number, newCount: number, updatedCount: number, url?: string | null, error?: string | null, syncDate?: string | null } };

export type SyncUrlConfigDateRangeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type SyncUrlConfigDateRangeMutation = { __typename?: 'Mutation', syncUrlConfigDateRange: { __typename?: 'SyncUrlDateRangeResult', success: boolean, totalArticles: number, totalNew: number, totalUpdated: number, syncedDates: Array<string>, error?: string | null } };

export type SyncMultipleUrlsMutationVariables = Exact<{
  displayUrls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SyncMultipleUrlsMutation = { __typename?: 'Mutation', syncMultipleUrls: Array<{ __typename?: 'SyncUrlResult', success: boolean, articlesCount: number, newCount: number, updatedCount: number, url?: string | null, error?: string | null }> };

export type StartUehSyncForDateMutationVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type StartUehSyncForDateMutation = { __typename?: 'Mutation', startUehSyncForDate: boolean };

export type StartUehSyncForDateRangeMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type StartUehSyncForDateRangeMutation = { __typename?: 'Mutation', startUehSyncForDateRange: boolean };

export type StartUehSyncJobForDateMutationVariables = Exact<{
  date: Scalars['String']['input'];
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartUehSyncJobForDateMutation = { __typename?: 'Mutation', startUehSyncJobForDate: string };

export type StartUehSyncJobForDateRangeMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartUehSyncJobForDateRangeMutation = { __typename?: 'Mutation', startUehSyncJobForDateRange: string };

export type StartConnectionTestJobMutationVariables = Exact<{
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartConnectionTestJobMutation = { __typename?: 'Mutation', startConnectionTestJob: string };

export type StartMultiUrlSyncJobMutationVariables = Exact<{
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
  targetDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartMultiUrlSyncJobMutation = { __typename?: 'Mutation', startMultiUrlSyncJob: string };

export type SyncAndUpdateAgentMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  syncUrls: Array<Scalars['String']['input']> | Scalars['String']['input'];
  targetDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncAndUpdateAgentMutation = { __typename?: 'Mutation', syncAndUpdateAgent: string };

export type UpdateAgentsWithSyncedDataMutationVariables = Exact<{
  agentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  urls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAgentsWithSyncedDataMutation = { __typename?: 'Mutation', updateAgentsWithSyncedData: Array<{ __typename?: 'UpdateResult', success: boolean, agentId: string, error?: string | null, exportResult?: { __typename?: 'ExportResult', success: boolean, documentsCreated: number, documentsUpdated: number, documentsDeleted: number, totalProcessed: number, folderId: string, error?: string | null } | null }> };

export type UpdateChatRoomNameMutationVariables = Exact<{
  chatRoomId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateChatRoomNameMutation = { __typename?: 'Mutation', updateChatRoom: { __typename: 'ChatRoom', id: string, name?: string | null, updatedAt: any } };

export type FindTaskByTaskIdQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type FindTaskByTaskIdQuery = { __typename?: 'Query', findTaskByTaskId?: { __typename?: 'TaskState', id: string, taskId: string, taskType: string, status: TaskStatus, progressPercentage: number, progressMessage?: string | null, startedAt?: any | null, completedAt?: any | null, errorData?: any | null } | null };

export type FindTasksByUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTasksByUserQuery = { __typename?: 'Query', findTasksByUser: Array<{ __typename?: 'TaskState', id: string, taskId: string, taskType: string, status: TaskStatus, progressPercentage: number, progressMessage?: string | null, createdAt: any, startedAt?: any | null, completedAt?: any | null }> };

export const KgDocumentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KGDocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KnowledgeGraphDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocumentMd5"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<KgDocumentFragmentFragment, unknown>;
export const FolderCountFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderCountFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"}}]}}]}}]} as unknown as DocumentNode<FolderCountFragmentFragment, unknown>;
export const GetChatRoomsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyChatRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastMessage"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetChatRoomsQuery, GetChatRoomsQueryVariables>;
export const GetChatRoomsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatRoomsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyChatRooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastMessage"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetChatRoomsPaginatedQuery, GetChatRoomsPaginatedQueryVariables>;
export const GetMessagesByChatRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessagesByChatRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chatRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"asc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceDocuments"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomId"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"contextDocumentIds"}},{"kind":"Field","name":{"kind":"Name","value":"contextFormIds"}},{"kind":"Field","name":{"kind":"Name","value":"thinkingSteps"}},{"kind":"Field","name":{"kind":"Name","value":"contentBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMessagesByChatRoomQuery, GetMessagesByChatRoomQueryVariables>;
export const GetFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subFolders"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"originalMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"processedMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocumentMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assets"}},{"kind":"Field","name":{"kind":"Name","value":"regions"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<GetFoldersQuery, GetFoldersQueryVariables>;
export const GetAllFoldersForPickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllFoldersForPicker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"asc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"COMPLETED","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllFoldersForPickerQuery, GetAllFoldersForPickerQueryVariables>;
export const SearchDocumentsByContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchDocumentsByContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"insensitive","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"COMPLETED","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"NullValue"}}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"StringValue","value":"asc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}}]}}]}}]} as unknown as DocumentNode<SearchDocumentsByContentQuery, SearchDocumentsByContentQueryVariables>;
export const CreateRootFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRootFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentId"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateRootFolderMutation, CreateRootFolderMutationVariables>;
export const CreateFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateFolderMutation, CreateFolderMutationVariables>;
export const GetDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"originalMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"processedMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocumentMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assets"}},{"kind":"Field","name":{"kind":"Name","value":"regions"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const SoftDeleteDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SoftDeleteDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"softDeleteDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<SoftDeleteDocumentMutation, SoftDeleteDocumentMutationVariables>;
export const UpdateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const GetLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLanguages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"asc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAgents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"knowledgeGraph"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentFolders"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflow"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphId"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"formFolderPath"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiagent"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"folderSnapshot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agentFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dataStatusAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataStatusReason"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAgentsQuery, GetAgentsQueryVariables>;
export const GetSelectableAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSelectableAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audience"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgentAudience"}},"defaultValue":{"kind":"EnumValue","value":"PUBLIC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserAgents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"audience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audience"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"COMPLETED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetSelectableAgentsQuery, GetSelectableAgentsQueryVariables>;
export const ToggleAgentHiddenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleAgentHidden"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleAgentHidden"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}}]}}]} as unknown as DocumentNode<ToggleAgentHiddenMutation, ToggleAgentHiddenMutationVariables>;
export const CreateChatRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChatRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateChatRoomMutation, CreateChatRoomMutationVariables>;
export const DeleteChatRoomMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChatRoomMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chatRoomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteChatRoomMessagesMutation, DeleteChatRoomMessagesMutationVariables>;
export const DeleteChatRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChatRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChatRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteChatRoomMutation, DeleteChatRoomMutationVariables>;
export const GetUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMyFirstUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMyUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const GetSourceDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSourceDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManySourceDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"score"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetSourceDocumentsQuery, GetSourceDocumentsQueryVariables>;
export const RateMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RateMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feedback"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<RateMessageMutation, RateMessageMutationVariables>;
export const GetAgentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFirstAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"knowledgeGraph"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentFolders"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflow"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphId"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"formFolderPath"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiagent"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agentFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAgentByIdQuery, GetAgentByIdQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"platformUserId"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUsersPaginatedQuery, GetUsersPaginatedQueryVariables>;
export const CountUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CountUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}}]}]}}]} as unknown as DocumentNode<CountUsersMutation, CountUsersMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const DisableUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<DisableUserMutation, DisableUserMutationVariables>;
export const EnableUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<EnableUserMutation, EnableUserMutationVariables>;
export const EnsureKgAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnsureKgAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ensureKgAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"definition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agentFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}}]}}]}}]}}]} as unknown as DocumentNode<EnsureKgAgentMutation, EnsureKgAgentMutationVariables>;
export const GetKgStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findKnowledgeGraphByUserNamespaceAndType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowType"},"value":{"kind":"StringValue","value":"IMPORT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"totalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"completedSteps"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pickleMd5"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKgStatusQuery, GetKgStatusQueryVariables>;
export const GetKgImportsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGImportsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findKnowledgeGraphsByUserAndNamespace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowType"},"value":{"kind":"StringValue","value":"IMPORT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"totalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"completedSteps"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pickleMd5"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKgImportsHistoryQuery, GetKgImportsHistoryQueryVariables>;
export const GetKgCompositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGComposition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findActiveKnowledgeGraphsByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKgCompositionQuery, GetKgCompositionQueryVariables>;
export const GetKnowledgeGraphsByUserAndNamespaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKnowledgeGraphsByUserAndNamespace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findKnowledgeGraphsByUserAndNamespace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"completedSteps"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"validationTree"}},{"kind":"Field","name":{"kind":"Name","value":"pickleMd5"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKnowledgeGraphsByUserAndNamespaceQuery, GetKnowledgeGraphsByUserAndNamespaceQueryVariables>;
export const GetKnowledgeGraphByUserNamespaceAndTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKnowledgeGraphByUserNamespaceAndType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findKnowledgeGraphByUserNamespaceAndType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"completedSteps"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"validationTree"}},{"kind":"Field","name":{"kind":"Name","value":"pickleMd5"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKnowledgeGraphByUserNamespaceAndTypeQuery, GetKnowledgeGraphByUserNamespaceAndTypeQueryVariables>;
export const GetKnowledgeGraphDocumentStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKnowledgeGraphDocumentStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKnowledgeGraphDocumentStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}}]}]}}]} as unknown as DocumentNode<GetKnowledgeGraphDocumentStatsQuery, GetKnowledgeGraphDocumentStatsQueryVariables>;
export const GetDocumentsByKnowledgeGraphIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentsByKnowledgeGraphId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDocumentsByKnowledgeGraphId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentsByKnowledgeGraphIdQuery, GetDocumentsByKnowledgeGraphIdQueryVariables>;
export const GetKgDocumentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetKGDocumentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countKnowledgeGraphDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}}]}}]}}]}]}}]} as unknown as DocumentNode<GetKgDocumentCountMutation, GetKgDocumentCountMutationVariables>;
export const GetKgDocumentsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGDocumentsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyKnowledgeGraphDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"document"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"insensitive","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"nodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipCount"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocumentMd5"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetKgDocumentsPaginatedQuery, GetKgDocumentsPaginatedQueryVariables>;
export const GetFoldersWithDocumentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFoldersWithDocumentCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"select"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"subFolders"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"subFolders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"select"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"_count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"select"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subFolders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFoldersWithDocumentCountQuery, GetFoldersWithDocumentCountQueryVariables>;
export const GetFolderDocumentsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFolderDocumentsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"insensitive","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"originalMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"processedMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocumentMd5"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFilename"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assets"}},{"kind":"Field","name":{"kind":"Name","value":"regions"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetFolderDocumentsPaginatedQuery, GetFolderDocumentsPaginatedQueryVariables>;
export const GetKgStatusOptimizedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGStatusOptimized"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findKnowledgeGraphsByNamespace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"totalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"completedSteps"}},{"kind":"Field","name":{"kind":"Name","value":"progressData"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pickleMd5"}},{"kind":"Field","name":{"kind":"Name","value":"totalNodes"}},{"kind":"Field","name":{"kind":"Name","value":"totalRelationships"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"knowledgeGraphDocuments"}}]}}]}}]}}]} as unknown as DocumentNode<GetKgStatusOptimizedQuery, GetKgStatusOptimizedQueryVariables>;
export const GetKgDocumentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetKGDocumentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countKnowledgeGraphDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}}]}}]}}]}]}}]} as unknown as DocumentNode<GetKgDocumentsCountMutation, GetKgDocumentsCountMutationVariables>;
export const GetKgMetricsLightweightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKGMetricsLightweight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKnowledgeGraphDocumentStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"knowledgeGraphId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowledgeGraphId"}}}]}]}}]} as unknown as DocumentNode<GetKgMetricsLightweightQuery, GetKgMetricsLightweightQueryVariables>;
export const GetAllModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"modelType"},"value":{"kind":"StringValue","value":"asc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isFallback"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModelId"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAllModelsQuery, GetAllModelsQueryVariables>;
export const GetModelsByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetModelsByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyModels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"modelType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDefault"},"value":{"kind":"StringValue","value":"desc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isFallback"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModelId"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetModelsByTypeQuery, GetModelsByTypeQueryVariables>;
export const UpdateModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isFallback"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModelId"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"modelType"}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parameters"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateModelMutation, UpdateModelMutationVariables>;
export const GetDocumentContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"ADMIN","block":false}}]}}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileS3Key"}}]}}]}}]} as unknown as DocumentNode<GetDocumentContentQuery, GetDocumentContentQueryVariables>;
export const GetDocumentVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDocumentVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"md5Hash"}},{"kind":"Field","name":{"kind":"Name","value":"changeType"}},{"kind":"Field","name":{"kind":"Name","value":"changedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetDocumentVersionsQuery, GetDocumentVersionsQueryVariables>;
export const FindFormTemplatesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFormTemplatesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FindFormTemplatesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFormTemplatesPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"md5"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<FindFormTemplatesPaginatedQuery, FindFormTemplatesPaginatedQueryVariables>;
export const FindManyFormFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyFormFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyFormFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<FindManyFormFoldersQuery, FindManyFormFoldersQueryVariables>;
export const FindFormTemplateCountsByFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFormTemplateCountsByFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFormTemplateCountsByFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<FindFormTemplateCountsByFolderQuery, FindFormTemplateCountsByFolderQueryVariables>;
export const FindFormParsedContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFormParsedContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueFormParsedContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"originalMarkdownMd5"}},{"kind":"Field","name":{"kind":"Name","value":"parsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assets"}}]}}]}}]} as unknown as DocumentNode<FindFormParsedContentQuery, FindFormParsedContentQueryVariables>;
export const SoftDeleteFormTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SoftDeleteFormTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"softDeleteFormTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<SoftDeleteFormTemplateMutation, SoftDeleteFormTemplateMutationVariables>;
export const RestoreFormTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreFormTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreFormTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<RestoreFormTemplateMutation, RestoreFormTemplateMutationVariables>;
export const MoveFormTemplateToFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveFormTemplateToFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFormTemplateToFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<MoveFormTemplateToFolderMutation, MoveFormTemplateToFolderMutationVariables>;
export const GetApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApiKeyFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKeys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimit"}},{"kind":"Field","name":{"kind":"Name","value":"dailyLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimit"}},{"kind":"Field","name":{"kind":"Name","value":"dailyLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<GetApiKeyQuery, GetApiKeyQueryVariables>;
export const CreateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateApiKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimit"}},{"kind":"Field","name":{"kind":"Name","value":"dailyLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawKey"}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const UpdateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateApiKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"rateLimit"}},{"kind":"Field","name":{"kind":"Name","value":"dailyLimit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"usageCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeyId"}}]}}]}}]} as unknown as DocumentNode<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const RevokeApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeyId"}}]}}]}}]} as unknown as DocumentNode<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const GetHiddenOneDriveItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHiddenOneDriveItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiddenOneDriveItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenAt"}}]}}]}}]} as unknown as DocumentNode<GetHiddenOneDriveItemsQuery, GetHiddenOneDriveItemsQueryVariables>;
export const GetHiddenOneDrivePathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHiddenOneDrivePaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiddenOneDrivePaths"}}]}}]} as unknown as DocumentNode<GetHiddenOneDrivePathsQuery, GetHiddenOneDrivePathsQueryVariables>;
export const HideOneDriveItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HideOneDriveItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideOneDriveItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenAt"}}]}}]}}]} as unknown as DocumentNode<HideOneDriveItemMutation, HideOneDriveItemMutationVariables>;
export const UnhideOneDriveItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnhideOneDriveItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unhideOneDriveItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}]}}]} as unknown as DocumentNode<UnhideOneDriveItemMutation, UnhideOneDriveItemMutationVariables>;
export const UnhideAllOneDriveItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnhideAllOneDriveItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unhideAllOneDriveItems"}}]}}]} as unknown as DocumentNode<UnhideAllOneDriveItemsMutation, UnhideAllOneDriveItemsMutationVariables>;
export const CleanupOrphanedHiddenItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CleanupOrphanedHiddenItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validPaths"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cleanupOrphanedHiddenItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validPaths"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validPaths"}}}]}]}}]} as unknown as DocumentNode<CleanupOrphanedHiddenItemsMutation, CleanupOrphanedHiddenItemsMutationVariables>;
export const GetOriginalDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOriginalDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyOriginalDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"syncedAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"md5Hash"}},{"kind":"Field","name":{"kind":"Name","value":"oneDriveItemId"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOriginalDocumentsQuery, GetOriginalDocumentsQueryVariables>;
export const GetOriginalDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOriginalDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueOriginalDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"md5Hash"}},{"kind":"Field","name":{"kind":"Name","value":"oneDriveItemId"}},{"kind":"Field","name":{"kind":"Name","value":"webUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetOriginalDocumentQuery, GetOriginalDocumentQueryVariables>;
export const CountOriginalDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountOriginalDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countOriginalDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}]}}]}}]}]}}]} as unknown as DocumentNode<CountOriginalDocumentsQuery, CountOriginalDocumentsQueryVariables>;
export const GetUserDocumentsForPickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDocumentsForPicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"insensitive","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserDocumentsForPickerQuery, GetUserDocumentsForPickerQueryVariables>;
export const CreateAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateAgentMutation, CreateAgentMutationVariables>;
export const CreateAgentSyncConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAgentSyncConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAgentSyncConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"syncUrls"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"autoUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateAgentSyncConfigMutation, CreateAgentSyncConfigMutationVariables>;
export const UpdateAgentSyncConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgentSyncConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgentSyncConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"syncUrls"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"autoUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateAgentSyncConfigMutation, UpdateAgentSyncConfigMutationVariables>;
export const DeleteAgentSyncConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAgentSyncConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAgentSyncConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAgentSyncConfigMutation, DeleteAgentSyncConfigMutationVariables>;
export const GetAgentSyncConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentSyncConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAgentSyncConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agent"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetFolder"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"StringValue","value":"desc","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"syncUrls"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"autoUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentSyncConfigsQuery, GetAgentSyncConfigsQueryVariables>;
export const RecreateAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecreateAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recreateAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"folderIds"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<RecreateAgentMutation, RecreateAgentMutationVariables>;
export const UpdateAgentConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgentConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateAgentConfigMutation, UpdateAgentConfigMutationVariables>;
export const UpdateAgentFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgentFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgentFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateAgentFoldersMutation, UpdateAgentFoldersMutationVariables>;
export const UpdateAgentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateAgentStatusMutation, UpdateAgentStatusMutationVariables>;
export const GetAllUrlConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllUrlConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllUrlConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"apiClientId"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAllUrlConfigsQuery, GetAllUrlConfigsQueryVariables>;
export const GetUrlConfigDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUrlConfigDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"apiClientId"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUrlConfigDetailsQuery, GetUrlConfigDetailsQueryVariables>;
export const FindUniqueUrlConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueUrlConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"apiClientId"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<FindUniqueUrlConfigQuery, FindUniqueUrlConfigQueryVariables>;
export const GetUrlConfigsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUrlConfigsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUrlConfigsCount"}}]}}]} as unknown as DocumentNode<GetUrlConfigsCountQuery, GetUrlConfigsCountQueryVariables>;
export const GetUrlFoldersForAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUrlFoldersForAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUrlFoldersForAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetUrlFoldersForAgentQuery, GetUrlFoldersForAgentQueryVariables>;
export const CreateUrlConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUrlConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiEndpoint"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"apiEndpoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiEndpoint"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateUrlConfigMutation, CreateUrlConfigMutationVariables>;
export const DeleteOneUrlConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneUrlConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]} as unknown as DocumentNode<DeleteOneUrlConfigMutation, DeleteOneUrlConfigMutationVariables>;
export const ValidateUrlConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateUrlConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiEndpoint"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"apiEndpoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiEndpoint"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"accessible"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ValidateUrlConfigMutation, ValidateUrlConfigMutationVariables>;
export const CreateUrlAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUrlAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createAgentDto"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAgentDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createAgentDto"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createAgentDto"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"agentType"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateUrlAgentMutation, CreateUrlAgentMutationVariables>;
export const CreateUrlAgentSyncConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUrlAgentSyncConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAgentSyncConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"syncUrls"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"autoUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateUrlAgentSyncConfigMutation, CreateUrlAgentSyncConfigMutationVariables>;
export const GetUehArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUehArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkNguon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"markdownContent"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"weaviateId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUehArticlesQuery, GetUehArticlesQueryVariables>;
export const GetUehArticlesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUehArticlesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehArticlesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}]}}]} as unknown as DocumentNode<GetUehArticlesCountQuery, GetUehArticlesCountQueryVariables>;
export const GetAllUehArticlesSourceUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllUehArticlesSourceUrls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}}]}}]} as unknown as DocumentNode<GetAllUehArticlesSourceUrlsQuery, GetAllUehArticlesSourceUrlsQueryVariables>;
export const GetArticlesByAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlesByAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getArticlesByAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkNguon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"}},{"kind":"Field","name":{"kind":"Name","value":"markdownContent"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"weaviateId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetArticlesByAgentQuery, GetArticlesByAgentQueryVariables>;
export const GetChatbotUpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatbotUpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChatbotUpdateStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}]}]}}]} as unknown as DocumentNode<GetChatbotUpdateStatusQuery, GetChatbotUpdateStatusQueryVariables>;
export const GetLastWeekdayDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastWeekdayDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLastWeekdayDate"}}]}}]} as unknown as DocumentNode<GetLastWeekdayDateQuery, GetLastWeekdayDateQueryVariables>;
export const GetRecentUehSyncJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentUehSyncJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecentUehSyncJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<GetRecentUehSyncJobsQuery, GetRecentUehSyncJobsQueryVariables>;
export const GetUehSyncStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUehSyncStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehSyncStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<GetUehSyncStatusQuery, GetUehSyncStatusQueryVariables>;
export const GetUehSyncQueueStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUehSyncQueueStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehSyncQueueStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waiting"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}},{"kind":"Field","name":{"kind":"Name","value":"delayed"}},{"kind":"Field","name":{"kind":"Name","value":"stuck"}}]}}]}}]} as unknown as DocumentNode<GetUehSyncQueueStatsQuery, GetUehSyncQueueStatsQueryVariables>;
export const GetSyncStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSyncStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSyncStatistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSyncs"}},{"kind":"Field","name":{"kind":"Name","value":"successfulSyncs"}},{"kind":"Field","name":{"kind":"Name","value":"failedSyncs"}},{"kind":"Field","name":{"kind":"Name","value":"totalArticlesProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"totalArticlesAdded"}},{"kind":"Field","name":{"kind":"Name","value":"totalArticlesUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"totalArticlesDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"averageSyncDuration"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"syncsByDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<GetSyncStatisticsQuery, GetSyncStatisticsQueryVariables>;
export const StartUehSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSync"}}]}}]} as unknown as DocumentNode<StartUehSyncMutation, StartUehSyncMutationVariables>;
export const StartUehSyncJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSyncJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSyncJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}]}]}}]} as unknown as DocumentNode<StartUehSyncJobMutation, StartUehSyncJobMutationVariables>;
export const CancelUehSyncJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelUehSyncJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelUehSyncJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}]}}]} as unknown as DocumentNode<CancelUehSyncJobMutation, CancelUehSyncJobMutationVariables>;
export const InitializeDefaultUehConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitializeDefaultUehConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initializeDefaultUehConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"folderName"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<InitializeDefaultUehConfigMutation, InitializeDefaultUehConfigMutationVariables>;
export const ExportArticlesToDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportArticlesToDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlConfigId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportArticlesToDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urlConfigId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlConfigId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"documentsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"documentsUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"documentsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"totalProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ExportArticlesToDocumentsMutation, ExportArticlesToDocumentsMutationVariables>;
export const GetSuggestedSyncDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuggestedSyncDates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSuggestedSyncDates"}}]}}]} as unknown as DocumentNode<GetSuggestedSyncDatesQuery, GetSuggestedSyncDatesQueryVariables>;
export const GetSyncableUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSyncableUrls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSyncableUrls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GetSyncableUrlsQuery, GetSyncableUrlsQueryVariables>;
export const GetMultiUrlSyncStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMultiUrlSyncStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUehSyncStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<GetMultiUrlSyncStatusQuery, GetMultiUrlSyncStatusQueryVariables>;
export const ValidateSyncUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateSyncUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateSyncUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urls"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"accessible"}},{"kind":"Field","name":{"kind":"Name","value":"responseTime"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ValidateSyncUrlsQuery, ValidateSyncUrlsQueryVariables>;
export const SyncUrlConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncUrlConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncUrlConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"articlesCount"}},{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"syncDate"}}]}}]}}]} as unknown as DocumentNode<SyncUrlConfigMutation, SyncUrlConfigMutationVariables>;
export const SyncUrlConfigForDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncUrlConfigForDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncUrlConfigForDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"articlesCount"}},{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"syncDate"}}]}}]}}]} as unknown as DocumentNode<SyncUrlConfigForDateMutation, SyncUrlConfigForDateMutationVariables>;
export const SyncUrlConfigDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncUrlConfigDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncUrlConfigDateRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"totalArticles"}},{"kind":"Field","name":{"kind":"Name","value":"totalNew"}},{"kind":"Field","name":{"kind":"Name","value":"totalUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"syncedDates"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SyncUrlConfigDateRangeMutation, SyncUrlConfigDateRangeMutationVariables>;
export const SyncMultipleUrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncMultipleUrls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayUrls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncMultipleUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayUrls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayUrls"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"articlesCount"}},{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SyncMultipleUrlsMutation, SyncMultipleUrlsMutationVariables>;
export const StartUehSyncForDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSyncForDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSyncForDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}]}}]} as unknown as DocumentNode<StartUehSyncForDateMutation, StartUehSyncForDateMutationVariables>;
export const StartUehSyncForDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSyncForDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSyncForDateRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}]}}]} as unknown as DocumentNode<StartUehSyncForDateRangeMutation, StartUehSyncForDateRangeMutationVariables>;
export const StartUehSyncJobForDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSyncJobForDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSyncJobForDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}]}]}}]} as unknown as DocumentNode<StartUehSyncJobForDateMutation, StartUehSyncJobForDateMutationVariables>;
export const StartUehSyncJobForDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartUehSyncJobForDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startUehSyncJobForDateRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}]}]}}]} as unknown as DocumentNode<StartUehSyncJobForDateRangeMutation, StartUehSyncJobForDateRangeMutationVariables>;
export const StartConnectionTestJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartConnectionTestJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startConnectionTestJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}]}]}}]} as unknown as DocumentNode<StartConnectionTestJobMutation, StartConnectionTestJobMutationVariables>;
export const StartMultiUrlSyncJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartMultiUrlSyncJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startMultiUrlSyncJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urls"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}]}]}}]} as unknown as DocumentNode<StartMultiUrlSyncJobMutation, StartMultiUrlSyncJobMutationVariables>;
export const SyncAndUpdateAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncAndUpdateAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"syncUrls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncAndUpdateAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"syncUrls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"syncUrls"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetDate"}}}]}]}}]} as unknown as DocumentNode<SyncAndUpdateAgentMutation, SyncAndUpdateAgentMutationVariables>;
export const UpdateAgentsWithSyncedDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgentsWithSyncedData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urls"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgentsWithSyncedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"urls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urls"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"exportResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"documentsCreated"}},{"kind":"Field","name":{"kind":"Name","value":"documentsUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"documentsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"totalProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<UpdateAgentsWithSyncedDataMutation, UpdateAgentsWithSyncedDataMutationVariables>;
export const UpdateChatRoomNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChatRoomName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChatRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatRoomId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateChatRoomNameMutation, UpdateChatRoomNameMutationVariables>;
export const FindTaskByTaskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTaskByTaskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTaskByTaskId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"taskType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"progressMessage"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorData"}}]}}]}}]} as unknown as DocumentNode<FindTaskByTaskIdQuery, FindTaskByTaskIdQueryVariables>;
export const FindTasksByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTasksByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTasksByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"taskType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"progressMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<FindTasksByUserQuery, FindTasksByUserQueryVariables>;